import type { Namespace } from '@govard/i18n-core';

export const featuresRu: Namespace = {
  'features.task_detail.complete': 'Отметить выполненной',
  'features.task_detail.reopen': 'Вернуть в работу',
  'features.task_detail.add_note': 'Добавить заметку',
  'features.task_detail.action_error': 'Не удалось выполнить действие',
  'features.task_detail.status': 'Статус',
  'features.task_detail.row_status': 'Статус задачи «{title}»',
  'features.task_detail.priority': 'Приоритет',
  'features.task_detail.unassigned': 'Не назначен',
  'features.task_detail.links': 'Связи',
  'features.task_detail.author': 'Автор',
  'features.task_detail.updated': 'Обновлена',
  'features.task_detail.completed': 'Выполнена',
  'features.task_detail.related': 'Связанные задачи',
  'features.task_detail.last_notes': 'Последние заметки',
  'features.task_detail.last_activity': 'Последние активности',
  'features.task_detail.group_by': 'Группировка',
  'features.task_detail.count': { one: 'задача', few: 'задачи', many: 'задач', other: 'задачи' },
  'features.columns.company': 'Компания',
  'features.columns.industry': 'Отрасль',
  'features.columns.contacts': 'Контакты',
  'features.columns.deals': 'Сделки',
  'features.columns.tasks': 'Задачи',
  'features.columns.created_at': 'Дата создания',
  'features.columns.title': 'Название',
  'features.columns.type': 'Тип',
  'features.columns.status': 'Статус',
  'features.columns.amount': 'Сумма',
  'features.columns.client_deal': 'Клиент / Сделка',
  'features.columns.template': 'Шаблон',
  'features.columns.channel': 'Канал',
  'features.columns.variables': 'Переменные',
  'features.columns.usage_count': 'Использований',
  'features.columns.note': 'Заметка',
  'features.columns.links': 'Привязки',
  'features.columns.author': 'Автор',
  'features.columns.priority': 'Приоритет',
  'features.columns.due_at': 'Срок',
  'features.columns.assignee': 'Исполнитель',
  'features.columns.deal': 'Сделка',
  'features.columns.contact': 'Контакт',
  'features.task.status.todo': 'К выполнению',
  'features.task.status.in_progress': 'В работе',
  'features.task.status.blocked': 'Заблокирована',
  'features.task.status.done': 'Выполнена',
  'features.task.status.cancelled': 'Отменена',
  'features.task.priority.low': 'Низкий',
  'features.task.priority.medium': 'Средний',
  'features.task.priority.high': 'Высокий',
  'features.task.priority.urgent': 'Срочно',

  // Project statuses (roadmap F3-4).
  'features.project.status.planned': 'Запланирован',
  'features.project.status.active': 'В работе',
  'features.project.status.on_hold': 'Приостановлен',
  'features.project.status.completed': 'Завершён',
  'features.project.status.cancelled': 'Отменён',
  'features.meeting.status.scheduled': 'Запланирована',
  'features.meeting.status.completed': 'Прошла',
  'features.meeting.status.cancelled': 'Отменена',
  'features.document.type.contract': 'Договор',
  'features.document.type.invoice': 'Счёт',
  'features.document.type.act': 'Акт',
  'features.document.status.draft': 'Черновик',
  'features.document.status.sent': 'Отправлен',
  'features.document.status.signed': 'Подписан',
  'features.document.status.cancelled': 'Отменён',
  'features.features.activity.components.entityhistorybutton.история': 'История',
  'features.features.activity.components.entityhistorybutton.история_2': 'История',
  'features.features.activity.components.entityhistorybutton.не_удалось_загрузить_историю':
    'Не удалось загрузить историю',
  'features.features.activity.components.entityhistorybutton.событий_пока_нет': 'Событий пока нет',
  'features.features.activity.lib.describeactivity.запись': 'запись',
  'features.features.activity.lib.describeactivity.срок_прошел': 'Срок прошёл',
  'features.features.ai.chat.components.agentcapabilitiescard.nedostupno': 'Недоступно',
  'features.features.ai.chat.components.agentcapabilitiescard.s_podtverzhdeniem':
    'С подтверждением',
  'features.features.ai.chat.components.agentcapabilitiescard.agentnaya_logika': 'Агентная логика',
  'features.features.ai.chat.components.agentcapabilitiescard.zhivoy_katalog_tools_iz_backend_chtenie_vypo':
    'Живой каталог tools из backend: чтение выполняется сразу, действия идут через подтверждение.',
  'features.features.ai.chat.components.agentcapabilitiescard.dlya_tekushchikh_prav_net_dostupnykh_agent_tools':
    'Для текущих прав нет доступных agent tools.',
  'features.features.ai.chat.components.antdesignxchatsurface.vyzov_instrumenta':
    'Вызов инструмента',
  'features.features.ai.chat.components.antdesignxchatsurface.istochniki': 'Источники',
  'features.features.ai.chat.components.antdesignxchatsurface.otvet_formiruetsya':
    'Ответ формируется',
  'features.features.ai.chat.components.antdesignxchatsurface.ostanovit': 'Остановить',
  'features.features.ai.chat.components.antdesignxchatsurface.povtorit': 'Повторить',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_slishkom_bolshoy_dlya_bezopasnogo_rende':
    'Блок слишком большой для безопасного рендера.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.json_slishkom_glubokiy_dlya_bezopasnogo_rend':
    'JSON слишком глубокий для безопасного рендера.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.json_soderzhit_slishkom_mnogo_uzlov_dlya_bezo':
    'JSON содержит слишком много узлов для безопасного рендера.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_soderzhit_nebezopasnye_ssylki_ili_call':
    'Блок содержит небезопасные ссылки или callbacks.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.render_mermaid_prevysil_bezopasnyy_limit_v':
    'Рендер Mermaid превысил безопасный лимит времени.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.mermaid_ne_smog_bezopasno_otrenderit_diag':
    'Mermaid не смог безопасно отрендерить диаграмму.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_ne_raspoznan_kak_bezopasnyy_format':
    'Блок не распознан как безопасный формат.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.soobshchenie_slishkom_bolshoe_dlya_bezopasnogo_':
    'Сообщение слишком большое для безопасного Markdown-рендера.',
  'features.features.ai.chat.components.chatpanel.izmenit_vysotu_ai_chata':
    'Изменить высоту AI-чата',
  'features.features.ai.chat.components.chatpanel.potyanite_chtoby_izmenit_vysotu_chata':
    'Потяните, чтобы изменить высоту чата',
  'features.features.ai.chat.components.chatpanel.ne_udalos_izmenit_ai_shlyuz':
    'Не удалось изменить AI-шлюз',
  'features.features.ai.chat.components.chatpanel.ne_udalos_izmenit_ai_shlyuz_2':
    'Не удалось изменить AI-шлюз',
  'features.features.ai.chat.components.conversationswitcher.dialog': 'Диалог',
  'features.features.ai.chat.components.conversationswitcher.vybrat': 'Выбрать',
  'features.features.ai.chat.components.conversationswitcher.perepiska_udalitsya_bezvozvratno':
    'Переписка удалится безвозвратно.',
  'features.features.ai.chat.components.conversationswitcher.udalit': 'Удалить',
  'features.features.ai.chat.components.conversationswitcher.otmena': 'Отмена',
  'features.features.ai.chat.components.conversationswitcher.ne_udalos_udalit_dialogi':
    'Не удалось удалить диалоги',
  'features.features.ai.chat.components.conversationswitcher.otmena_2': 'Отмена',
  'features.features.ai.chat.components.conversationswitcher.vybor_dialogov_na_udalenie':
    'Выбор диалогов на удаление',
  'features.features.ai.chat.components.conversationswitcher.dialog_2': 'Диалог',
  'features.features.ai.chat.components.conversationswitcher.novyy_dialog': 'Новый диалог',
  'features.features.ai.chat.components.dealchatcrudactions.verni_confirmation_card_i_ne_sokhranyay_zame':
    'Верни confirmation card и не сохраняй заметку без подтверждения пользователя.',
  'features.features.ai.chat.components.dealchatcrudactions.verni_approval_card_i_ne_menyay_stadiyu_bez_':
    'Верни approval card и не меняй стадию без подтверждения пользователя.',
  'features.features.ai.chat.components.gatewayprofileselector.marshrut_modeli_zakreplen_za_tekushchim_dialog':
    'Маршрут модели закреплён за текущим диалогом',
  'features.features.ai.chat.components.gatewayprofileselector.ai_shlyuz': 'AI-шлюз',
  'features.features.ai.chat.components.openroutermodelselector.model_sokhranyaetsya_tolko_v_etom_brauzere':
    'Модель сохраняется только в этом браузере',
  'features.features.ai.chat.components.openroutermodelselector.model_openrouter':
    'Модель OpenRouter',
  'features.features.ai.chat.components.reasoningmodeswitch.model_obdumyvaet_otvet_pered_tem_kak_ego_':
    'Модель обдумывает ответ перед тем, как его дать: точнее с инструментами, но медленнее — размышление не показывается и выглядит как пауза',
  'features.features.ai.chat.components.reasoningmodeswitch.model_otvechaet_srazu_bez_razmyshleniya_byst':
    'Модель отвечает сразу, без размышления: быстрее в разы, но на многошаговых вопросах может ошибаться в выборе инструментов',
  'features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie_modeli':
    'Размышление модели',
  'features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie': 'Размышление',
  'features.features.ai.chat.components.reasoningmodeswitch.vkl': 'вкл',
  'features.features.ai.chat.components.reasoningmodeswitch.vykl': 'выкл',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.dobavit_zametku':
    'Добавить заметку?',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.sdelka': 'Сделка',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.zametka_dobavlena':
    'Заметка добавлена',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.ne_udalos_dobavit_zametku_poprobuyte_eshche':
    'Действие завершилось ошибкой. Заметка не добавлена.',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.rezultat_proveryaetsya':
    'Результат проверяется',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.podtverzhdenie_sokhraneno_rezultat_proveryaetsya':
    'Подтверждение сохранено. Результат выполнения проверяется.',
  'features.features.ai.chat.components.snippets.dealactionplansnippet.vybrano': 'Выбрано:',
  'features.features.ai.chat.components.snippets.dealactionplansnippet.iz': 'из',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.podgotovka_k_razgovoru':
    'Подготовка к разговору',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.otkrytye_zadachi':
    'Открытые задачи',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.poslednie_zametki':
    'Последние заметки',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.chto_sprosit_klientu':
    'Что спросить клиенту',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.eto_tolko_podgotovka_dannye_crm_ne_izmenya':
    'Это только подготовка. Данные CRM не изменялись.',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.nizkiy': 'Низкий',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.sredniy': 'Средний',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.vysokiy': 'Высокий',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.srochnyy': 'Срочный',
  'features.features.ai.chat.components.snippets.dealrisksnippet.naydeno_signalov':
    'Найдено сигналов',
  'features.features.ai.chat.components.snippets.dealsummarysnippet.sobytiya': 'События',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.chto_trebuet_vnimaniya_segodnya':
    'Что требует внимания сегодня?',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.obzor_na_segodnya':
    'Обзор на сегодня',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.goryachie_sdelki':
    'Горячие сделки',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prosrochennye_zadachi':
    'Просроченные задачи',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.sdelki_s_riskom':
    'Сделки с риском',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.srochnykh_signalov_na_segodnya_ne_naydeno':
    'Срочных сигналов на сегодня не найдено.',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.goryachie_sdelki_2':
    'Горячие сделки',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prosrochennye_zadachi_2':
    'Просроченные задачи',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.sdelki_s_riskom_2':
    'Сделки с риском',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prioritety': 'Приоритеты',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.eto_tolko_obzor_sdelki_zadachi_i_pisma_ne':
    'Это только обзор. Сделки, задачи и письма не были изменены.',
  'features.features.ai.chat.components.snippets.memorysnippet.pamyat': 'Память',
  'features.features.ai.chat.components.snippets.viewsnippet.zakrepit': 'Закрепить',
  'features.features.ai.chat.components.snippets.viewsnippet.otkryt_zakreplennoe_predstavlenie':
    'Открыть закреплённое представление',
  'features.features.ai.chat.components.snippets.viewsnippet.otkryt_na_dasborde':
    'Открыть на дашборде',
  'features.features.ai.chat.components.snippets.viewsnippet.po_zapisannym_primeram':
    'по записанным примерам',
  'features.features.ai.chat.hooks.useentitychat.ne_udalos_poluchit_otvet_ot_llm_provayder':
    'Не удалось получить ответ от LLM-провайдера. Попробуйте ещё раз.',
  'features.features.approvals.lib.approvalsummary.удалить_контакт': 'Удалить контакт',
  'features.features.approvals.lib.approvalsummary.удалить_сделку': 'Удалить сделку',
  'features.features.approvals.lib.approvalsummary.сценарий': 'Сценарий',
  'features.features.approvals.lib.approvalsummary.шаг': 'Шаг',
  'features.features.approvals.lib.approvalsummary.выполнить_шаг_сценария':
    'Выполнить шаг сценария',
  'features.features.approvals.lib.approvalsummary.новая_стадия': 'Новая стадия',
  'features.features.approvals.lib.approvalsummary.причина': 'Причина',
  'features.features.approvals.lib.approvalsummary.сменить_стадию_сделки': 'Сменить стадию сделки',
  'features.features.approvals.lib.approvalsummary.дополнить_данные_контакта':
    'Дополнить данные контакта',
  'features.features.approvals.lib.approvalsummary.кому': 'Кому',
  'features.features.approvals.lib.approvalsummary.тема': 'Тема',
  'features.features.approvals.lib.approvalsummary.текст': 'Текст',
  'features.features.approvals.lib.approvalsummary.отправить_письмо': 'Отправить письмо',
  'features.features.approvals.lib.approvalsummary.сценарий_2': 'Сценарий',
  'features.features.approvals.lib.approvalsummary.запустить_сценарий': 'Запустить сценарий',
  'features.features.approvals.lib.approvalsummary.уровень': 'Уровень',
  'features.features.approvals.lib.approvalsummary.ключ': 'Ключ',
  'features.features.approvals.lib.approvalsummary.значение': 'Значение',
  'features.features.approvals.lib.approvalsummary.записать_в_память': 'Записать в память',
  'features.features.approvals.pages.approvalspage.действие': 'Действие',
  'features.features.approvals.pages.approvalspage.объект': 'Объект',
  'features.features.approvals.pages.approvalspage.создано': 'Создано',
  'features.features.approvals.pages.approvalspage.истекает': 'Истекает',
  'features.features.approvals.pages.approvalspage.срок_подтверждения_истек':
    'Срок подтверждения истёк',
  'features.features.approvals.pages.approvalspage.статус': 'Статус',
  'features.features.approvals.pages.approvalspage.действия': 'Действия',
  'features.features.approvals.pages.approvalspage.подтвердить': 'Подтвердить',
  'features.features.approvals.pages.approvalspage.выполнить_действие': 'Выполнить действие?',
  'features.features.approvals.pages.approvalspage.выполнить': 'Выполнить',
  'features.features.approvals.pages.approvalspage.отмена': 'Отмена',
  'features.features.approvals.pages.approvalspage.подтвердить_2': 'Подтвердить',
  'features.features.approvals.pages.approvalspage.отклонить': 'Отклонить',
  'features.features.approvals.pages.approvalspage.отклонить_запрос': 'Отклонить запрос?',
  'features.features.approvals.pages.approvalspage.отклонить_2': 'Отклонить',
  'features.features.approvals.pages.approvalspage.отмена_2': 'Отмена',
  'features.features.approvals.pages.approvalspage.отклонить_3': 'Отклонить',
  'features.features.approvals.pages.approvalspage.подтверждения': 'Подтверждения',
  'features.features.approvals.pages.approvalspage.действия_ассистента_которые_не_выполняются':
    'Действия ассистента, которые не выполняются без вашего решения.',
  'features.features.approvals.pages.approvalspage.обновить': 'Обновить',
  'features.features.approvals.pages.approvalspage.обновить_2': 'Обновить',
  'features.features.approvals.pages.approvalspage.фильтр_по_статусу': 'Фильтр по статусу',
  'features.features.approvals.pages.approvalspage.не_удалось_применить_решение':
    'Не удалось применить решение',
  'features.features.approvals.pages.approvalspage.действие_не_выполнено': 'Действие не выполнено',
  'features.features.approvals.pages.approvalspage.подтверждение_сохранено_но_исполнение_завершилось_ошибкой':
    'Подтверждение сохранено, но выполнение завершилось ошибкой. Повторного запуска не было.',
  'features.features.approvals.pages.approvalspage.не_удалось_загрузить_подтверждения':
    'Не удалось загрузить подтверждения',
  'features.features.approvals.pages.approvalspage.нет_запросов_ожидающих_решения':
    'Нет запросов, ожидающих решения',
  'features.features.approvals.pages.approvalspage.записей_нет': 'Записей нет',
  'features.features.attachments.api.attachments.client.не_удалось_загрузить_файл':
    'Не удалось загрузить файл',
  'features.features.attachments.components.entityattachmentspanel.файлы': 'Файлы',
  'features.features.attachments.components.entityattachmentspanel.не_удалось_открыть_файл':
    'Не удалось открыть файл',
  'features.features.attachments.components.entityattachmentspanel.загрузить_файл':
    'Загрузить файл',
  'features.features.attachments.components.entityattachmentspanel.ошибка_операции_с_файлом':
    'Ошибка операции с файлом',
  'features.features.attachments.components.entityattachmentspanel.не_удалось_загрузить_файлы':
    'Не удалось загрузить файлы',
  'features.features.attachments.components.entityattachmentspanel.файлов_пока_нет':
    'Файлов пока нет',
  'features.features.attachments.components.entityattachmentspanel.удалить_файл': 'Удалить файл',
  'features.features.attachments.components.entityattachmentspanel.удалить_файл_2': 'Удалить файл?',
  'features.features.attachments.components.entityattachmentspanel.файл_пропадет_из_карточки_запись_об_этом_о':
    'Файл пропадёт из карточки; запись об этом останется в истории.',
  'features.features.companies.components.companyformmodal.редактировать_компанию':
    'Редактировать компанию',
  'features.features.companies.components.companyformmodal.новая_компания': 'Новая компания',
  'features.features.companies.components.companyformmodal.сохранить': 'Сохранить',
  'features.features.companies.components.companyformmodal.создать': 'Создать',
  'features.features.companies.components.companyformmodal.отмена': 'Отмена',
  'features.features.companies.components.companyformmodal.не_удалось_сохранить_компанию':
    'Не удалось сохранить компанию',
  'features.features.companies.components.companyformmodal.название': 'Название',
  'features.features.companies.components.companyformmodal.введите_название_компании':
    'Введите название компании',
  'features.features.companies.components.companyformmodal.ооо_ромашка': 'ООО «Ромашка»',
  'features.features.companies.components.companyformmodal.отрасль': 'Отрасль',
  'features.features.companies.components.companyformmodal.услуги_ритейл': 'Услуги, ритейл…',
  'features.features.companies.components.companyformmodal.телефон': 'Телефон',
  'features.features.companies.components.companyformmodal.домен': 'Домен',
  'features.features.companies.components.companyformmodal.сайт': 'Сайт',
  'features.features.companies.components.companyformmodal.описание': 'Описание',
  'features.features.companies.components.companyformmodal.чем_занимается_компания':
    'Чем занимается компания',
  'features.features.companies.pages.companiespage.компания': 'Компания',
  'features.features.companies.pages.companiespage.отрасль': 'Отрасль',
  'features.features.companies.pages.companiespage.контакты': 'Контакты',
  'features.features.companies.pages.companiespage.сделки': 'Сделки',
  'features.features.companies.pages.companiespage.задачи': 'Задачи',
  'features.features.companies.pages.companiespage.дата_создания': 'Дата создания',
  'features.features.companies.pages.companiespage.действия': 'Действия',
  'features.features.companies.pages.companiespage.редактировать': 'Редактировать',
  'features.features.companies.pages.companiespage.история_компании': 'История компании',
  'features.features.companies.pages.companiespage.удалить_компанию': 'Удалить компанию',
  'features.features.companies.pages.companiespage.удалить_компанию_2': 'Удалить компанию?',
  'features.features.companies.pages.companiespage.контакты_сделки_и_задачи_останутся_но_поте':
    'Контакты, сделки и задачи останутся, но потеряют привязку к компании.',
  'features.features.companies.pages.companiespage.компании': 'Компании',
  'features.features.companies.pages.companiespage.компания_хаб_к_ней_привязываются_контакты_':
    'Компания — хаб: к ней привязываются контакты, задачи и сделки.',
  'features.features.companies.pages.companiespage.новая_компания': 'Новая компания',
  'features.companies_list.search_label': 'Поиск компаний',
  'features.companies_list.select_row': 'Выбрать компанию {name}',
  'features.companies_list.empty_filtered': 'Нет компаний по текущим фильтрам',
  'features.features.companies.pages.companiespage.поиск_по_названию_или_отрасли':
    'Поиск по названию или отрасли…',
  'features.features.companies.pages.companiespage.не_удалось_загрузить_компании':
    'Не удалось загрузить компании',
  'features.features.companies.pages.companiespage.компаний_пока_нет': 'Компаний пока нет',
  'features.features.companies.pages.companydetailpage.компания_не_найдена': 'Компания не найдена',
  'features.features.companies.pages.companydetailpage.к_компании_пока_не_привязан_ни_один_контак':
    'К компании пока не привязан ни один контакт',
  'features.features.companies.pages.companydetailpage.у_компании_и_ее_контактов_пока_нет_сделок':
    'У компании и её контактов пока нет сделок',
  'features.features.companies.pages.companydetailpage.к_компаниям': 'К компаниям',
  'features.features.companies.pages.companydetailpage.удалить': 'Удалить',
  'features.features.companies.pages.companydetailpage.удалить_компанию': 'Удалить компанию?',
  'features.features.companies.pages.companydetailpage.связанные_контакты_сделки_задачи_и_докумен':
    'Связанные контакты, сделки, задачи и документы останутся, но потеряют привязку к этой компании.',
  'features.company_detail.summary': 'Сводка',
  'features.company_detail.details': 'Детали',
  'features.company_detail.contacts': 'Контакты',
  'features.company_detail.open_deals': 'Открытые сделки',
  'features.company_detail.activity': 'Активность',
  'features.company_detail.tasks': 'Задачи',
  'features.company_detail.tasks_hint':
    'Открыто / просрочено. Включая задачи контактов, сделок и документов компании',
  'features.company_detail.updated': 'Обновлено',
  'features.company_detail.industry': 'Отрасль',
  'features.company_detail.domain': 'Домен',
  'features.company_detail.website': 'Сайт',
  'features.company_detail.phone': 'Телефон',
  'features.company_detail.description': 'Описание',
  'features.company_detail.all': 'Все →',
  'features.company_detail.open_tasks': 'Открытые задачи ({count})',
  'features.company_detail.recent_notes': 'Последние заметки',
  'features.company_detail.empty_open_deals': 'Открытых сделок нет',
  'features.company_detail.empty_open_tasks': 'Открытых задач нет',
  'features.company_detail.deals_count': 'Сделки: {count}',
  'features.company_detail.next_contact_at': 'Следующий контакт: {date}',
  'features.company_detail.search_contacts': 'Поиск по имени',
  'features.company_detail.sort_name': 'По имени',
  'features.company_detail.sort_direction': 'Порядок сортировки',
  'features.company_detail.sort_ascend': 'По возрастанию',
  'features.company_detail.sort_descend': 'По убыванию',
  'features.company_detail.sort_original': 'Исходный порядок',
  'features.company_detail.sort_created': 'По дате создания',
  'features.company_detail.sort_deals': 'По числу сделок',
  'features.company_detail.sort_next_contact': 'По следующему контакту',
  'features.company_detail.history_all': 'Все',
  'features.company_detail.history_deals': 'Сделки',
  'features.company_detail.history_contacts': 'Контакты',
  'features.company_detail.history_tasks': 'Задачи',
  'features.company_detail.history_notes': 'Заметки',
  'features.company_detail.event_company': 'Компания',
  'features.company_detail.event_deal': 'Сделка',
  'features.company_detail.event_contact': 'Контакт',
  'features.company_detail.event_task': 'Задача',
  'features.company_detail.event_note': 'Заметка',
  'features.company_detail.event_meeting': 'Встреча',
  'features.company_detail.event_document': 'Документ',
  'features.company_detail.event_file': 'Файл',
  'features.company_detail.event_other': 'Активность',
  'features.company_detail.retry': 'Повторить',
  'features.features.contacts.components.contactformmodal.редактировать_контакт':
    'Редактировать контакт',
  'features.features.contacts.components.contactformmodal.сохранить': 'Сохранить',
  'features.features.contacts.components.contactformmodal.отмена': 'Отмена',
  'features.features.contacts.components.contactformmodal.не_удалось_сохранить_контакт':
    'Не удалось сохранить контакт',
  'features.features.contacts.components.contactformmodal.не_удалось_создать_контакт':
    'Не удалось создать контакт',
  'features.features.contacts.components.contactformmodal.введите_имя': 'Введите имя',
  'features.features.contacts.components.contactformmodal.иван': 'Иван',
  'features.features.contacts.components.contactformmodal.петров': 'Петров',
  'features.features.contacts.components.contactformmodal.похоже_это_не_email':
    'Похоже, это не email',
  'features.features.contacts.components.contactformmodal.компания': 'Компания',
  'features.features.contacts.components.contactformmodal.без_компании': 'Без компании',
  'features.features.contacts.components.contactinteractionspanel.история_взаимодействий':
    'История взаимодействий',
  'features.features.contacts.components.contactinteractionspanel.тип': 'Тип',
  'features.features.contacts.components.contactinteractionspanel.тема': 'Тема',
  'features.features.contacts.components.contactinteractionspanel.канал': 'Канал',
  'features.features.contacts.components.contactinteractionspanel.когда': 'Когда',
  'features.features.contacts.components.contactinteractionspanel.действия': 'Действия',
  'features.features.contacts.components.contactinteractionspanel.редактировать': 'Редактировать',
  'features.features.contacts.components.contactinteractionspanel.редактировать_взаимодействие':
    'Редактировать взаимодействие',
  'features.features.contacts.components.contactinteractionspanel.удалить_запись': 'Удалить запись',
  'features.features.contacts.components.contactinteractionspanel.удалить_запись_2':
    'Удалить запись?',
  'features.features.contacts.components.contactinteractionspanel.запись_пропадет_из_журнала_в_истории_конта':
    'Запись пропадёт из журнала; в истории контакта останется след об удалении.',
  'features.features.contacts.components.contactinteractionspanel.записать': 'Записать',
  'features.features.contacts.components.contactinteractionspanel.не_удалось_загрузить_взаимодействия':
    'Не удалось загрузить взаимодействия',
  'features.features.contacts.components.contactinteractionspanel.пока_ничего_не_записано':
    'Пока ничего не записано',
  'features.features.contacts.components.contactinteractionspanel.редактировать_взаимодействие_2':
    'Редактировать взаимодействие',
  'features.features.contacts.components.contactinteractionspanel.записать_состоявшееся_взаимодействие':
    'Записать состоявшееся взаимодействие',
  'features.features.contacts.components.contactinteractionspanel.сохранить': 'Сохранить',
  'features.features.contacts.components.contactinteractionspanel.отмена': 'Отмена',
  'features.features.contacts.components.contactinteractionspanel.не_удалось_сохранить':
    'Не удалось сохранить',
  'features.features.contacts.components.contactinteractionspanel.тип_2': 'Тип',
  'features.features.contacts.components.contactinteractionspanel.выберите_тип': 'Выберите тип',
  'features.features.contacts.components.contactinteractionspanel.фиксируется_уже_состоявшееся_общение_назна':
    'Фиксируется уже состоявшееся общение. Назначить встречу с участниками и приглашением — во вкладке «Встречи».',
  'features.features.contacts.components.contactinteractionspanel.тема_2': 'Тема',
  'features.features.contacts.components.contactinteractionspanel.обсудили_условия':
    'Обсудили условия',
  'features.features.contacts.components.contactinteractionspanel.детали': 'Детали',
  'features.features.contacts.components.contactinteractionspanel.канал_2': 'Канал',
  'features.features.contacts.components.contactinteractionspanel.телефон_whatsapp_почта':
    'Телефон, WhatsApp, почта…',
  'features.features.contacts.components.contactinteractionspanel.когда_2': 'Когда',
  'features.features.contacts.pages.contactdetailpage.загрузка_контакта': 'Загрузка контакта...',
  'features.features.contacts.pages.contactdetailpage.контакт_не_найден': 'Контакт не найден',
  'features.features.contacts.pages.contactdetailpage.попробуйте_открыть_карточку_еще_раз':
    'Попробуйте открыть карточку ещё раз.',
  'features.features.contacts.pages.contactdetailpage.повторить': 'Повторить',
  'features.features.contacts.pages.contactdetailpage.информация': 'Информация',
  'features.features.contacts.pages.contactdetailpage.контактная_информация':
    'Контактная информация',
  'features.features.contacts.pages.contactdetailpage.источник': 'Источник',
  'features.features.contacts.pages.contactdetailpage.не_указан': 'Не указан',
  'features.features.contacts.pages.contactdetailpage.компания': 'Компания',
  'features.features.contacts.pages.contactdetailpage.частное_лицо_без_компании':
    'Частное лицо (без компании)',
  'features.features.contacts.pages.contactdetailpage.открыть_карточку_компании':
    'Открыть карточку компании →',
  'features.features.contacts.pages.contactdetailpage.контакт_числится_частным_лицом':
    'Контакт числится частным лицом',
  'features.features.contacts.pages.contactdetailpage.теги': 'Теги',
  'features.features.contacts.pages.contactdetailpage.нет_тегов': 'Нет тегов',
  'features.features.contacts.pages.contactdetailpage.заметки': 'Заметки',
  'features.features.contacts.pages.contactdetailpage.заметок_пока_нет': 'Заметок пока нет.',
  'features.features.contacts.pages.contactdetailpage.сделки_контакта': 'Сделки контакта',
  'features.features.contacts.pages.contactdetailpage.нет_привязанных_сделок':
    'Нет привязанных сделок.',
  'features.features.contacts.pages.contactdetailpage.сделка': 'Сделка',
  'features.features.contacts.pages.contactdetailpage.стадия': 'Стадия',
  'features.features.contacts.pages.contactdetailpage.сумма': 'Сумма',
  'features.features.contacts.pages.contactdetailpage.заметки_по_контакту': 'Заметки по контакту',
  'features.features.contacts.pages.contactdetailpage.задачи_контакта': 'Задачи контакта',
  'features.features.contacts.pages.contactdetailpage.встречи_с_контактом': 'Встречи с контактом',
  'features.features.contacts.pages.contactdetailpage.документы_контакта': 'Документы контакта',
  'features.features.contacts.pages.contactdetailpage.файлы': 'Файлы',
  'features.features.contacts.pages.contactdetailpage.история_взаимодействий':
    'История взаимодействий',
  'features.features.contacts.pages.contactdetailpage.история_взаимодействий_2':
    'История взаимодействий',
  'features.features.contacts.pages.contactdetailpage.к_контактам': 'К контактам',
  'features.features.contacts.pages.contactdetailpage.к_контактам_2': 'К контактам',
  'features.features.contacts.pages.contactdetailpage.канал_связи_не_указан':
    'Канал связи не указан',
  'features.features.contacts.pages.contactdetailpage.написать': 'Написать',
  'features.features.contacts.pages.contactdetailpage.позвонить': 'Позвонить',
  'features.features.contacts.pages.contactdetailpage.редактировать': 'Редактировать',
  'features.features.contacts.pages.contactdetailpage.история_контакта': 'История контакта',
  'features.features.contacts.pages.contactdetailpage.удалить_контакт': 'Удалить контакт',
  'features.features.contacts.pages.contactdetailpage.удалить_контакт_2': 'Удалить контакт?',
  'features.features.contacts.pages.contactdetailpage.сделки_задачи_и_заметки_контакта_останутся':
    'Сделки, задачи и заметки контакта останутся, но потеряют привязку.',
  'features.features.contacts.pages.contactdetailpage.активные_сделки': 'Активные сделки',
  'features.features.contacts.pages.contactdetailpage.последняя_активность': 'Последняя активность',
  'features.features.contacts.pages.contactspage.контакт': 'Контакт',
  'features.features.contacts.pages.contactspage.компания': 'Компания',
  'features.features.contacts.pages.contactspage.частное_лицо': 'Частное лицо',
  'features.features.contacts.pages.contactspage.сделки': 'Сделки',
  'features.features.contacts.pages.contactspage.дата_создания': 'Дата создания',
  'features.features.contacts.pages.contactspage.теги': 'Теги',
  'features.features.contacts.pages.contactspage.действия': 'Действия',
  'features.features.contacts.pages.contactspage.нет_email': 'Нет email',
  'features.features.contacts.pages.contactspage.нет_телефона': 'Нет телефона',
  'features.features.contacts.pages.contactspage.создать_задачу_по_контакту':
    'Создать задачу по контакту',
  'features.features.contacts.pages.contactspage.редактировать': 'Редактировать',
  'features.features.contacts.pages.contactspage.история_контакта': 'История контакта',
  'features.features.contacts.pages.contactspage.удалить_контакт': 'Удалить контакт',
  'features.features.contacts.pages.contactspage.удалить_контакт_2': 'Удалить контакт?',
  'features.features.contacts.pages.contactspage.сделки_задачи_и_заметки_контакта_останутся':
    'Сделки, задачи и заметки контакта останутся, но потеряют привязку.',
  'features.features.contacts.pages.contactspage.контактов_по_фильтру': 'контактов по фильтру',
  'features.features.contacts.pages.contactspage.контактов_единая_клиентская_база':
    'контактов · единая клиентская база',
  'features.features.contacts.pages.contactspage.канбан': 'Канбан',
  'features.features.contacts.pages.contactspage.канбан_2': 'Канбан',
  'features.features.contacts.pages.contactspage.список': 'Список',
  'features.features.contacts.pages.contactspage.список_2': 'Список',
  'features.features.contacts.pages.contactspage.карточки': 'Карточки',
  'features.features.contacts.pages.contactspage.карточки_2': 'Карточки',
  'features.features.contacts.pages.contactspage.новый_контакт': 'Новый контакт',
  'features.features.contacts.pages.contactspage.новый_контакт_2': 'Новый контакт',
  'features.features.contacts.pages.contactspage.обновить': 'Обновить',
  'features.features.contacts.pages.contactspage.обновить_контакты': 'Обновить контакты',
  'features.features.contacts.pages.contactspage.поиск_по_контакту_или_телефону':
    'Поиск по контакту или телефону',
  'features.features.contacts.pages.contactspage.фильтр_контактов': 'Фильтр контактов',
  'features.features.contacts.pages.contactspage.все_контакты': 'Все контакты',
  'features.features.contacts.pages.contactspage.со_сделками': 'Со сделками',
  'features.features.contacts.pages.contactspage.с_email': 'С email',
  'features.features.contacts.pages.contactspage.фильтр_по_тегу': 'Фильтр по тегу',
  'features.features.contacts.pages.contactspage.все_теги': 'Все теги',
  'features.features.contacts.pages.contactspage.всего_контактов': 'Всего контактов',
  'features.features.contacts.pages.contactspage.со_сделками_2': 'Со сделками',
  'features.features.contacts.pages.contactspage.с_email_2': 'С email',
  'features.features.contacts.pages.contactspage.нет_контактов_по_текущим_фильтрам':
    'Нет контактов по текущим фильтрам.',
  'features.features.dashboard.dashboard.vm.онлайн_записи': 'ОНЛАЙН ЗАПИСИ',
  'features.features.dashboard.dashboard.vm.свободные_окна': 'СВОБОДНЫЕ ОКНА',
  'features.features.dashboard.dashboard.vm.новые_клиенты': 'НОВЫЕ КЛИЕНТЫ',
  'features.features.dashboard.dashboard.vm.возвратность': 'ВОЗВРАТНОСТЬ',
  'features.features.dashboard.dashboard.vm.отмены': 'ОТМЕНЫ',
  'features.features.dashboard.dashboard.vm.выручка_смена': 'ВЫРУЧКА (СМЕНА)',
  'features.features.dashboard.dashboard.vm.требует_внимания': 'Требует внимания',
  'features.features.dashboard.dashboard.vm.напоминание_о_визите': 'Напоминание о визите',
  'features.features.dashboard.dashboard.vm.сбор_отзыва_whatsapp': 'Сбор отзыва (WhatsApp)',
  'features.features.dashboard.dashboard.vm.реактивация_спящих': 'Реактивация спящих',
  'features.features.dashboard.dashboard.vm.перенос_записи_конфликт': 'Перенос записи (конфликт)',
  'features.features.dashboard.dashboard.vm.новая_запись': 'Новая запись',
  'features.features.dashboard.dashboard.vm.требует_подтверждения': 'Требует подтверждения',
  'features.features.dashboard.dashboard.vm.переговоры': 'Переговоры',
  'features.features.dashboard.dashboard.vm.услуга_оказана': 'Услуга оказана',
  'features.features.deals.components.dealcard.следующий_шаг': 'Следующий контакт',
  'features.features.deals.components.dealcard.контакт_просрочен': 'Контакт просрочен',
  'features.features.deals.components.dealcard.нужен_следующий_шаг': 'Нужен следующий контакт',
  'features.features.deals.components.dealcard.последний_контакт': 'Последний контакт',
  'features.features.deals.components.dealformmodal.редактировать_сделку': 'Редактировать сделку',
  'features.features.deals.components.dealformmodal.новая_сделка': 'Новая сделка',
  'features.features.deals.components.dealformmodal.сохранить': 'Сохранить',
  'features.features.deals.components.dealformmodal.создать': 'Создать',
  'features.features.deals.components.dealformmodal.отмена': 'Отмена',
  'features.features.deals.components.dealformmodal.не_удалось_сохранить_сделку':
    'Не удалось сохранить сделку',
  'features.features.deals.components.dealformmodal.не_удалось_создать_сделку':
    'Не удалось создать сделку',
  'features.features.deals.components.dealformmodal.обязательно_только_название_контакт_и_комп':
    'Обязательно только название. Контакт и компанию можно выбрать позже — или указать компанию без контакта.',
  'features.features.deals.components.dealformmodal.название': 'Название',
  'features.features.deals.components.dealformmodal.введите_название_сделки':
    'Введите название сделки',
  'features.features.deals.components.dealformmodal.о_чем_сделка': 'О чём сделка?',
  'features.features.deals.components.dealformmodal.сумма': 'Сумма',
  'features.features.deals.components.dealformmodal.сумма_не_может_быть_отрицательной':
    'Сумма не может быть отрицательной',
  'features.features.deals.components.dealformmodal.стадия': 'Стадия',
  'features.features.deals.components.dealformmodal.источник': 'Источник',
  'features.features.deals.components.dealformmodal.не_указан': 'Не указан',
  'features.features.deals.components.dealformmodal.следующий_шаг': 'Следующий контакт',
  'features.features.deals.components.deallistview.контакт_не_указан': 'Контакт не указан',
  'features.features.deals.components.deallistview.сделка': 'Сделка',
  'features.features.deals.components.deallistview.компания': 'Компания',
  'features.features.deals.components.deallistview.без_компании': 'Без компании',
  'features.features.deals.components.deallistview.контакт': 'Контакт',
  'features.features.deals.components.deallistview.стадия': 'Стадия',
  'features.features.deals.components.deallistview.сумма': 'Сумма',
  'features.features.deals.components.deallistview.следующий_шаг': 'Следующий контакт',
  'features.features.deals.components.deallistview.срок_следующего_шага_прошел':
    'Следующий контакт просрочен',
  'features.features.deals.components.deallistview.дата_создания': 'Дата создания',
  'features.features.deals.components.deallistview.действие': 'Действие',
  'features.features.deals.components.deallistview.финальная': 'Финальная',
  'features.features.deals.components.deallistview.действия': 'Действия',
  'features.features.deals.components.deallistview.редактировать': 'Редактировать',
  'features.features.deals.components.deallistview.история_сделки': 'История сделки',
  'features.features.deals.components.deallistview.удалить_сделку': 'Удалить сделку',
  'features.features.deals.components.deallistview.удалить_сделку_2': 'Удалить сделку?',
  'features.features.deals.components.deallistview.задачи_заметки_и_встречи_сделки_останутся_':
    'Задачи, заметки и встречи сделки останутся, но потеряют привязку.',
  'features.features.deals.components.dealstagehistorypanel.история_стадий': 'История стадий',
  'features.features.deals.components.dealstagehistorypanel.не_удалось_загрузить_историю_стадий':
    'Не удалось загрузить историю стадий',
  'features.features.deals.components.dealstagehistorypanel.стадия_еще_не_менялась':
    'Стадия ещё не менялась',
  'features.features.deals.components.kanbanboard.без_шага': 'Без контакта:',
  'features.features.deals.components.kanbanboard.в_этой_стадии_пока_нет_сделок':
    'В этой стадии пока нет сделок.',
  'features.features.deals.lib.kanban.контакт_не_указан': 'Контакт не указан',
  'features.features.deals.pages.dealcardpage.редактировать': 'Редактировать',
  'features.features.deals.pages.dealcardpage.компания': 'Компания',
  'features.features.deals.pages.dealcardpage.без_компании': 'Без компании',
  'features.features.deals.pages.dealcardpage.срок_следующего_шага_прошел':
    'Следующий контакт просрочен',
  'features.features.deals.pages.dealcardpage.файлы': 'Файлы',
  'features.features.deals.pages.dealcardpage.стадии': 'Стадии',
  'features.features.deals.pages.dealcardpage.история_стадий_сделки': 'История стадий сделки',
  'features.features.deals.pages.dealcardpage.задачи_сделки': 'Задачи сделки',
  'features.features.deals.pages.dealcardpage.встречи_по_сделке': 'Встречи по сделке',
  'features.features.deals.pages.dealcardpage.документы_сделки': 'Документы сделки',
  'features.features.deals.pages.dealcardpage.история_сделки': 'История сделки',
  'features.features.deals.pages.dealcardpage.удалить_сделку': 'Удалить сделку',
  'features.features.deals.pages.dealcardpage.удалить_сделку_2': 'Удалить сделку?',
  'features.features.deals.pages.dealcardpage.задачи_встречи_и_документы_останутся_но_по':
    'Задачи, встречи и документы останутся, но потеряют привязку к сделке.',
  'features.features.deals.pages.dealcardpage.срок_следующего_шага_прошел_2':
    'Следующий контакт просрочен',
  'features.features.deals.pages.dealcardpage.готов': 'Готов',
  'features.features.deals.pages.dealcardpage.готов_2': 'Готов',
  'features.features.deals.pages.dealkanbanpage.загрузка_сделок': 'Загрузка сделок...',
  'features.features.deals.pages.dealkanbanpage.не_удалось_загрузить_сделки':
    'Не удалось загрузить сделки',
  'features.features.deals.pages.dealkanbanpage.сделки': 'Сделки',
  'features.features.deals.pages.dealkanbanpage.сделок_по_фильтру': {
    one: '{count} сделка по фильтру',
    few: '{count} сделки по фильтру',
    many: '{count} сделок по фильтру',
    other: '{count} сделок по фильтру',
  },
  'features.features.deals.pages.dealkanbanpage.сделок_кросс_проектный_вид': {
    one: '{count} сделка · кросс-проектный вид',
    few: '{count} сделки · кросс-проектный вид',
    many: '{count} сделок · кросс-проектный вид',
    other: '{count} сделок · кросс-проектный вид',
  },
  'features.features.deals.pages.dealkanbanpage.канбан': 'Канбан',
  'features.features.deals.pages.dealkanbanpage.канбан_2': 'Канбан',
  'features.features.deals.pages.dealkanbanpage.список': 'Список',
  'features.features.deals.pages.dealkanbanpage.список_2': 'Список',
  'features.features.deals.pages.dealkanbanpage.карточки': 'Карточки',
  'features.features.deals.pages.dealkanbanpage.карточки_2': 'Карточки',
  'features.features.deals.pages.dealkanbanpage.новая_сделка': 'Новая сделка',
  'features.features.deals.pages.dealkanbanpage.обновить_сделки': 'Обновить сделки',
  'features.features.deals.pages.dealkanbanpage.поиск_сделок': 'Поиск сделок',
  'features.features.deals.pages.dealkanbanpage.поиск_по_сделке_или_контакту':
    'Поиск по сделке или контакту',
  'features.features.deals.pages.dealkanbanpage.фильтр_по_стадии': 'Фильтр по стадии',
  'features.features.deals.pages.dealkanbanpage.все_стадии': 'Все стадии',
  'features.features.deals.pages.dealkanbanpage.фильтр_по_активности': 'Фильтр по активности',
  'features.features.deals.pages.dealkanbanpage.все_активности': 'Все активности',
  'features.features.deals.pages.dealkanbanpage.есть_следующий_шаг': 'Есть следующий контакт',
  'features.features.deals.pages.dealkanbanpage.без_следующего_шага': 'Без следующего контакта',
  'features.features.deals.pages.dealkanbanpage.сбросить_фильтры': 'Сбросить фильтры',
  'features.features.deals.pages.dealkanbanpage.всего_сделок': 'Всего сделок',
  'features.features.deals.pages.dealkanbanpage.активные': 'Активные',
  'features.features.deals.pages.dealkanbanpage.требуют_внимания': 'Требуют внимания',
  'features.features.deals.pages.dealkanbanpage.выбрано': 'выбрано',
  'features.features.deals.pages.dealkanbanpage.переместить_выбранные_сделки':
    'Переместить выбранные сделки',
  'features.features.deals.pages.dealkanbanpage.переместить': 'Переместить',
  'features.features.deals.pages.dealkanbanpage.отменить': 'Отменить',
  'features.features.documents.components.documentformmodal.редактировать_документ':
    'Редактировать документ',
  'features.features.documents.components.documentformmodal.новый_документ': 'Новый документ',
  'features.features.documents.components.documentformmodal.сохранить': 'Сохранить',
  'features.features.documents.components.documentformmodal.создать': 'Создать',
  'features.features.documents.components.documentformmodal.отмена': 'Отмена',
  'features.features.documents.components.documentformmodal.не_удалось_сохранить_документ':
    'Не удалось сохранить документ',
  'features.features.documents.components.documentformmodal.не_удалось_создать_документ':
    'Не удалось создать документ',
  'features.features.documents.components.documentformmodal.название_документа':
    'Название документа',
  'features.features.documents.components.documentformmodal.введите_название_документа':
    'Введите название документа',
  'features.features.documents.components.documentformmodal.договор': 'Договор №...',
  'features.features.documents.components.documentformmodal.тип': 'Тип',
  'features.features.documents.components.documentformmodal.выберите_тип_документа':
    'Выберите тип документа',
  'features.features.documents.components.documentformmodal.статус': 'Статус',
  'features.features.documents.components.documentformmodal.сумма': 'Сумма',
  'features.features.documents.components.documentformmodal.файлы_документа': 'Файлы документа',
  'features.features.documents.components.documentformmodal.файлы_можно_будет_прикрепить_сразу_после_с':
    'Файлы можно будет прикрепить сразу после создания — в этой же форме или на карточке документа.',
  'features.features.documents.components.entitydocumentspanel.документы': 'Документы',
  'features.features.documents.components.entitydocumentspanel.документ': 'Документ',
  'features.features.documents.components.entitydocumentspanel.тип': 'Тип',
  'features.features.documents.components.entitydocumentspanel.статус': 'Статус',
  'features.features.documents.components.entitydocumentspanel.сумма': 'Сумма',
  'features.features.documents.components.entitydocumentspanel.создан': 'Создан',
  'features.features.documents.components.entitydocumentspanel.не_удалось_загрузить_документы':
    'Не удалось загрузить документы',
  'features.features.documents.components.entitydocumentspanel.документов_пока_нет':
    'Документов пока нет',
  'features.features.documents.pages.documentcardpage.загрузка_документа': 'Загрузка документа...',
  'features.features.documents.pages.documentcardpage.ошибка_загрузки': 'Ошибка загрузки',
  'features.features.documents.pages.documentcardpage.не_удалось_загрузить_документ':
    'Не удалось загрузить документ',
  'features.features.documents.pages.documentcardpage.повторить': 'Повторить',
  'features.features.documents.pages.documentcardpage.договор': 'Договор',
  'features.features.documents.pages.documentcardpage.счет': 'Счет',
  'features.features.documents.pages.documentcardpage.акт': 'Акт',
  'features.features.documents.pages.documentcardpage.черновик': 'Черновик',
  'features.features.documents.pages.documentcardpage.отправлен': 'Отправлен',
  'features.features.documents.pages.documentcardpage.подписан': 'Подписан',
  'features.features.documents.pages.documentcardpage.отменен': 'Отменен',
  'features.features.documents.pages.documentcardpage.к_списку_документов': 'К списку документов',
  'features.features.documents.pages.documentcardpage.сделка': 'Сделка:',
  'features.features.documents.pages.documentcardpage.сохранить': 'Сохранить',
  'features.features.documents.pages.documentcardpage.ошибка_сохранения':
    'Не удалось сохранить документ',
  'features.features.documents.pages.documentcardpage.история_документа': 'История документа',
  'features.features.documents.pages.documentcardpage.удалить_документ': 'Удалить документ',
  'features.features.documents.pages.documentcardpage.удалить_документ_2': 'Удалить документ?',
  'features.features.documents.pages.documentcardpage.документ_пропадет_из_списков_связанные_сде':
    'Документ пропадёт из списков; связанные сделка и контакт останутся.',
  'features.features.documents.pages.documentcardpage.детали': 'Детали',
  'features.features.documents.pages.documentcardpage.редактировать': 'Редактировать',
  'features.features.documents.pages.documentcardpage.тип': 'Тип',
  'features.features.documents.pages.documentcardpage.статус': 'Статус',
  'features.features.documents.pages.documentcardpage.сумма': 'Сумма',
  'features.features.documents.pages.documentcardpage.компания': 'Компания',
  'features.features.documents.pages.documentcardpage.без_компании': 'Без компании',
  'features.features.documents.pages.documentcardpage.контакт': 'Контакт',
  'features.features.documents.pages.documentcardpage.без_контакта': 'Без контакта',
  'features.features.documents.pages.documentcardpage.сделка_2': 'Сделка',
  'features.features.documents.pages.documentcardpage.без_сделки': 'Без сделки',
  'features.features.documents.pages.documentcardpage.текст_документа': 'Текст документа',
  'features.features.documents.pages.documentcardpage.начните_писать_текст_документа_или_попроси':
    'Начните писать текст документа или попросите AI сгенерировать его...',
  'features.features.documents.pages.documentcardpage.заметки_по_документу': 'Заметки по документу',
  'features.features.documents.pages.documentcardpage.задачи_по_документу': 'Задачи по документу',
  'features.features.documents.pages.documentcardpage.встречи_по_документу': 'Встречи по документу',
  'features.features.documents.pages.documentcardpage.файлы': 'Файлы',
  'features.features.documents.pages.documentcardpage.файлы_документа': 'Файлы документа',
  'features.features.documents.pages.documentcardpage.ai_помощник': 'AI Помощник',
  'features.features.documents.pages.documentcardpage.готов': 'Готов',
  'features.features.documents.pages.documentcardpage.документ_не_привязан_к_сделке_ассистенту_н':
    'Документ не привязан к сделке — ассистенту нечего обсуждать. Укажите сделку слева, и чат станет доступен.',
  'features.features.documents.pages.documentspage.название': 'Название',
  'features.features.documents.pages.documentspage.тип': 'Тип',
  'features.features.documents.pages.documentspage.договор': 'Договор',
  'features.features.documents.pages.documentspage.счет': 'Счет',
  'features.features.documents.pages.documentspage.акт': 'Акт',
  'features.features.documents.pages.documentspage.статус': 'Статус',
  'features.features.documents.pages.documentspage.черновик': 'Черновик',
  'features.features.documents.pages.documentspage.отправлен': 'Отправлен',
  'features.features.documents.pages.documentspage.подписан': 'Подписан',
  'features.features.documents.pages.documentspage.отменен': 'Отменен',
  'features.features.documents.pages.documentspage.сумма': 'Сумма',
  'features.features.documents.pages.documentspage.клиент_сделка': 'Клиент / Сделка',
  'features.features.documents.pages.documentspage.дата_создания': 'Дата создания',
  'features.features.documents.pages.documentspage.действия': 'Действия',
  'features.features.documents.pages.documentspage.редактировать': 'Редактировать',
  'features.features.documents.pages.documentspage.история_документа': 'История документа',
  'features.features.documents.pages.documentspage.удалить_документ': 'Удалить документ',
  'features.features.documents.pages.documentspage.удалить_документ_2': 'Удалить документ?',
  'features.features.documents.pages.documentspage.документ_пропадет_из_списков_связанные_сде':
    'Документ пропадёт из списков; связанные сделка и контакт останутся.',
  'features.features.documents.pages.documentspage.документы': 'Документы',
  'features.features.documents.pages.documentspage.документов': 'документов',
  'features.features.documents.pages.documentspage.создать_документ': 'Создать документ',
  'features.features.documents.pages.documentspage.обновить': 'Обновить',
  'features.features.documents.pages.documentspage.поиск_по_документам': 'Поиск по документам',
  'features.features.documents.pages.documentspage.поиск_по_названию': 'Поиск по названию...',
  'features.features.documents.pages.documentspage.фильтр_по_типу': 'Фильтр по типу',
  'features.features.documents.pages.documentspage.все_типы': 'Все типы',
  'features.features.documents.pages.documentspage.договор_2': 'Договор',
  'features.features.documents.pages.documentspage.счет_2': 'Счет',
  'features.features.documents.pages.documentspage.акт_2': 'Акт',
  'features.features.documents.pages.documentspage.фильтр_по_статусу': 'Фильтр по статусу',
  'features.features.documents.pages.documentspage.все_статусы': 'Все статусы',
  'features.features.documents.pages.documentspage.черновик_2': 'Черновик',
  'features.features.documents.pages.documentspage.отправлен_2': 'Отправлен',
  'features.features.documents.pages.documentspage.подписан_2': 'Подписан',
  'features.features.documents.pages.documentspage.отменен_2': 'Отменен',
  'features.features.documents.pages.documentspage.нет_документов': 'Нет документов.',
  'features.features.entity.links.entitylinkfields.компания': 'Компания',
  'features.features.entity.links.entitylinkfields.без_компании': 'Без компании',
  'features.features.entity.links.entitylinkfields.другая': 'другая',
  'features.features.entity.links.entitylinkfields.контакт': 'Контакт',
  'features.features.entity.links.entitylinkfields.без_контакта': 'Без контакта',
  'features.features.entity.links.entitylinkfields.сделка': 'Сделка',
  'features.features.entity.links.entitylinkfields.подходящих_сделок_нет': 'Подходящих сделок нет',
  'features.features.entity.links.entitylinkfields.без_сделки': 'Без сделки',
  'features.features.entity.links.useentitylinkcascade.выбор_компании_оставит_в_списке_контактов_':
    'Выбор компании оставит в списке контактов только её сотрудников',
  'features.features.entity.links.useentitylinkcascade.компании_помеченные_другая_не_связаны_с_вы':
    'Компании, помеченные «другая», не связаны с выбранным контактом — выбор такой очистит контакт',
  'features.features.entity.links.useentitylinkcascade.показаны_сделки_выбранного_контакта':
    'Показаны сделки выбранного контакта',
  'features.features.entity.links.useentitylinkcascade.показаны_сделки_компании_и_ее_контактов':
    'Показаны сделки компании и её контактов',
  'features.features.hot.leads.pages.hotleadspage.сумма': 'Сумма',
  'features.features.hot.leads.pages.hotleadspage.скор': 'Скор',
  'features.features.hot.leads.pages.hotleadspage.открыть': 'Открыть',
  'features.features.hot.leads.pages.hotleadspage.из': 'из',
  'features.features.hot.leads.pages.hotleadspage.сделок_приоритетный_список':
    'сделок · приоритетный список',
  'features.features.hot.leads.pages.hotleadspage.канбан': 'Канбан',
  'features.features.hot.leads.pages.hotleadspage.канбан_2': 'Канбан',
  'features.features.hot.leads.pages.hotleadspage.список': 'Список',
  'features.features.hot.leads.pages.hotleadspage.список_2': 'Список',
  'features.features.hot.leads.pages.hotleadspage.обновить': 'Обновить',
  'features.features.hot.leads.pages.hotleadspage.обновить_горячие_лиды': 'Обновить горячие лиды',
  'features.features.hot.leads.pages.hotleadspage.поиск_горячих_лидов': 'Поиск горячих лидов',
  'features.features.hot.leads.pages.hotleadspage.поиск_по_сделке_или_контакту':
    'Поиск по сделке или контакту',
  'features.features.hot.leads.pages.hotleadspage.фильтр_по_причине': 'Фильтр по причине',
  'features.features.hot.leads.pages.hotleadspage.фильтр_по_стадии': 'Фильтр по стадии',
  'features.features.hot.leads.pages.hotleadspage.все_стадии': 'Все стадии',
  'features.features.hot.leads.pages.hotleadspage.нет_горячих_лидов_по_текущим_фильтрам':
    'Нет горячих лидов по текущим фильтрам',
  'features.features.meetings.components.entitymeetingspanel.встречи': 'Встречи',
  'features.features.meetings.components.entitymeetingspanel.тема': 'Тема',
  'features.features.meetings.components.entitymeetingspanel.начало': 'Начало',
  'features.features.meetings.components.entitymeetingspanel.встреча_уже_прошла_но_не_закрыта':
    'Встреча уже прошла, но не закрыта',
  'features.features.meetings.components.entitymeetingspanel.участники': 'Участники',
  'features.features.meetings.components.entitymeetingspanel.гость': 'гость',
  'features.features.meetings.components.entitymeetingspanel.еще': 'ещё',
  'features.features.meetings.components.entitymeetingspanel.действия': 'Действия',
  'features.features.meetings.components.entitymeetingspanel.редактировать': 'Редактировать',
  'features.features.meetings.components.entitymeetingspanel.редактировать_встречу':
    'Редактировать встречу',
  'features.features.meetings.components.entitymeetingspanel.скачать_ics': 'Скачать .ics',
  'features.features.meetings.components.entitymeetingspanel.скачать_приглашение':
    'Скачать приглашение',
  'features.features.meetings.components.entitymeetingspanel.встреча': '+ Встреча',
  'features.features.meetings.components.entitymeetingspanel.не_удалось_загрузить_встречи':
    'Не удалось загрузить встречи',
  'features.features.meetings.components.entitymeetingspanel.встреч_пока_нет': 'Встреч пока нет',
  'features.features.meetings.components.meetingformmodal.сотрудники': 'Сотрудники',
  'features.features.meetings.components.meetingformmodal.контакты': 'Контакты',
  'features.features.meetings.components.meetingformmodal.редактировать_встречу':
    'Редактировать встречу',
  'features.features.meetings.components.meetingformmodal.новая_встреча': 'Новая встреча',
  'features.features.meetings.components.meetingformmodal.сохранить': 'Сохранить',
  'features.features.meetings.components.meetingformmodal.назначить': 'Назначить',
  'features.features.meetings.components.meetingformmodal.отмена': 'Отмена',
  'features.features.meetings.components.meetingformmodal.не_удалось_сохранить_встречу':
    'Не удалось сохранить встречу',
  'features.features.meetings.components.meetingformmodal.тема': 'Тема',
  'features.features.meetings.components.meetingformmodal.введите_тему_встречи':
    'Введите тему встречи',
  'features.features.meetings.components.meetingformmodal.о_чем_встреча': 'О чём встреча?',
  'features.features.meetings.components.meetingformmodal.начало': 'Начало',
  'features.features.meetings.components.meetingformmodal.укажите_начало': 'Укажите начало',
  'features.features.meetings.components.meetingformmodal.окончание': 'Окончание',
  'features.features.meetings.components.meetingformmodal.укажите_окончание': 'Укажите окончание',
  'features.features.meetings.components.meetingformmodal.окончание_должно_быть_позже_начала':
    'Окончание должно быть позже начала',
  'features.features.meetings.components.meetingformmodal.часовой_пояс': 'Часовой пояс',
  'features.features.meetings.components.meetingformmodal.место_ссылка': 'Место / ссылка',
  'features.features.meetings.components.meetingformmodal.адрес_или_ссылка_на_созвон':
    'Адрес или ссылка на созвон',
  'features.features.meetings.components.meetingformmodal.участники': 'Участники',
  'features.features.meetings.components.meetingformmodal.сотрудники_и_контакты_из_списка_внешнего_г':
    'Сотрудники и контакты — из списка; внешнего гостя добавьте, введя email и нажав Enter',
  'features.features.meetings.components.meetingformmodal.кого_приглашаем': 'Кого приглашаем?',
  'features.features.meetings.components.meetingformmodal.описание': 'Описание',
  'features.features.meetings.components.meetingformmodal.повестка_необязательно':
    'Повестка (необязательно)',
  'features.features.meetings.pages.meetingcardpage.встреча_не_найдена': 'Встреча не найдена',
  'features.features.meetings.pages.meetingcardpage.файлы': 'Файлы',
  'features.features.meetings.pages.meetingcardpage.заметки_по_встрече': 'Заметки по встрече',
  'features.features.meetings.pages.meetingcardpage.к_встречам': 'К встречам',
  'features.features.meetings.pages.meetingcardpage.редактировать': 'Редактировать',
  'features.features.meetings.pages.meetingcardpage.история_встречи': 'История встречи',
  'features.features.meetings.pages.meetingcardpage.отменить': 'Отменить',
  'features.features.meetings.pages.meetingcardpage.отменить_встречу': 'Отменить встречу',
  'features.features.meetings.pages.meetingcardpage.отменить_встречу_2': 'Отменить встречу?',
  'features.features.meetings.pages.meetingcardpage.встреча_останется_в_списках_со_статусом_от':
    'Встреча останется в списках со статусом «Отменена».',
  'features.features.meetings.pages.meetingcardpage.не_удалось_отменить_встречу':
    'Не удалось отменить встречу',
  'features.features.meetings.pages.meetingcardpage.начало': 'Начало',
  'features.features.meetings.pages.meetingcardpage.встреча_уже_прошла_но_не_закрыта':
    'Встреча уже прошла, но не закрыта',
  'features.features.meetings.pages.meetingcardpage.окончание': 'Окончание',
  'features.features.meetings.pages.meetingcardpage.статус': 'Статус',
  'features.features.meetings.pages.meetingcardpage.место': 'Место',
  'features.features.meetings.pages.meetingcardpage.прошла_дней_назад': 'Прошла {count} дн. назад',
  'features.features.meetings.pages.meetingcardpage.часовой_пояс': 'Часовой пояс',
  'features.features.meetings.pages.meetingcardpage.сделка': 'Сделка',
  'features.features.meetings.pages.meetingcardpage.контакт': 'Контакт',
  'features.features.meetings.pages.meetingcardpage.компания': 'Компания',
  'features.features.meetings.pages.meetingcardpage.задача': 'Задача',
  'features.features.meetings.pages.meetingcardpage.документ': 'Документ',
  'features.features.meetings.pages.meetingcardpage.участники': 'Участники',
  'features.features.meetings.pages.meetingcardpage.участников_пока_нет': 'Участников пока нет',
  'features.features.meetings.pages.meetingcardpage.гость': 'гость',
  'features.features.meetings.pages.meetingcardpage.описание': 'Описание',
  'features.features.meetings.pages.meetingspage.гость': 'гость',
  'features.features.meetings.pages.meetingspage.тема': 'Тема',
  'features.features.meetings.pages.meetingspage.начало': 'Начало',
  'features.features.meetings.pages.meetingspage.встреча_уже_прошла_но_не_закрыта':
    'Встреча уже прошла, но не закрыта',
  'features.features.meetings.pages.meetingspage.окончание': 'Окончание',
  'features.features.meetings.pages.meetingspage.статус': 'Статус',
  'features.features.meetings.pages.meetingspage.участники': 'Участники',
  'features.features.meetings.pages.meetingspage.еще': 'ещё',
  'features.features.meetings.pages.meetingspage.место': 'Место',
  'features.features.meetings.pages.meetingspage.дата_создания': 'Дата создания',
  'features.features.meetings.pages.meetingspage.привязка': 'Привязка',
  'features.features.meetings.pages.meetingspage.действия': 'Действия',
  'features.features.meetings.pages.meetingspage.редактировать': 'Редактировать',
  'features.features.meetings.pages.meetingspage.редактировать_встречу': 'Редактировать встречу',
  'features.features.meetings.pages.meetingspage.скачать_ics_файл_для_календаря_участника':
    'Скачать .ics — файл для календаря участника',
  'features.features.meetings.pages.meetingspage.скачать_приглашение': 'Скачать приглашение',
  'features.features.meetings.pages.meetingspage.история_встречи': 'История встречи',
  'features.features.meetings.pages.meetingspage.отменить_встречу': 'Отменить встречу',
  'features.features.meetings.pages.meetingspage.отменить_встречу_2': 'Отменить встречу?',
  'features.features.meetings.pages.meetingspage.встреча_будет_отменена_и_скрыта_из_списка':
    'Встреча будет отменена и скрыта из списка.',
  'features.features.meetings.pages.meetingspage.отменить': 'Отменить',
  'features.features.meetings.pages.meetingspage.встречи': 'Встречи',
  'features.features.meetings.pages.meetingspage.назначайте_встречи_добавляйте_участников_и':
    'Назначайте встречи, добавляйте участников и скачивайте .ics для календаря. Рассылка приглашений по почте появится после подключения почтового транспорта.',
  'features.features.meetings.pages.meetingspage.новая_встреча': 'Новая встреча',
  'features.features.meetings.pages.meetingspage.поиск_по_теме_описанию_месту':
    'Поиск по теме, описанию, месту…',
  'features.features.meetings.pages.meetingspage.все_статусы': 'Все статусы',
  'features.features.meetings.pages.meetingspage.запланирована': 'Запланирована',
  'features.features.meetings.pages.meetingspage.прошла': 'Прошла',
  'features.features.meetings.pages.meetingspage.отменена': 'Отменена',
  'features.features.meetings.pages.meetingspage.список': 'Список',
  'features.features.meetings.pages.meetingspage.календарь': 'Календарь',
  'features.features.meetings.pages.meetingspage.не_удалось_отменить_встречу':
    'Не удалось отменить встречу',
  'features.features.meetings.pages.meetingspage.не_удалось_загрузить_встречи':
    'Не удалось загрузить встречи',
  'features.features.meetings.pages.meetingspage.встреч_пока_нет_назначьте_первую_кнопкой_н':
    'Встреч пока нет. Назначьте первую кнопкой «Новая встреча».',
  'features.features.notes.components.entitynotespanel.заметки': 'Заметки',
  'features.features.notes.components.entitynotespanel.ошибка_операции_с_заметкой':
    'Ошибка операции с заметкой',
  'features.features.notes.components.entitynotespanel.новая_заметка': 'Новая заметка…',
  'features.features.notes.components.entitynotespanel.добавить': 'Добавить',
  'features.features.notes.components.entitynotespanel.ctrl_enter_быстро_сохранить':
    'Ctrl+Enter — быстро сохранить',
  'features.features.notes.components.entitynotespanel.не_прикреплять': 'Не прикреплять',
  'features.features.notes.components.entitynotespanel.прикрепить_существующую':
    'Прикрепить существующую',
  'features.features.notes.components.entitynotespanel.найти_заметку_по_тексту':
    'Найти заметку по тексту…',
  'features.features.notes.components.entitynotespanel.ничего_не_нашлось': 'Ничего не нашлось',
  'features.features.notes.components.entitynotespanel.не_удалось_загрузить_заметки':
    'Не удалось загрузить заметки',
  'features.features.notes.components.entitynotespanel.заметок_пока_нет': 'Заметок пока нет',
  'features.features.notes.components.entitynotespanel.неизвестный_автор': 'Неизвестный автор',
  'features.features.notes.components.entitynotespanel.изменить': 'Изменить',
  'features.features.notes.components.entitynotespanel.поделиться': 'Поделиться',
  'features.features.notes.components.entitynotespanel.извлечь_задачи': 'Извлечь задачи',
  'features.features.notes.components.entitynotespanel.извлечь_задачи_в_план':
    'Извлечь задачи в план через AI',
  'features.features.notes.components.entitynotespanel.удалить_заметку': 'Удалить заметку',
  'features.features.notes.components.entitynotespanel.удалить_заметку_2': 'Удалить заметку?',
  'features.features.notes.components.entitynotespanel.заметка_пропадет_из_списка_и_со_всех_карто':
    'Заметка пропадёт из списка и со всех карточек, к которым привязана.',
  'features.features.notes.components.noteformmodal.редактировать_заметку': 'Редактировать заметку',
  'features.features.notes.components.noteformmodal.сохранить': 'Сохранить',
  'features.features.notes.components.noteformmodal.отмена': 'Отмена',
  'features.features.notes.components.noteformmodal.не_удалось_сохранить_заметку':
    'Не удалось сохранить заметку',
  'features.features.notes.components.noteformmodal.текст': 'Текст',
  'features.features.notes.components.noteformmodal.заметка_не_может_быть_пустой':
    'Заметка не может быть пустой',
  'features.features.notes.components.notesharemodal.поделиться_заметкой': 'Поделиться заметкой',
  'features.features.notes.components.notesharemodal.видимость': 'Видимость',
  'features.features.notes.components.notesharemodal.кто_видит': 'Кто видит эту заметку?',
  'features.features.notes.components.notesharemodal.всем_в_пространстве': 'Все в пространстве',
  'features.features.notes.components.notesharemodal.только_я': 'Только я',
  'features.features.notes.components.notesharemodal.выбранные_участники': 'Выбранные участники',
  'features.features.notes.components.notesharemodal.участники': 'Участники',
  'features.features.notes.components.notesharemodal.выберите_участников': 'Выберите участников…',
  'features.features.notes.components.notesharemodal.сохранить': 'Сохранить',
  'features.features.notes.components.notesharemodal.отмена': 'Отмена',
  'features.features.notes.components.notesharemodal.не_удалось_сохранить_доступ':
    'Не удалось сохранить доступ',
  'features.features.notes.components.notesharemodal.метка_всем': 'Всем',
  'features.features.notes.components.notesharemodal.метка_личное': 'Личное',
  'features.features.notes.components.notesharemodal.метка_доступ': 'Доступ',
  'features.features.notes.components.notesharemodal.подсказка_всем':
    'Видна всем участникам пространства',
  'features.features.notes.components.notesharemodal.подсказка_личное': 'Видна только автору',
  'features.features.notes.components.notesharemodal.подсказка_доступ':
    'Видна автору и выбранным участникам',
  'features.features.notes.components.notesharemodal.не_ваша_заметка':
    'Видимость и доступ меняет только автор заметки',
  'features.features.notes.components.quicknotebutton.быстрая_заметка': 'Быстрая заметка',
  'features.features.notes.components.quicknotebutton.заметка': 'Заметка',
  'features.features.notes.components.quicknotebutton.быстрая_заметка_2': 'Быстрая заметка',
  'features.features.notes.components.quicknotebutton.сохранить': 'Сохранить',
  'features.features.notes.components.quicknotebutton.отмена': 'Отмена',
  'features.features.notes.components.quicknotebutton.не_удалось_сохранить_заметку':
    'Не удалось сохранить заметку',
  'features.features.notes.components.quicknotebutton.что_записать': 'Что записать?',
  'features.features.notes.components.quicknotebutton.привязать_к': 'Привязать к',
  'features.features.notes.components.quicknotebutton.привязать_к_выбранным':
    'Привязать к выбранным (',
  'features.features.notes.components.quicknotebutton.одна_заметка_на_все':
    ') — одна заметка на все',
  'features.features.notes.components.quicknotebutton.еще': 'ещё',
  'features.features.notes.components.quicknotebutton.ничего_не_открыто_и_не_выбрано_заметка_сох':
    'Ничего не открыто и не выбрано — заметка сохранится без привязки. Отметьте строки в списке, чтобы привязать к',
  'features.features.notes.components.quicknotebutton.записям': 'записям',
  'features.features.notes.pages.notespage.заметка': 'Заметка',
  'features.features.notes.pages.notespage.привязки': 'Привязки',
  'features.features.notes.pages.notespage.без_привязки': 'Без привязки',
  'features.features.notes.pages.notespage.снять_эту_привязку': 'Снять эту привязку',
  'features.features.notes.pages.notespage.автор': 'Автор',
  'features.features.notes.pages.notespage.дата_создания': 'Дата создания',
  'features.features.notes.pages.notespage.действия': 'Действия',
  'features.features.notes.pages.notespage.изменить': 'Изменить',
  'features.features.notes.pages.notespage.изменить_заметку': 'Изменить заметку',
  'features.features.notes.pages.notespage.извлечь_задачи_в_план': 'Извлечь задачи в план',
  'features.features.notes.pages.notespage.снять_все_привязки': 'Снять все привязки',
  'features.features.notes.pages.notespage.привязок_нет': 'Привязок нет',
  'features.features.notes.pages.notespage.снять_все_привязки_2': 'Снять все привязки?',
  'features.features.notes.pages.notespage.текст_заметки_останется_она_станет_без_при':
    'Текст заметки останется, она станет без привязки.',
  'features.features.notes.pages.notespage.снять': 'Снять',
  'features.features.notes.pages.notespage.отмена': 'Отмена',
  'features.features.notes.pages.notespage.снять_все_привязки_3': 'Снять все привязки',
  'features.features.notes.pages.notespage.история_заметки': 'История заметки',
  'features.features.notes.pages.notespage.удалить_заметку': 'Удалить заметку',
  'features.features.notes.pages.notespage.удалить_заметку_2': 'Удалить заметку?',
  'features.features.notes.pages.notespage.заметка_пропадет_из_списка_и_со_всех_карто':
    'Заметка пропадёт из списка и со всех карточек, к которым привязана.',
  'features.features.notes.pages.notespage.заметки': 'Заметки',
  'features.features.notes.pages.notespage.быстрые_записи_по_сделкам_контактам_и_комп':
    'Быстрые записи по сделкам, контактам и компаниям. Новую можно добавить кнопкой в углу экрана или клавишей N.',
  'features.features.notes.pages.notespage.поиск_по_тексту_заметки': 'Поиск по тексту заметки…',
  'features.features.notes.pages.notespage.ошибка_операции': 'Ошибка операции',
  'features.features.notes.pages.notespage.не_удалось_загрузить_заметки':
    'Не удалось загрузить заметки',
  'features.features.notes.pages.notespage.заметок_пока_нет': 'Заметок пока нет',
  'features.features.settings.components.activesessionspanel.неизвестное_устройство':
    'Неизвестное устройство',
  'features.features.settings.components.activesessionspanel.неизвестное_устройство_2':
    'Неизвестное устройство',
  'features.features.settings.components.activesessionspanel.устройство': 'Устройство',
  'features.features.settings.components.activesessionspanel.текущая': 'Текущая',
  'features.features.settings.components.activesessionspanel.последняя_активность':
    'Последняя активность',
  'features.features.settings.components.activesessionspanel.вход': 'Вход',
  'features.features.settings.components.activesessionspanel.действия': 'Действия',
  'features.features.settings.components.activesessionspanel.закрыть_эту_сессию':
    'Закрыть эту сессию?',
  'features.features.settings.components.activesessionspanel.устройство_сразу_попадет_на_экран_входа':
    'Устройство сразу попадёт на экран входа.',
  'features.features.settings.components.activesessionspanel.закрыть': 'Закрыть',
  'features.features.settings.components.activesessionspanel.отмена': 'Отмена',
  'features.features.settings.components.activesessionspanel.закрыть_2': 'Закрыть',
  'features.features.settings.components.activesessionspanel.активные_сессии': 'Активные сессии',
  'features.features.settings.components.activesessionspanel.устройства_на_которых_выполнен_вход_закрой':
    'Устройства, на которых выполнен вход. Закройте те, которые не узнаёте.',
  'features.features.settings.components.activesessionspanel.выйти_на_всех_остальных_устройствах':
    'Выйти на всех остальных устройствах?',
  'features.features.settings.components.activesessionspanel.текущая_сессия_останется_активной':
    'Текущая сессия останется активной.',
  'features.features.settings.components.activesessionspanel.выйти_везде': 'Выйти везде',
  'features.features.settings.components.activesessionspanel.отмена_2': 'Отмена',
  'features.features.settings.components.activesessionspanel.выйти_на_других_устройствах':
    'Выйти на других устройствах',
  'features.features.settings.components.activesessionspanel.не_удалось_закрыть_сессию':
    'Не удалось закрыть сессию',
  'features.features.settings.components.activesessionspanel.других_активных_сессий_не_было':
    'Других активных сессий не было',
  'features.features.settings.components.activesessionspanel.не_удалось_загрузить_сессии':
    'Не удалось загрузить сессии',
  'features.features.settings.components.activesessionspanel.активных_сессий_нет':
    'Активных сессий нет',
  'features.features.tasks.components.entitytaskspanel.задачи': 'Задачи',
  'features.features.tasks.components.entitytaskspanel.задача': '+ Задача',
  'features.features.tasks.components.entitytaskspanel.не_удалось_загрузить_задачи':
    'Не удалось загрузить задачи',
  'features.features.tasks.components.entitytaskspanel.здесь_пока_нет_задач':
    'Здесь пока нет задач',
  'features.features.tasks.components.relatedtaskspanel.не_удалось_загрузить_связанные_задачи':
    'Не удалось загрузить связанные задачи',
  'features.features.tasks.components.relatedtaskspanel.связанных_задач_пока_нет':
    'Связанных задач пока нет',
  'features.features.tasks.components.relatedtaskspanel.у_задачи_пока_нет_связей_привяжите_сделку_':
    'У задачи пока нет связей — привяжите сделку, контакт, компанию или документ',
  'features.features.tasks.components.taskactivitytimeline.задача_создана': 'Задача создана',
  'features.features.tasks.components.taskactivitytimeline.задача_обновлена': 'Задача обновлена',
  'features.features.tasks.components.taskactivitytimeline.задача_удалена': 'Задача удалена',
  'features.features.tasks.components.taskactivitytimeline.пока_нет_записей_истории':
    'Пока нет записей истории',
  'features.features.tasks.components.taskdescriptionsection.содержание': 'Содержание',
  'features.features.tasks.components.taskdescriptionsection.изменить': 'Изменить',
  'features.features.tasks.components.taskdescriptionsection.добавить': 'Добавить',
  'features.features.tasks.components.taskdescriptionsection.не_удалось_сохранить_содержание':
    'Не удалось сохранить содержание',
  'features.features.tasks.components.taskdescriptionsection.опишите_содержание_задачи_в_markdown':
    'Опишите содержание задачи в Markdown…',
  'features.features.tasks.components.taskdescriptionsection.превью_пусто': 'Превью пусто',
  'features.features.tasks.components.taskdescriptionsection.сохранить': 'Сохранить',
  'features.features.tasks.components.taskdescriptionsection.отмена': 'Отмена',
  'features.features.tasks.components.taskdescriptionsection.сохранение': 'Сохранение…',
  'features.features.tasks.components.taskdescriptionsection.содержание_еще_не_добавлено':
    'Содержание ещё не добавлено',
  'features.features.tasks.components.taskformmodal.редактировать_задачу': 'Редактировать задачу',
  'features.features.tasks.components.taskformmodal.новая_задача': 'Новая задача',
  'features.features.tasks.components.taskformmodal.сохранить': 'Сохранить',
  'features.features.tasks.components.taskformmodal.создать': 'Создать',
  'features.features.tasks.components.taskformmodal.отмена': 'Отмена',
  'features.features.tasks.components.taskformmodal.не_удалось_сохранить_задачу':
    'Не удалось сохранить задачу',
  'features.features.tasks.components.taskformmodal.название': 'Название',
  'features.features.tasks.components.taskformmodal.введите_название_задачи':
    'Введите название задачи',
  'features.features.tasks.components.taskformmodal.что_нужно_сделать': 'Что нужно сделать?',
  'features.features.tasks.components.taskformmodal.описание': 'Описание',
  'features.features.tasks.components.taskformmodal.детали_задачи_необязательно':
    'Детали задачи (необязательно)',
  'features.features.tasks.components.taskformmodal.статус': 'Статус',
  'features.features.tasks.components.taskformmodal.приоритет': 'Приоритет',
  'features.features.tasks.components.taskformmodal.срок': 'Срок',
  'features.features.tasks.components.taskformmodal.срок_не_может_быть_в_прошлом':
    'Срок не может быть в прошлом',
  'features.features.tasks.components.taskformmodal.исполнитель': 'Исполнитель',
  'features.features.tasks.components.taskformmodal.не_назначен': 'Не назначен',
  'features.features.tasks.components.taskkanbanboard.в_этом_статусе_пока_нет_задач':
    'В этом статусе пока нет задач.',
  'features.features.tasks.components.taskkanbancard.срок': 'Срок:',
  'features.features.tasks.components.taskkanbancard.просрочено': 'Просрочено',
  'features.features.tasks.components.tasksgrid.название': 'Название',
  'features.features.tasks.components.tasksgrid.статус': 'Статус',
  'features.features.tasks.components.tasksgrid.приоритет': 'Приоритет',
  'features.features.tasks.components.tasksgrid.срок': 'Срок',
  'features.features.tasks.components.tasksgrid.исполнитель': 'Исполнитель',
  'features.features.tasks.components.tasksgrid.сделка': 'Сделка',
  'features.features.tasks.components.tasksgrid.компания': 'Компания',
  'features.features.tasks.components.tasksgrid.контакт': 'Контакт',
  'features.features.tasks.components.tasksgrid.дата_создания': 'Дата создания',
  'features.features.tasks.components.tasksgrid.действия': 'Действия',
  'features.features.tasks.components.tasksgrid.редактировать': 'Редактировать',
  'features.features.tasks.components.tasksgrid.редактировать_2': 'Редактировать',
  'features.features.tasks.components.tasksgrid.история_задачи': 'История задачи',
  'features.features.tasks.components.tasksgrid.удалить_задачу': 'Удалить задачу',
  'features.features.tasks.components.tasksgrid.удалить_задачу_2': 'Удалить задачу?',
  'features.features.tasks.components.tasksgrid.задачу_можно_будет_восстановить_только_из_':
    'Задачу можно будет восстановить только из базы.',
  'features.features.tasks.pages.taskcardpage.задача_не_найдена': 'Задача не найдена',
  'features.features.tasks.pages.taskcardpage.файлы': 'Файлы',
  'features.features.tasks.pages.taskcardpage.заметки_по_задаче': 'Заметки по задаче',
  'features.features.tasks.pages.taskcardpage.встречи_по_задаче': 'Встречи по задаче',
  'features.features.tasks.pages.taskcardpage.к_задачам': 'К задачам',
  'features.features.tasks.pages.taskcardpage.редактировать': 'Редактировать',
  'features.features.tasks.pages.taskcardpage.история_задачи': 'История задачи',
  'features.features.tasks.pages.taskcardpage.удалить': 'Удалить',
  'features.features.tasks.pages.taskcardpage.удалить_задачу': 'Удалить задачу?',
  'features.features.tasks.pages.taskcardpage.задача_пропадет_из_списков_заметки_по_ней_':
    'Задача пропадёт из списков; заметки по ней останутся без привязки.',
  'features.features.tasks.pages.taskcardpage.не_удалось_удалить_задачу':
    'Не удалось удалить задачу',
  'features.features.tasks.pages.taskcardpage.срок': 'Срок',
  'features.features.tasks.pages.taskcardpage.срок_задачи_прошел': 'Срок задачи прошёл',
  'features.features.tasks.pages.taskcardpage.исполнитель': 'Исполнитель',
  'features.features.tasks.pages.taskcardpage.не_назначен': 'не назначен',
  'features.features.tasks.pages.taskcardpage.сделка': 'Сделка',
  'features.features.tasks.pages.taskcardpage.контакт': 'Контакт',
  'features.features.tasks.pages.taskcardpage.компания': 'Компания',
  'features.features.tasks.pages.taskcardpage.документ': 'Документ',
  'features.features.tasks.pages.taskcardpage.создана': 'Создана',
  'features.features.tasks.pages.taskcardpage.касание_сделано': 'Касание сделано',
  'features.features.tasks.pages.taskcardpage.касание_зафиксировано':
    'Касание зафиксировано: взаимодействие записано в историю контакта',
  'features.features.tasks.pages.taskcardpage.не_удалось_зафиксировать_касание':
    'Не удалось зафиксировать касание',
  'features.features.tasks.pages.taskspage.без_контакта': 'Без контакта',
  'features.features.tasks.pages.taskspage.без_сделки': 'Без сделки',
  'features.features.tasks.pages.taskspage.без_компании': 'Без компании',
  'features.features.tasks.pages.taskspage.задачи': 'Задачи',
  'features.features.tasks.pages.taskspage.создавайте_и_ведите_задачи_все_в_пределах_':
    'Создавайте и ведите задачи. Всё в пределах текущего workspace.',
  'features.features.tasks.pages.taskspage.канбан': 'Канбан',
  'features.features.tasks.pages.taskspage.канбан_2': 'Канбан',
  'features.features.tasks.pages.taskspage.список': 'Список',
  'features.features.tasks.pages.taskspage.список_2': 'Список',
  'features.features.tasks.pages.taskspage.новая_задача': 'Новая задача',
  'features.features.tasks.pages.taskspage.поиск_по_названию': 'Поиск по названию…',
  'features.features.tasks.pages.taskspage.все_статусы': 'Все статусы',
  'features.features.tasks.pages.taskspage.любой_исполнитель': 'Любой исполнитель',
  'features.features.tasks.pages.taskspage.группировка': 'Группировка:',
  'features.features.tasks.pages.taskspage.без_группировки': 'Без группировки',
  'features.features.tasks.pages.taskspage.по_статусу': 'По статусу',
  'features.features.tasks.pages.taskspage.по_сделке': 'По сделке',
  'features.features.tasks.pages.taskspage.по_компании': 'По компании',
  'features.features.tasks.pages.taskspage.по_контакту': 'По контакту',
  'features.features.tasks.pages.taskspage.статус': 'Статус',
  'features.features.tasks.pages.taskspage.срок': 'Срок:',
  'features.features.tasks.pages.taskspage.все_сроки': 'Все сроки',
  'features.features.tasks.pages.taskspage.просрочено': 'Просрочено',
  'features.features.tasks.pages.taskspage.сегодня': 'Сегодня',
  'features.features.tasks.pages.taskspage.7_дней': '7 дней',
  'features.features.tasks.pages.taskspage.ошибка_операции': 'Ошибка операции',
  'features.features.tasks.pages.taskspage.не_удалось_загрузить_задачи':
    'Не удалось загрузить задачи',
  'features.features.tasks.pages.taskspage.задач_нет_создайте_первую_кнопкой_новая_за':
    'Задач нет. Создайте первую кнопкой «Новая задача».',
  'features.features.team.components.teampanel.участник': 'Участник',
  'features.features.team.components.teampanel.это_вы': 'это вы',
  'features.features.team.components.teampanel.роль': 'Роль',
  'features.features.team.components.teampanel.статус': 'Статус',
  'features.features.team.components.teampanel.действия': 'Действия',
  'features.features.team.components.teampanel.отключить': 'Отключить',
  'features.features.team.components.teampanel.отключить_2': 'Отключить',
  'features.features.team.components.teampanel.отключить_участника': 'Отключить участника?',
  'features.features.team.components.teampanel.человек_перестанет_попадать_в_пространство':
    'Человек перестанет попадать в пространство. Записи, которые он создал, останутся.',
  'features.features.team.components.teampanel.вернуть': 'Вернуть',
  'features.features.team.components.teampanel.адрес': 'Адрес',
  'features.features.team.components.teampanel.статус_2': 'Статус',
  'features.features.team.components.teampanel.просрочено': 'Просрочено',
  'features.features.team.components.teampanel.действует_до': 'Действует до',
  'features.features.team.components.teampanel.действия_2': 'Действия',
  'features.features.team.components.teampanel.отозвать': 'Отозвать',
  'features.features.team.components.teampanel.отозвать_2': 'Отозвать',
  'features.features.team.components.teampanel.отозвать_приглашение': 'Отозвать приглашение?',
  'features.features.team.components.teampanel.ссылка_перестанет_работать':
    'Ссылка перестанет работать.',
  'features.features.team.components.teampanel.команда': 'Команда',
  'features.features.team.components.teampanel.кто_состоит_в_пространстве_и_кого_позвали_':
    'Кто состоит в пространстве и кого позвали. Роль определяет, что человек может делать: наблюдатель только смотрит, участник правит, администратор ещё и управляет составом.',
  'features.features.team.components.teampanel.пригласить': 'Пригласить',
  'features.features.team.components.teampanel.приглашения_недоступны': 'Приглашения недоступны',
  'features.features.team.components.teampanel.не_получилось': 'Не получилось',
  'features.features.team.components.teampanel.приглашение_создано': 'Приглашение создано',
  'features.features.team.components.teampanel.письмо_поставлено_в_очередь_ссылку_можно_п':
    'Письмо поставлено в очередь. Ссылку можно передать и лично:',
  'features.features.team.components.teampanel.не_удалось_загрузить_участников':
    'Не удалось загрузить участников',
  'features.features.team.components.teampanel.приглашения': 'Приглашения',
  'features.features.team.components.teampanel.не_удалось_загрузить_приглашения':
    'Не удалось загрузить приглашения',
  'features.features.team.components.teampanel.никого_не_приглашали': 'Никого не приглашали',
  'features.features.team.components.teampanel.пригласить_в_пространство':
    'Пригласить в пространство',
  'features.features.team.components.teampanel.отправить_приглашение': 'Отправить приглашение',
  'features.features.team.components.teampanel.отмена': 'Отмена',
  'features.features.team.components.teampanel.не_удалось_пригласить': 'Не удалось пригласить',
  'features.features.team.components.teampanel.укажите_адрес': 'Укажите адрес',
  'features.features.team.components.teampanel.похоже_это_не_адрес_почты':
    'Похоже, это не адрес почты',
  'features.features.team.components.teampanel.принять_приглашение_можно_только_под_этим_':
    'Принять приглашение можно только под этим адресом.',
  'features.features.team.components.teampanel.роль_2': 'Роль',
  'features.features.templates.pages.templatespage.не_удалось_сохранить_шаблон_проверьте_изме':
    'Не удалось сохранить шаблон. Проверьте изменения и попробуйте ещё раз.',
  'features.features.templates.pages.templatespage.удалить_шаблон': 'Удалить шаблон',
  'features.features.templates.pages.templatespage.удалить_шаблон_2': 'Удалить шаблон?',
  'features.features.templates.pages.templatespage.отправленные_по_нему_письма_останутся_шабл':
    'Отправленные по нему письма останутся, шаблон пропадёт из списка.',
  'features.features.templates.pages.templatespage.не_удалось_создать_шаблон_проверьте_поля_и':
    'Не удалось создать шаблон. Проверьте поля и попробуйте ещё раз.',
  'features.features.templates.pages.templatespage.дата_создания': 'Дата создания',
  'features.features.templates.pages.templatespage.история_шаблона': 'История шаблона',
  'features.features.templates.pages.templatespage.удалить_шаблон_3': 'Удалить шаблон',
  'features.features.templates.pages.templatespage.удалить_шаблон_4': 'Удалить шаблон?',
  'features.features.templates.pages.templatespage.отправленные_по_нему_письма_останутся_шабл_2':
    'Отправленные по нему письма останутся, шаблон пропадёт из списка.',
  'features.features.templates.pages.templatespage.из': 'из',
  'features.features.templates.pages.templatespage.введите_название_шаблона':
    'Введите название шаблона',
  'features.features.templates.pages.templatespage.введите_текст_шаблона': 'Введите текст шаблона',
  'features.features.views.components.dashboardsavedviews.не_удалось_собрать_это_представление':
    'Не удалось собрать это представление',
  'features.features.views.components.dashboardsavedviews.мои_представления': 'Мои представления',
  'features.features.views.components.dashboardsavedviews.пока_ничего_не_закреплено_соберите_вид_в_р':
    'Пока ничего не закреплено. Соберите вид в разделе',
  'features.features.views.components.dashboardsavedviews.представления': '«Представления»',
  'features.features.views.components.dashboardsavedviews.и_отметьте_плиткой_на_дашборде':
    'и отметьте «Плиткой на дашборде».',
  'features.features.views.components.saveviewmodal.закрепить_представление':
    'Закрепить представление',
  'features.features.views.components.saveviewmodal.настройки_представления':
    'Настройки представления',
  'features.features.views.components.saveviewmodal.сохранить': 'Сохранить',
  'features.features.views.components.saveviewmodal.отмена': 'Отмена',
  'features.features.views.components.saveviewmodal.название': 'Название',
  'features.features.views.components.saveviewmodal.где_показывать': 'Где показывать',
  'features.features.views.components.saveviewmodal.пунктом_в_боковом_меню':
    'Пунктом в боковом меню',
  'features.features.views.components.saveviewmodal.плиткой_на_дашборде': 'Плиткой на дашборде',
  'features.features.views.components.saveviewmodal.кому_видно': 'Кому видно',
  'features.features.views.components.saveviewmodal.только_мне': 'Только мне',
  'features.features.views.components.saveviewmodal.выбранным_участникам': 'Выбранным участникам',
  'features.features.views.components.saveviewmodal.всем_в_пространстве': 'Всем в пространстве',
  'features.features.views.components.saveviewmodal.кому_открыть_доступ': 'Кому открыть доступ',
  'features.features.views.components.saveviewmodal.данные_останутся_под_правами_того_кто_смот':
    'Данные останутся под правами того, кто смотрит',
  'features.features.views.components.saveviewmodal.представление_показывает_только_те_записи_':
    'Представление показывает только те записи, которые человеку и так доступны.',
  'features.features.views.components.saveviewmodal.не_удалось_сохранить': 'Не удалось сохранить',
  'features.features.views.components.viewcellvalue.да': 'да',
  'features.features.views.components.viewcellvalue.нет': 'нет',
  'features.features.views.components.viewrenderer.ничего_не_найдено': 'Ничего не найдено',
  'features.features.views.components.viewrenderer.количество': 'Количество',
  'features.features.views.components.viewrenderer.сумма': 'Сумма',
  'features.features.views.components.viewrenderer.среднее': 'Среднее',
  'features.features.views.components.viewrenderer.ничего_не_найдено_2': 'Ничего не найдено',
  'features.features.views.components.viewrenderer.записей_больше_чем_разрез_успевает_пройти_':
    'Записей больше, чем разрез успевает пройти. Числа и порядок строк неполные — сузьте период или фильтр.',
  'features.features.views.pages.savedviewpage.представление_не_найдено':
    'Представление не найдено',
  'features.features.views.pages.savedviewpage.его_удалили_или_доступ_к_нему_закрыли':
    'Его удалили или доступ к нему закрыли.',
  'features.features.views.pages.savedviewpage.видно_всем': 'Видно всем',
  'features.features.views.pages.savedviewpage.настроить': 'Настроить',
  'features.features.views.pages.savedviewpage.убрать_представление': 'Убрать представление?',
  'features.features.views.pages.savedviewpage.убрать': 'Убрать',
  'features.features.views.pages.savedviewpage.отмена': 'Отмена',
  'features.features.views.pages.savedviewpage.убрать_2': 'Убрать',
  'features.features.views.pages.savedviewpage.не_удалось_собрать_представление':
    'Не удалось собрать представление',
  'features.features.views.pages.savedviewpage.описание_не_содержит_ни_одного_блока':
    'Описание не содержит ни одного блока.',
  'features.features.views.pages.viewspage.агент_представлений': 'Агент представлений',
  'features.features.views.pages.viewspage.опишите_словами_что_хотите_видеть_агент_св':
    'Опишите словами, что хотите видеть. Агент сверится со словарём сущностей, соберёт описание и покажет результат — экрана под такой запрос никто не писал.',
  'features.features.views.pages.viewspage.показать': 'Показать',
  'features.features.views.pages.viewspage.например_три_последних_договора_сумма_фирм':
    'Например: три последних договора — сумма, фирма и дата',
  'features.features.views.pages.viewspage.примеры': 'Примеры:',
  'features.features.views.pages.viewspage.агент_не_ответил': 'Агент не ответил',
  'features.features.views.pages.viewspage.по_записанным_примерам': 'по записанным примерам',
  'features.features.views.pages.viewspage.описание_не_удалось_разобрать':
    'Описание не удалось разобрать',
  'features.features.views.pages.viewspage.закрепить': 'Закрепить',
  'features.features.views.pages.viewspage.закрепленные_представления':
    'Закреплённые представления',
  'features.features.views.pages.viewspage.описание_которое_собрал_агент':
    'Описание, которое собрал агент',
  'features.pages.chatpage.переписка_удалится_безвозвратно': 'Переписка удалится безвозвратно.',
  'features.pages.chatpage.удалить': 'Удалить',
  'features.pages.chatpage.отмена': 'Отмена',
  'features.pages.chatpage.не_удалось_удалить_сессии': 'Не удалось удалить сессии',
  'features.pages.chatpage.отмена_2': 'Отмена',
  'features.pages.chatpage.выбрать': 'Выбрать',
  'features.pages.chatpage.не_удалось_изменить_ai_шлюз': 'Не удалось изменить AI-шлюз',
  'features.pages.settingspage.не_подтвержден': 'не подтверждён',
  'features.pages.settingspage.имя': 'Имя',
  'features.pages.settingspage.роль': 'Роль',
  'features.pages.settingspage.адрес_не_подтвержден': 'Адрес не подтверждён',
  'features.pages.settingspage.подтверждение_нужно_чтобы_восстановить_пар':
    'Подтверждение нужно, чтобы восстановить пароль и получать письма о встречах.',
  'features.pages.settingspage.письмо_отправлено_проверьте_почту':
    'Письмо отправлено — проверьте почту.',
  'features.pages.settingspage.отправить_письмо': 'Отправить письмо',
  'features.pages.settingspage.включен_в_карточке_сделки': 'Включен в карточке сделки',
  'features.pages.settingspage.биллинг': 'Биллинг',
  'features.pages.settingspage.включен': 'Включен',
  'features.pages.settingspage.выключен': 'Выключен',
  'features.activity.field.title': 'название',
  'features.activity.field.description': 'описание',
  'features.activity.field.body': 'текст',
  'features.activity.field.priority': 'приоритет',
  'features.activity.field.status': 'статус',
  'features.activity.field.assignee': 'исполнитель',
  'features.activity.field.owner': 'ответственный',
  'features.activity.field.deal': 'сделка',
  'features.activity.field.company': 'компания',
  'features.activity.field.contact': 'контакт',
  'features.activity.field.task': 'задача',
  'features.activity.field.due_at': 'срок',
  'features.activity.field.completed_at': 'дата выполнения',
  'features.activity.field.amount': 'сумма',
  'features.activity.field.currency': 'валюта',
  'features.activity.field.source': 'источник',
  'features.activity.field.role': 'должность',
  'features.activity.field.phone': 'телефон',
  'features.activity.field.tags': 'теги',
  'features.activity.field.notes': 'заметки',
  'features.activity.field.first_name': 'имя',
  'features.activity.field.last_name': 'фамилия',
  'features.activity.field.domain': 'домен',
  'features.activity.field.website': 'сайт',
  'features.activity.field.industry': 'отрасль',
  'features.activity.field.type': 'тип',
  'features.activity.field.subject': 'тема',
  'features.activity.field.variables': 'переменные',
  'features.activity.field.is_active': 'активность',
  'features.activity.field.location': 'место',
  'features.activity.field.timezone': 'часовой пояс',
  'features.activity.field.next_step': 'следующий шаг',
  'features.activity.field.links': 'привязки',
  'features.activity.field.starts_at': 'начало',
  'features.activity.field.ends_at': 'окончание',
  'features.activity.field.participants': 'участники',
  'features.activity.event.todo': 'К выполнению',
  'features.activity.event.in_progress': 'В работе',
  'features.activity.event.done': 'Выполнена',
  'features.activity.event.cancelled': 'Отменена',
  'features.activity.event.deal_created': 'Сделка создана',
  'features.activity.event.deal_deleted': 'Сделка удалена',
  'features.activity.event.contact_created': 'Контакт создан',
  'features.activity.event.contact_deleted': 'Контакт удалён',
  'features.activity.event.company_created': 'Компания создана',
  'features.activity.event.company_deleted': 'Компания удалена',
  'features.activity.event.task_created': 'Задача создана',
  'features.activity.event.task_deleted': 'Задача удалена',
  'features.activity.event.note_added': 'Заметка добавлена',
  'features.activity.event.note_deleted': 'Заметка удалена',
  'features.activity.event.meeting_scheduled': 'Встреча назначена',
  'features.activity.event.meeting_cancelled': 'Встреча отменена',
  'features.activity.event.document_created': 'Документ создан',
  'features.activity.event.document_deleted': 'Документ удалён',
  'features.activity.event.template_created': 'Шаблон создан',
  'features.activity.event.template_deleted': 'Шаблон удалён',
  'features.activity.event.interaction_logged': 'Записано взаимодействие',
  'features.activity.event.email_sent': 'Отправлено письмо',
  'features.activity.event.email_opened': 'Письмо открыто',
  'features.activity.event.email_clicked': 'Переход из письма',
  'features.activity.event.call_made': 'Совершён звонок',
  'features.activity.event.ai_tool_invoked': 'Ассистент выполнил действие',
  'features.activity.event.scenario_started': 'Сценарий запущен',
  'features.activity.event.scenario_completed': 'Сценарий завершён',
  'features.activity.actor.system': 'Система',
  'features.activity.event.task_due_reminder': 'Напоминание о сроке задачи: {p0}',
  'features.activity.event.task_due_reminder_plain': 'Напоминание о сроке задачи',
  'features.activity.event.deal_updated': 'Сделка обновлена',
  'features.activity.event.contact_updated': 'Контакт обновлён',
  'features.activity.event.company_updated': 'Компания обновлена',
  'features.activity.event.task_updated': 'Задача обновлена',
  'features.activity.event.note_updated': 'Заметка обновлена',
  'features.activity.event.meeting_updated': 'Встреча обновлена',
  'features.activity.event.document_updated': 'Документ обновлён',
  'features.activity.event.template_updated': 'Шаблон обновлён',
  'features.dynamic.features.activity.lib.describeactivity.1': 'Привязка добавлена: {p0}',
  'features.dynamic.features.activity.lib.describeactivity.2': 'Привязка снята: {p0}',
  'features.dynamic.features.activity.lib.describeactivity.3': 'Статус: {p0} → {p1}',
  'features.dynamic.features.activity.lib.describeactivity.4': 'Стадия: {p0} → {p1}',
  'features.dynamic.features.activity.lib.describeactivity.5': 'Изменено: {p0}',
  'features.dynamic.features.ai.chat.components.antdesignxchatsurface.6': 'Параметры: {p0}',
  'features.dynamic.features.ai.chat.components.chatpanel.7':
    'Подготовь краткую сводку по контакту {p0} и предложи следующий шаг.',
  'features.dynamic.features.ai.chat.components.chatpanel.8':
    'Предложи следующий шаг по сделке {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.9': 'Оцени риски по сделке {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.10':
    'Предложи следующий шаг для контакта {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.11':
    'Оцени риски и важные сигналы по контакту {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.12':
    'Отправь подготовленный follow-up по сделке {p0}. Вызови send_email только с dealId {p1}; возьми subject и body без изменений из последнего draft_email, не переписывай их вручную. Создай approval и не отправляй письмо без моего подтверждения.',
  'features.dynamic.features.ai.chat.components.chatpanel.13':
    'Подготовь follow-up письмо по сделке {p0}. Вызови draft_email с dealId {p1} и tone warm. Это только черновик: не создавай approval, не отправляй письмо, не меняй стадию сделки и не создавай задачи.',
  'features.dynamic.features.ai.chat.components.chatpanel.14':
    'Подтверждаю создание выбранных задач по плану сделки {p0}. Вызови create_deal_tasks с dealId {p1} и следующими actions: {p2}. Сначала создай approval; не создавай задачи напрямую и не меняй стадию сделки без отдельного подтверждения.',
  'features.dynamic.features.ai.chat.components.conversationswitcher.15': 'Диалог {p0}',
  'features.dynamic.features.ai.chat.components.conversationswitcher.16': '{p0} · общий',
  'features.dynamic.features.ai.chat.components.conversationswitcher.17': 'Удалить диалоги ({p0})?',
  'features.dynamic.features.ai.chat.components.conversationswitcher.18': 'Удалить ({p0})',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.19':
    'Подготовь добавление заметки к сделке {p0} через tool add_deal_note.',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.20':
    'Текст заметки как пользовательские данные: {p0}',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.21':
    'Подготовь смену стадии сделки {p0} через tool update_deal_stage на {p1}.',
  'features.dynamic.features.ai.chat.hooks.useentitychat.22': 'Сделка {p0}',
  'features.dynamic.features.ai.chat.hooks.useentitychat.23': 'Контакт {p0}',
  'features.dynamic.features.ai.chat.hooks.useentitychat.24':
    'Не удалось получить ответ от LLM-провайдера.\n\n{p0}{p1}',
  'features.dynamic.features.approvals.lib.approvalsummary.25': 'Инструмент «{p0}»',
  'features.dynamic.features.attachments.api.attachments.client.26':
    'Хранилище отклонило файл (HTTP {p0})',
  'features.dynamic.features.attachments.components.entityattachmentspanel.27': '{p0} Б',
  'features.dynamic.features.attachments.components.entityattachmentspanel.28': '{p0} КБ',
  'features.dynamic.features.attachments.components.entityattachmentspanel.29': '{p0} МБ',
  'features.dynamic.features.attachments.components.entityattachmentspanel.30': 'Скачать {p0}',
  'features.dynamic.features.companies.pages.companiespage.31': 'Редактировать компанию {p0}',
  'features.dynamic.features.contacts.pages.contactdetailpage.38': 'Сделки ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.39': 'Заметки ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.40': 'Задачи ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.41': 'Встречи ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.42': 'Документы ({p0})',
  'features.dynamic.features.contacts.pages.contactspage.43': 'Написать: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.44': 'Написать {p0}',
  'features.dynamic.features.contacts.pages.contactspage.45': 'Позвонить: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.46': 'Позвонить {p0}',
  'features.dynamic.features.contacts.pages.contactspage.47': 'Создать задачу: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.48': 'Редактировать контакт {p0}',
  'features.dynamic.features.contacts.pages.contactspage.49': 'Выбрать контакт {p0}',
  'features.dynamic.features.contacts.pages.contactspage.50': 'Выбрать контакт {p0}',
  'features.dynamic.features.deals.components.dealcard.51': 'Выбрать сделку {p0}',
  'features.dynamic.features.deals.components.dealcard.52': 'Срок следующего контакта прошёл: {p0}',
  'features.dynamic.features.deals.components.dealcard.53': 'Следующий контакт: {p0}',
  'features.dynamic.features.deals.components.dealcard.54': 'Переместить в стадию «{p0}»',
  'features.dynamic.features.deals.components.deallistview.54': 'Следующая стадия для {p0}',
  'features.dynamic.features.deals.components.deallistview.55': 'Редактировать сделку {p0}',
  'features.dynamic.features.deals.components.deallistview.56': 'Выбрать сделку {p0}',
  'features.dynamic.features.deals.components.deallistview.57': 'Выбрать сделку {p0}',
  'features.dynamic.features.deals.components.kanbanboard.58': 'Создать сделку в {p0}',
  'features.dynamic.features.deals.pages.dealcardpage.59': 'Встречи ({p0})',
  'features.dynamic.features.deals.pages.dealcardpage.60': 'Документы ({p0})',
  'features.dynamic.features.deals.pages.dealkanbanpage.61': '{p0} сделок не перемещено',
  'features.dynamic.features.documents.pages.documentcardpage.62': 'Заметки ({p0})',
  'features.dynamic.features.documents.pages.documentcardpage.63': 'Задачи ({p0})',
  'features.dynamic.features.documents.pages.documentcardpage.64': 'Встречи ({p0})',
  'features.dynamic.features.documents.pages.documentspage.65':
    '{p0}: у самого документа клиент не указан',
  'features.dynamic.features.documents.pages.documentspage.66': 'Редактировать документ {p0}',
  'features.dynamic.features.meetings.pages.meetingcardpage.67': 'Заметки ({p0})',
  'features.dynamic.features.notes.components.quicknotebutton.68': 'Заметка к {p0}',
  'features.dynamic.features.notes.components.quicknotebutton.69': 'Заметка к выбранным ({p0})',
  'features.dynamic.features.notes.components.quicknotebutton.70': '{p0} · клавиша N',
  'features.dynamic.features.notes.pages.notespage.71': 'Снять привязку: {p0}',
  'features.dynamic.features.settings.components.activesessionspanel.72': 'Закрыто сессий: {p0}',
  'features.dynamic.features.tasks.components.taskactivitytimeline.73': 'Статус: {p0} → {p1}',
  'features.dynamic.features.tasks.components.taskactivitytimeline.74': 'Изменено: {p0}',
  'features.dynamic.features.tasks.components.taskdescriptionsection.75':
    'Форматирование превысит лимит в {p0} символов',
  'features.dynamic.features.tasks.components.taskkanbanboard.76': 'Создать задачу в статусе {p0}',
  'features.dynamic.features.tasks.pages.taskcardpage.77': 'Заметки ({p0})',
  'features.dynamic.features.tasks.pages.taskcardpage.78': 'Встречи ({p0})',
  'features.dynamic.features.tasks.pages.taskcardpage.79': 'Связанные задачи ({p0})',
  'features.dynamic.features.views.components.viewcellvalue.80':
    'Связь {p0}: у самой записи она не проставлена',
  'features.dynamic.features.views.components.viewrenderer.81': 'Посчитано по {p0} записям из {p1}',
  'features.dynamic.features.views.components.viewrenderer.82':
    'Блок «{p0}» не поддерживается этой версией интерфейса',
  'features.dynamic.features.views.pages.savedviewpage.83': 'Поделился: {p0}',
  'features.dynamic.features.views.pages.savedviewpage.84': 'Открыто: {p0}',
  'features.dynamic.pages.chatpage.85': 'Удалить сессии ({p0})?',
  'features.dynamic.pages.chatpage.86': 'Удалить ({p0})',
  'features.map.features.ai.chat.components.dealchatcrudactions.1': 'Новая',
  'features.map.features.ai.chat.components.dealchatcrudactions.2': 'Контакт',
  'features.map.features.ai.chat.components.dealchatcrudactions.3': 'Переговоры',
  'features.map.features.ai.chat.components.gatewayprofileselector.4': 'NeuralDeep · РФ',
  'features.map.features.ai.chat.components.gatewayprofileselector.5': 'OpenRouter',
  'features.map.features.approvals.lib.approvalsummary.6': 'Действие ассистента',
  'features.map.features.approvals.lib.approvalsummary.7': 'Шаг сценария',
  'features.map.features.approvals.lib.approvalsummary.8': 'Удаление контакта',
  'features.map.features.approvals.lib.approvalsummary.9': 'Удаление сделки',
  'features.map.features.approvals.pages.approvalspage.10': 'Ожидают решения',
  'features.map.features.approvals.pages.approvalspage.11': 'Подтверждённые',
  'features.map.features.approvals.pages.approvalspage.12': 'Отклонённые',
  'features.map.features.approvals.pages.approvalspage.13': 'Истёкшие',
  'features.map.features.approvals.pages.approvalspage.14': 'Все',
  'features.map.features.approvals.pages.approvalspage.15': 'Ожидает',
  'features.map.features.approvals.pages.approvalspage.16': 'Подтверждено',
  'features.map.features.approvals.pages.approvalspage.17': 'Отклонено',
  'features.map.features.approvals.pages.approvalspage.18': 'Истекло',
  'features.map.features.approvals.pages.approvalspage.19': 'Отменённые',
  'features.map.features.approvals.pages.approvalspage.20': 'Отменено',
  'features.map.features.contacts.components.contactinteractionspanel.19': 'Звонок',
  'features.map.features.contacts.components.contactinteractionspanel.20': 'Письмо',
  'features.map.features.contacts.components.contactinteractionspanel.21': 'Личная встреча',
  'features.map.features.contacts.components.contactinteractionspanel.22': 'Заметка',
  'features.map.features.contacts.components.contactinteractionspanel.23': 'В приложении',
  'features.map.features.contacts.components.contactinteractionspanel.24': 'Звонок',
  'features.map.features.contacts.components.contactinteractionspanel.25': 'Письмо',
  'features.map.features.contacts.components.contactinteractionspanel.26':
    'Личная встреча (состоялась)',
  'features.map.features.contacts.components.contactinteractionspanel.27': 'В приложении',
  'features.map.features.contacts.pages.contactspage.28': 'Контакт',
  'features.map.features.contacts.pages.contactspage.29': 'Email / телефон',
  'features.map.features.contacts.pages.contactspage.30': 'Компания',
  'features.map.features.contacts.pages.contactspage.31': 'Сделки',
  'features.map.features.contacts.pages.contactspage.32': 'Теги',
  'features.map.features.contacts.pages.contactspage.33': 'Дата создания',
  'features.map.features.deals.components.dealformmodal.34': 'Новая запись',
  'features.map.features.deals.components.dealformmodal.35': 'Требует подтверждения',
  'features.map.features.deals.components.dealformmodal.36': 'Переговоры',
  'features.map.features.deals.components.dealformmodal.37': 'Услуга оказана',
  'features.map.features.deals.components.dealformmodal.38': 'Отменена',
  'features.map.features.deals.components.deallistview.39': 'Сделка',
  'features.map.features.deals.components.deallistview.40': 'Компания',
  'features.map.features.deals.components.deallistview.41': 'Контакт',
  'features.map.features.deals.components.deallistview.42': 'Стадия',
  'features.map.features.deals.components.deallistview.43': 'Сумма',
  'features.map.features.deals.components.deallistview.44': 'Следующий шаг',
  'features.map.features.deals.components.deallistview.45': 'Следующая стадия',
  'features.map.features.deals.components.deallistview.46': 'Дата создания',
  'features.map.features.documents.components.documentformmodal.47': 'Договор',
  'features.map.features.documents.components.documentformmodal.48': 'Счет',
  'features.map.features.documents.components.documentformmodal.49': 'Акт',
  'features.map.features.documents.components.documentformmodal.50': 'Черновик',
  'features.map.features.documents.components.documentformmodal.51': 'Отправлен',
  'features.map.features.documents.components.documentformmodal.52': 'Подписан',
  'features.map.features.documents.components.documentformmodal.53': 'Отменен',
  'features.map.features.meetings.pages.meetingspage.54': 'Тема',
  'features.map.features.meetings.pages.meetingspage.55': 'Начало',
  'features.map.features.meetings.pages.meetingspage.56': 'Окончание',
  'features.map.features.meetings.pages.meetingspage.57': 'Статус',
  'features.map.features.meetings.pages.meetingspage.58': 'Участники',
  'features.map.features.meetings.pages.meetingspage.59': 'Место',
  'features.map.features.meetings.pages.meetingspage.60': 'Привязка',
  'features.map.features.meetings.pages.meetingspage.61': 'Дата создания',
  'features.map.features.notes.components.quicknotebutton.62': 'сделке',
  'features.map.features.notes.components.quicknotebutton.63': 'контакту',
  'features.map.features.notes.components.quicknotebutton.64': 'компании',
  'features.map.features.notes.components.quicknotebutton.65': 'задаче',
  'features.map.features.notes.components.quicknotebutton.66': 'встрече',
  'features.map.features.notes.components.quicknotebutton.67': 'документу',
  'features.map.features.notes.components.quicknotebutton.68': 'шаблону',
  'features.map.features.notes.hooks.usecurrententitycontext.69': 'сделке',
  'features.map.features.notes.hooks.usecurrententitycontext.70': 'контакту',
  'features.map.features.notes.hooks.usecurrententitycontext.71': 'компании',
  'features.map.features.tasks.components.relatedtaskspanel.72': 'Название',
  'features.map.features.tasks.components.relatedtaskspanel.73': 'Статус',
  'features.map.features.tasks.components.relatedtaskspanel.74': 'Приоритет',
  'features.map.features.tasks.components.relatedtaskspanel.75': 'Срок',
  'features.map.features.tasks.components.relatedtaskspanel.76': 'Исполнитель',
  'features.map.features.tasks.components.taskactivitytimeline.77': 'название',
  'features.map.features.tasks.components.taskactivitytimeline.78': 'описание',
  'features.map.features.tasks.components.taskactivitytimeline.79': 'приоритет',
  'features.map.features.tasks.components.taskactivitytimeline.80': 'исполнитель',
  'features.map.features.tasks.components.taskactivitytimeline.81': 'сделка',
  'features.map.features.tasks.components.taskactivitytimeline.82': 'компания',
  'features.map.features.tasks.components.taskactivitytimeline.83': 'контакт',
  'features.map.features.tasks.components.taskactivitytimeline.84': 'срок',
  'features.map.features.tasks.components.taskdescriptionsection.85': 'Жирный',
  'features.map.features.tasks.components.taskdescriptionsection.86': 'Курсив',
  'features.map.features.tasks.components.taskdescriptionsection.87': 'Зачёркивание',
  'features.map.features.tasks.components.taskdescriptionsection.88': 'Код',
  'features.map.features.tasks.components.taskdescriptionsection.89': 'Заголовок',
  'features.map.features.tasks.components.taskdescriptionsection.90': 'Маркированный список',
  'features.map.features.tasks.components.taskdescriptionsection.91': 'Нумерованный список',
  'features.map.features.tasks.components.taskdescriptionsection.92': 'Цитата',
  'features.map.features.tasks.components.taskdescriptionsection.93': 'Редактор',
  'features.map.features.tasks.components.taskdescriptionsection.94': 'Предпросмотр',
  'features.map.features.tasks.lib.markdownformat.95': 'жирный текст',
  'features.map.features.tasks.lib.markdownformat.96': 'курсивный текст',
  'features.map.features.tasks.lib.markdownformat.97': 'зачёркнутый текст',
  'features.map.features.tasks.lib.markdownformat.98': 'код',
  'ai_ui.add_note.confirm': 'Добавить заметку',
  'ai_ui.tool.action_plan_draft.name': 'Подготовить план действий',
  'ai_ui.tool.action_plan_draft.description': 'Подготовить безопасный черновик связанных действий.',
  'ai_ui.tool.action_plan_start.name': 'Запустить план действий',
  'ai_ui.tool.crm_list.name': 'Загрузить записи CRM',
  'ai_ui.tool.action_plan_start.description': 'Сохранить подтверждённый план связанных действий.',
  'ai_ui.tool.web_fetch.name': 'Открыть страницу',
  'ai_ui.tool.web_fetch.description': 'Загрузить страницу из интернета.',
  'ai_ui.tool.web_search.name': 'Поиск в интернете',
  'ai_ui.tool.web_search.description': 'Найти свежую информацию в интернете.',
  'ai_ui.tool.deep_research.name': 'Глубокое исследование',
  'ai_ui.tool.deep_research.description': 'Провести многошаговое исследование темы в интернете.',
  'ai_ui.tool.search_projects.name': 'Поиск проектов',
  'ai_ui.tool.search_projects.description': 'Найти проекты по запросу и фильтрам.',
  'ai_ui.tool.read_project.name': 'Прочитать проект',
  'ai_ui.tool.read_project.description': 'Получить карточку проекта со связями.',
  'ai_ui.tool.create_project.name': 'Создать проект',
  'ai_ui.tool.create_project.description': 'Подготовить создание проекта к подтверждению.',
  'ai_ui.tool.update_project.name': 'Изменить проект',
  'ai_ui.tool.update_project.description': 'Подготовить изменения проекта к подтверждению.',
  'ai_ui.tool.deal_summary.name': 'Сводка по сделке',
  'ai_ui.tool.deal_summary.description':
    'Выполнить действие «Сводка по сделке» в текущем контексте CRM.',
  'ai_ui.tool.deal_risk.name': 'Анализ рисков сделки',
  'ai_ui.tool.deal_risk.description':
    'Выполнить действие «Анализ рисков сделки» в текущем контексте CRM.',
  'ai_ui.tool.deal_call.name': 'Подготовка к звонку',
  'ai_ui.tool.deal_call.description':
    'Выполнить действие «Подготовка к звонку» в текущем контексте CRM.',
  'ai_ui.tool.deal_cockpit.name': 'Карточка сделки',
  'ai_ui.tool.deal_cockpit.description':
    'Выполнить действие «Карточка сделки» в текущем контексте CRM.',
  'ai_ui.tool.deal_plan.name': 'План действий',
  'ai_ui.tool.deal_plan.description': 'Выполнить действие «План действий» в текущем контексте CRM.',
  'ai_ui.tool.touch_strategy.name': 'Стратегия касаний',
  'ai_ui.tool.touch_strategy.description': 'Предложить стратегию касаний по текущей сделке в CRM.',
  'ai_ui.tool.deal_qualification.name': 'Квалификация сделки',
  'ai_ui.tool.deal_qualification.description':
    'Извлечь чеклист квалификации по текущей сделке из её истории.',
  'ai_ui.tool.update_deal_qualification.name': 'Обновление квалификации сделки',
  'ai_ui.tool.update_deal_qualification.description':
    'Перезаписать чеклист квалификации сделки; требует подтверждения пользователя.',
  'ai_ui.tool.add_note.name': 'Добавить заметку',
  'ai_ui.tool.add_note.description':
    'Выполнить действие «Добавить заметку» в текущем контексте CRM.',
  'ai_ui.tool.draft_email.name': 'Черновик письма',
  'ai_ui.tool.draft_email.description':
    'Выполнить действие «Черновик письма» в текущем контексте CRM.',
  'ai_ui.tool.send_email.name': 'Отправить письмо',
  'ai_ui.tool.send_email.description':
    'Выполнить действие «Отправить письмо» в текущем контексте CRM.',
  'ai_ui.tool.update_stage.name': 'Изменить стадию',
  'ai_ui.tool.update_stage.description':
    'Выполнить действие «Изменить стадию» в текущем контексте CRM.',
  'ai_ui.tool.create_tasks.name': 'Создать задачи',
  'ai_ui.tool.create_tasks.description':
    'Выполнить действие «Создать задачи» в текущем контексте CRM.',
  'ai_ui.tool.contact_history.name': 'История контакта',
  'ai_ui.tool.contact_history.description':
    'Выполнить действие «История контакта» в текущем контексте CRM.',
  'ai_ui.tool.manager_briefing.name': 'Мой день',
  'ai_ui.tool.manager_briefing.description': 'Собрать обзор дня в текущем контексте CRM.',
  'ai_ui.tool.analyze_meeting_note.name': 'Разбор заметки встречи',
  'ai_ui.tool.analyze_meeting_note.description':
    'Разобрать последнюю заметку сделки без изменений в CRM.',
  'ai_ui.tool.hot_leads.name': 'Горячие лиды',
  'ai_ui.tool.hot_leads.description': 'Выполнить действие «Горячие лиды» в текущем контексте CRM.',
  'ai_ui.tool.run_scenario.name': 'Запустить сценарий',
  'ai_ui.tool.run_scenario.description':
    'Выполнить действие «Запустить сценарий» в текущем контексте CRM.',
  'ai_ui.tool.recent_activities.name': 'Загрузка активностей',
  'ai_ui.tool.recent_activities.description': 'Получить последние действия и события в CRM.',
  'ai_ui.tool.search_deals.name': 'Поиск сделок',
  'ai_ui.tool.search_deals.description': 'Поиск и фильтрация сделок по параметрам.',
  'ai_ui.tool.show_view.name': 'Отображение данных',
  'ai_ui.tool.show_view.description': 'Построение и показ аналитической витрины.',
  'ai_ui.tool.search_contacts.name': 'Поиск контактов',
  'ai_ui.tool.search_contacts.description': 'Поиск клиентов и контактов в CRM.',
  'ai_ui.tool.recent_memories.name': 'Память ассистента',
  'ai_ui.tool.recent_memories.description': 'Загрузка контекста и сохраненных предпочтений.',
  'ai_ui.tool.write_memory.name': 'Запись в память',
  'ai_ui.tool.write_memory.description': 'Сохранение важного факта в долговременную память.',
  'ai_ui.tool.update_memory.name': 'Изменить запись памяти',
  'ai_ui.tool.update_memory.description': 'Подготовить изменение записи памяти к подтверждению.',
  'ai_ui.tool.delete_memory.name': 'Удалить запись памяти',
  'ai_ui.tool.delete_memory.description': 'Подготовить удаление записи памяти к подтверждению.',
  'ai_ui.tool.view_catalog.name': 'Каталог представлений',
  'ai_ui.tool.view_catalog.description': 'Просмотр доступных витрин данных.',
  'ai_ui.tool.find_records.name': 'Поиск записей',
  'ai_ui.tool.find_records.description': 'Поиск строк в базе данных CRM.',
  'ai_ui.tool.build_view.name': 'Построение отчета',
  'ai_ui.tool.build_view.description': 'Генерация динамической таблицы данных.',
  'ai_ui.tool.save_view.name': 'Сохранение отчета',
  'ai_ui.tool.save_view.description': 'Сохранение кастомного представления.',
  'ai_ui.tool.read_task.name': 'Просмотреть задачу',
  'ai_ui.tool.read_task.description': 'Просмотреть одну доступную вам задачу.',
  'ai_ui.tool.create_task.name': 'Создать задачу',
  'ai_ui.tool.create_task.description': 'Подготовить новую задачу к подтверждению.',
  'ai_ui.tool.update_task.name': 'Изменить задачу',
  'ai_ui.tool.update_task.description': 'Подготовить изменения задачи к подтверждению.',
  'ai_ui.tool.delete_task.name': 'Удалить задачу',
  'ai_ui.tool.delete_task.description': 'Подготовить удаление задачи к подтверждению.',
  'ai_ui.tool.set_task_status.name': 'Изменить статус задачи',
  'ai_ui.tool.set_task_status.description': 'Подготовить изменение статуса задачи к подтверждению.',
  'ai_ui.tool.assign_task.name': 'Назначить задачу',
  'ai_ui.tool.assign_task.description': 'Подготовить назначение задачи к подтверждению.',
  'ai_ui.tool.link_task.name': 'Привязать задачу',
  'ai_ui.tool.link_task.description': 'Подготовить привязку задачи к записи для подтверждения.',
  'ai_ui.tool.unlink_task.name': 'Удалить связь задачи',
  'ai_ui.tool.unlink_task.description': 'Подготовить удаление связи задачи к подтверждению.',
  'ai_ui.tool.set_task_due_date.name': 'Изменить срок задачи',
  'ai_ui.tool.set_task_due_date.description': 'Подготовить изменение срока задачи к подтверждению.',
  'ai_ui.tool.read_note.name': 'Просмотреть заметку',
  'ai_ui.tool.read_note.description': 'Просмотреть одну доступную вам заметку.',
  'ai_ui.tool.create_note.name': 'Создать заметку',
  'ai_ui.tool.create_note.description': 'Подготовить новую заметку к подтверждению.',
  'ai_ui.tool.update_note.name': 'Изменить заметку',
  'ai_ui.tool.update_note.description': 'Подготовить изменения заметки к подтверждению.',
  'ai_ui.tool.delete_note.name': 'Удалить заметку',
  'ai_ui.tool.delete_note.description': 'Подготовить удаление заметки к подтверждению.',
  'ai_ui.tool.link_note.name': 'Привязать заметку',
  'ai_ui.tool.link_note.description': 'Подготовить привязку заметки к записи для подтверждения.',
  'ai_ui.tool.unlink_note.name': 'Удалить связь заметки',
  'ai_ui.tool.unlink_note.description': 'Подготовить удаление связи заметки к подтверждению.',
  'ai_ui.tool.search_tasks.name': 'Поиск задач',
  'ai_ui.tool.search_tasks.description': 'Найти задачи по фильтрам.',
  'ai_ui.tool.bulk_read_contacts.name': 'Просмотр контактов',
  'ai_ui.tool.bulk_read_contacts.description': 'Просмотреть выбранные контакты.',
  'ai_ui.tool.bulk_read_companies.name': 'Просмотр компаний',
  'ai_ui.tool.bulk_read_companies.description': 'Просмотреть выбранные компании.',
  'ai_ui.tool.bulk_read_notes.name': 'Просмотр заметок',
  'ai_ui.tool.bulk_read_notes.description': 'Просмотреть выбранные заметки.',
  'ai_ui.tool.bulk_read_documents.name': 'Просмотр документов',
  'ai_ui.tool.bulk_read_documents.description': 'Просмотреть выбранные документы.',
  'ai_ui.tool.bulk_read_templates.name': 'Просмотр шаблонов',
  'ai_ui.tool.bulk_read_templates.description': 'Просмотреть выбранные шаблоны.',
  'ai_ui.tool.bulk_read_attachments.name': 'Просмотр вложений',
  'ai_ui.tool.bulk_read_attachments.description': 'Просмотреть выбранные вложения.',
  'ai_ui.tool.bulk_read_contact_interactions.name': 'Просмотр взаимодействий',
  'ai_ui.tool.bulk_read_contact_interactions.description':
    'Просмотреть выбранные взаимодействия с контактами.',
  'ai_ui.tool.bulk_read_calendar_events.name': 'Просмотр встреч',
  'ai_ui.tool.bulk_read_calendar_events.description': 'Просмотреть выбранные встречи.',
  'ai_ui.tool.read_company.name': 'Карточка компании',
  'ai_ui.tool.read_company.description': 'Просмотреть данные компании.',
  'ai_ui.tool.read_company_revenue.name': 'Выручка компании',
  'ai_ui.tool.read_company_revenue.description':
    'Показать суммы выигранных сделок компании отдельно по валютам.',
  'ai_ui.tool.read_document.name': 'Просмотр документа',
  'ai_ui.tool.read_document.description': 'Просмотреть один доступный вам документ.',
  'ai_ui.tool.read_attachment.name': 'Просмотр вложения',
  'ai_ui.tool.read_attachment.description': 'Просмотреть данные вложения.',
  'ai_ui.tool.read_attachment_content.name': 'Содержимое вложения',
  'ai_ui.tool.read_attachment_content.description': 'Прочитать текстовое содержимое вложения.',
  'ai_ui.tool.read_attachment_image.name': 'Просмотр изображения',
  'ai_ui.tool.read_attachment_image.description': 'Посмотреть изображение вложения.',
  'ai_ui.tool.read_template.name': 'Просмотр шаблона',
  'ai_ui.tool.read_template.description': 'Просмотреть один доступный вам шаблон.',
  'ai_ui.tool.read_calendar_event.name': 'Просмотр встречи',
  'ai_ui.tool.read_calendar_event.description': 'Просмотреть одну доступную вам встречу.',
  'ai_ui.tool.read_calendar_events.name': 'Просмотр списка встреч',
  'ai_ui.tool.read_calendar_events.description': 'Просмотреть встречи за период.',
  'ai_ui.tool.list_attachments.name': 'Список вложений',
  'ai_ui.tool.list_attachments.description': 'Показать вложения записи.',
  'ai_ui.tool.list_imports.name': 'Список импортов',
  'ai_ui.tool.list_imports.description': 'Показать прошлые импорты.',
  'ai_ui.tool.preview_import.name': 'Предпросмотр импорта',
  'ai_ui.tool.preview_import.description': 'Разобрать файл импорта без записи данных.',
  'ai_ui.tool.execute_import.name': 'Запуск импорта',
  'ai_ui.tool.execute_import.description': 'Подготовить импорт данных к подтверждению.',
  'ai_ui.tool.investigate_crm_context.name': 'Проверка контекста CRM',
  'ai_ui.tool.investigate_crm_context.description':
    'Изучить данные рабочего пространства по запросу.',
  'ai_ui.tool.conversation_to_note.name': 'Заметка из диалога',
  'ai_ui.tool.conversation_to_note.description':
    'Подготовить заметку по истории диалога к подтверждению.',
  'ai_ui.tool.document_to_note.name': 'Заметка из документа',
  'ai_ui.tool.document_to_note.description': 'Подготовить заметку из документа к подтверждению.',
  'ai_ui.tool.create_deal.name': 'Создать сделку',
  'ai_ui.tool.create_deal.description': 'Создать новую сделку в воронке.',
  'ai_ui.tool.update_deal.name': 'Изменить сделку',
  'ai_ui.tool.update_deal.description': 'Изменить данные сделки.',
  'ai_ui.tool.delete_deal.name': 'Удалить сделку',
  'ai_ui.tool.delete_deal.description': 'Удалить сделку из рабочего пространства.',
  'ai_ui.tool.bulk_create_templates.name': 'Создать шаблоны',
  'ai_ui.tool.bulk_create_templates.description': 'Подготовить новые шаблоны к подтверждению.',
  'ai_ui.tool.bulk_update_templates.name': 'Изменить шаблоны',
  'ai_ui.tool.bulk_update_templates.description': 'Подготовить изменения шаблонов к подтверждению.',
  'ai_ui.tool.enrich_contact.name': 'Обогащение контакта',
  'ai_ui.tool.enrich_contact.description': 'Дополнить данные контакта из открытых источников.',
  'ai_ui.tool.get_sales_health.name': 'Показатели продаж',
  'ai_ui.tool.get_sales_health.description': 'Показать состояние воронки продаж.',
  'ai_ui.tool.generate_dashboard_widget.name': 'Виджет дашборда',
  'ai_ui.tool.generate_dashboard_widget.description': 'Собрать виджет для дашборда.',
  'ai_ui.tool.refresh_entity_context.name': 'Обновление контекста',
  'ai_ui.tool.refresh_entity_context.description': 'Обновить контекст записи для следующих шагов.',
  'ai_ui.tool.propose_candidate_refinement.name': 'Уточнение подборки',
  'ai_ui.tool.propose_candidate_refinement.description': 'Предложить уточнение подборки записей.',
  'ai_ui.tool.delegate_deal_specialist.name': 'Помощник по сделкам',
  'ai_ui.tool.delegate_deal_specialist.description': 'Передать вопрос специалисту по сделкам.',
  'ai_ui.tool.delegate_tasks_specialist.name': 'Помощник по задачам',
  'ai_ui.tool.delegate_tasks_specialist.description': 'Передать вопрос специалисту по задачам.',
  'chat.manager_briefing.title': 'Мой день',
  'chat.manager_briefing.signal_count': {
    one: '{count} сигнал',
    few: '{count} сигнала',
    many: '{count} сигналов',
    other: '{count} сигналов',
  },
  'chat.manager_briefing.hot_leads': 'Горячие лиды',
  'chat.manager_briefing.overdue_tasks': 'Просроченные задачи',
  'chat.manager_briefing.risk_deals': 'Сделки с риском потери',
  'chat.manager_briefing.today_meetings': 'Встречи сегодня',
  'chat.manager_briefing.priorities': 'Ключевые приоритеты на сегодня',
  'chat.manager_briefing.priority_meetings': 'Подготовиться к встречам сегодня',
  'chat.manager_briefing.priority_overdue_tasks': 'Разобрать просроченные задачи',
  'chat.manager_briefing.priority_risk_deals': 'Проверить сделки с риском',
  'chat.manager_briefing.priority_hot_leads': 'Определить следующий шаг по горячим сделкам',
  'chat.manager_briefing.reason_overdue_next_activity': 'Просрочено следующее действие',
  'chat.manager_briefing.reason_missing_next_activity': 'Не запланировано следующее действие',
  'chat.manager_briefing.reason_stale_activity': 'Нет недавней активности',
  'chat.manager_briefing.reason_overdue_task': 'Есть просроченная задача',
  'chat.manager_briefing.reason_due': 'Срок следующего действия близко',
  'chat.manager_briefing.reason_high_value': 'Высокая стоимость сделки',
  'chat.manager_briefing.pipeline_slice': 'Срез воронки продаж',
  'chat.manager_briefing.conversion': 'Конверсия',
  'chat.manager_briefing.new': 'Новые',
  'chat.manager_briefing.in_progress': 'В работе',
  'chat.manager_briefing.contacted': 'Контакт установлен',
  'chat.manager_briefing.negotiation': 'Переговоры',
  'chat.manager_briefing.won': 'Успешно закрыты',
  'chat.manager_briefing.lost': 'Потеряны',
  'chat.meeting_outcome.title': 'Разбор встречи',
  'chat.meeting_outcome.summary': 'Резюме',
  'chat.meeting_outcome.decisions': 'Решения и договорённости',
  'chat.meeting_outcome.risks': 'Риски и открытые вопросы',
  'chat.meeting_outcome.next_actions': 'Кандидаты в следующие действия',
  'chat.meeting_outcome.read_only_note':
    'Это только разбор. Данные CRM не изменялись, задачи не созданы.',
  'chat.meeting_outcome.no_note_missing':
    'У этой сделки пока нет заметок. Добавьте заметку о встрече и повторите запрос.',
  'chat.meeting_outcome.no_note_empty': 'Последняя заметка этой сделки пуста — разбирать нечего.',
  'chat.meeting_outcome.source_latest_note': 'Источник: последняя заметка сделки',
  'chat.meeting_outcome.analysis_unavailable':
    'Не удалось разобрать заметку: сервис ИИ сейчас недоступен. Попробуйте повторить запрос позже.',
  'chat.meeting_outcome.note_too_long':
    'Заметка слишком длинная для разбора. Сократите её или выберите фрагмент о встрече, затем повторите запрос.',
  'chat.meeting_outcome.empty_list': '—',
  'chat.meeting_outcome.selected_count': 'Выбрано: {selected} из {total}',
  'chat.meeting_outcome.select_action': 'Выбрать действие: {title}',
  'chat.meeting_outcome.create_selected_tasks': 'Создать выбранные задачи',
  'chat.meeting_outcome.create_tasks_command': 'Создай выбранные задачи из разбора встречи',
  'chat.meeting_outcome.approval_hint':
    'Задачи будут созданы только после подтверждения в заявке на согласование.',
  'chat.sales_health.title': 'Здоровье продаж',
  'chat.sales_health.badge_readonly': 'Только чтение',
  'chat.sales_health.badge_heuristic': 'Эвристика CRM',
  'chat.sales_health.stats_active': 'Активные сделки',
  'chat.sales_health.stats_healthy': 'Здоровые',
  'chat.sales_health.stats_attention': 'Требуют внимания',
  'chat.sales_health.stats_critical': 'Критичные',
  'chat.sales_health.money_pipeline': 'Сумма воронки',
  'chat.sales_health.money_expected': 'Ожидаемая выручка',
  'chat.sales_health.stages_title': 'Воронка по стадиям',
  'chat.sales_health.stage_New': 'Новые',
  'chat.sales_health.stage_Contacted': 'В работе',
  'chat.sales_health.stage_Negotiation': 'Переговоры',
  'chat.sales_health.attention_title': 'Сделки, требующие внимания',
  'chat.sales_health.level_healthy': 'Здоровая',
  'chat.sales_health.level_attention': 'Внимание',
  'chat.sales_health.level_critical': 'Критичная',
  'chat.sales_health.reason_overdue_next_activity': 'Просрочено следующее действие',
  'chat.sales_health.reason_missing_next_activity': 'Не запланировано следующее действие',
  'chat.sales_health.reason_stale_activity': 'Давно нет активности',
  'chat.sales_health.reason_overdue_task': 'Есть просроченная задача',
  'chat.sales_health.reason_stage_age_over_norm': 'На текущей стадии дольше нормы',
  'chat.sales_health.reason_qualification_gaps': 'Квалификация не заполнена',
  'chat.sales_health.reason_stage_new': 'Ранняя стадия',
  'chat.sales_health.reason_stage_contacted': 'Стадия «В работе»',
  'chat.sales_health.reason_stage_negotiation': 'Стадия «Переговоры»',
  'chat.sales_health.reason_zero_amount': 'Не указана сумма сделки',
  'chat.sales_health.reason_closed_won': 'Сделка успешно закрыта',
  'chat.sales_health.reason_closed_lost': 'Сделка закрыта как потерянная',
  'chat.sales_health.recommendation_fix_overdue_activity': 'Перенести просроченное действие',
  'chat.sales_health.recommendation_close_overdue_tasks': 'Закрыть просроченные задачи',
  'chat.sales_health.recommendation_plan_next_step': 'Запланировать следующий шаг',
  'chat.sales_health.recommendation_follow_up': 'Связаться с клиентом',
  'chat.sales_health.recommendation_continue_pipeline': 'Продолжать работу по воронке',
  'chat.sales_health.recommendation_none': 'Действий не требуется',
  'chat.sales_health.activity_scheduled_future': 'Шаг запланирован',
  'chat.sales_health.activity_overdue': 'Шаг просрочен',
  'chat.sales_health.activity_missing': 'Шаг не назначен',
  'chat.sales_health.col_title': 'Сделка',
  'chat.sales_health.col_stage': 'Стадия',
  'chat.sales_health.col_amount': 'Сумма',
  'chat.sales_health.col_probability': 'Вероятность',
  'chat.sales_health.col_next_action': 'Следующий шаг',
  'chat.sales_health.empty_no_deals':
    'В открытой воронке пока нет сделок — добавьте первую, чтобы увидеть прогноз.',
  'chat.sales_health.empty_all_healthy':
    'Все сделки открытой воронки здоровы — внимание сейчас не требуется.',
  'chat.sales_health.empty_no_risky': 'Нет сделок, требующих внимания.',
  'chat.sales_health.disclaimer_readonly': 'Карточка только для чтения: данные CRM не изменялись.',
  'chat.sales_health.disclaimer_heuristic':
    'Это объяснимая эвристика CRM (стадия + сигналы риска), а не ML-прогноз.',
  'chat.touch_strategy.title': 'Стратегия касаний',
  'chat.touch_strategy.diagnosis_label': 'Диагноз по сделке',
  'chat.touch_strategy.steps_title': 'Каденс касаний',
  'chat.touch_strategy.channel_email': 'Письмо',
  'chat.touch_strategy.channel_call': 'Звонок',
  'chat.touch_strategy.channel_meeting': 'Встреча',
  'chat.touch_strategy.channel_telegram': 'Telegram',
  'chat.touch_strategy.day_offset': 'Д+{n}',
  'chat.touch_strategy.draft_preview_show': 'показать полностью',
  'chat.touch_strategy.draft_preview_hide': 'скрыть',
  'chat.touch_strategy.evidence': 'Сигналы в пользу стратегии',
  'chat.touch_strategy.preset_proposal_silent': 'Дожим после КП',
  'chat.touch_strategy.preset_stale_silence': 'Возврат в работу',
  'chat.touch_strategy.preset_discovery': 'Квалификация',
  'chat.touch_strategy.preset_no_next_step': 'Лёгкий каденс',
  'chat.touch_strategy.create_tasks': {
    one: 'Создать {count} задачу',
    few: 'Создать {count} задачи',
    many: 'Создать {count} задач',
    other: 'Создать {count} задач',
  },
  'chat.touch_strategy.decline': 'Отклонить',
  'chat.touch_strategy.status_pending': 'Подтверждение получено, проверяем выполнение…',
  'chat.touch_strategy.status_executed': 'Задачи созданы',
  'chat.touch_strategy.status_declined': 'Стратегия отклонена — задачи не созданы',
  'chat.touch_strategy.status_guard': 'Стратегия не прошла проверку фактов и не выдана',
  'chat.touch_strategy.status_llm': 'Не удалось подготовить стратегию, попробуйте позже',
  'chat.touch_strategy.status_persist': 'Не удалось зарегистрировать подтверждение стратегии',
  'chat.touch_strategy.executed_at': 'в {time}',
  'chat.touch_strategy.cockpit_button': 'Предложить стратегию',
  'chat.touch_strategy.trigger':
    'Предложи стратегию касаний по сделке {dealId}: что делать дальше, чтобы дожать её',
  'chat.touch_strategy.read_only': 'Только чтение',
  'chat.touch_strategy.history_advanced': 'История изменилась — стратегия могла устареть',
  'chat.qualification.title': 'Квалификация сделки',
  'chat.qualification.summary': 'Подтверждено {confirmed} из {total}',
  'chat.qualification.status_missing_hint': 'В переписке явно указано, что данных нет',
  'chat.qualification.apply': 'Применить',
  'chat.qualification.decline': 'Отклонить',
  'chat.qualification.status_pending': 'Подтверждение получено, проверяем выполнение…',
  'chat.qualification.status_executed': 'Квалификация обновлена',
  'chat.qualification.status_declined': 'Предложение отклонено — квалификация не изменена',
  'chat.qualification.executed_at': 'в {time}',
  'chat.qualification.evidence_label': 'источник: {text}',
  'chat.qualification.evidence_show': 'показать',
  'chat.qualification.evidence_hide': 'скрыть',
  'chat.qualification.read_only': 'Только чтение',
  'chat.qualification.status_llm': 'Не удалось извлечь квалификацию, попробуйте позже',
  'chat.qualification.status_no_deal': 'Сделка не найдена или недоступна',
  'chat.meeting_outcome.prepare_follow_up': 'Подготовить follow-up',
  'chat.meeting_outcome.prepare_followup_command': 'Подготовь follow-up по итогам разбора встречи',
  'ai_chat.session_sidebar.new_chat': 'Новый чат',
  'ai_chat.session_sidebar.search_placeholder': 'Поиск по чатам...',
  'ai_chat.session_sidebar.recent_chats': 'Недавние чаты',
  'ai_chat.session_sidebar.group_today': 'Сегодня',
  'ai_chat.session_sidebar.group_yesterday': 'Вчера',
  'ai_chat.session_sidebar.group_last_7_days': 'Предыдущие 7 дней',
  'ai_chat.session_sidebar.group_last_30_days': 'Предыдущие 30 дней',
  'ai_chat.session_sidebar.group_this_week': 'На этой неделе',
  'ai_chat.session_sidebar.group_earlier': 'Ранее',
  'ai_chat.session_sidebar.no_matches': 'Ничего не найдено',
  'ai_chat.session_sidebar.no_chats': 'История диалогов пуста',
  'ai_chat.session_sidebar.empty_history': 'История диалогов пуста',
  'ai_chat.session_sidebar.context_deal': 'Сделка',
  'ai_chat.session_sidebar.context_contact': 'Контакт',
  'ai_chat.session_sidebar.context_general': 'Общий чат',
  'ai_chat.session_sidebar.untitled_chat': 'Новый диалог',
  'ai_chat.session_sidebar.delete_confirm_title': 'Удалить этот чат?',
  'ai_chat.session_sidebar.yes': 'Да',
  'ai_chat.session_sidebar.no': 'Нет',
  'ai_chat.session_sidebar.delete_chat': 'Удалить чат',
  'ai_chat.session_sidebar.rename_chat': 'Переименовать чат',
  'ai_chat.session_sidebar.rename_failed': 'Не удалось переименовать чат',
  'ai_chat.session_sidebar.demo_scenarios': 'Демо-сценарии',
  'ai_chat.session_sidebar.engine_ready': 'Движок готов',
  'ai_chat.right_panel.title': 'Детали запуска',
  'ai_chat.right_panel.session_outcomes': 'Выполнено в CRM',
  'ai_chat.right_panel.outcome_contact_created': 'Создан контакт: {name}',
  'ai_chat.right_panel.outcome_contact_updated': 'Обновлен контакт: {name}',
  'ai_chat.right_panel.outcome_deal_created': 'Создана сделка: {title}',
  'ai_chat.right_panel.outcome_deal_stage_changed': 'Сделка {title}: новый этап {stage}',
  'ai_chat.right_panel.outcome_appointment_created': 'Назначена встреча: {title}',
  'ai_chat.right_panel.outcome_task_created': 'Создана задача: {title}',
  'ai_chat.right_panel.outcome_interaction_logged': 'Записано взаимодействие: {title}',
  'ai_chat.right_panel.via_action_plan': 'В рамках CRM-плана',
  'ai_chat.right_panel.view_entity': 'Открыть',
  'ai_chat.right_panel.user_request': 'Запрос пользователя',
  'ai_chat.right_panel.view_artifact': 'Открыть артефакт',
  'ai_chat.overlay.deal_details': 'Детали сделки',
  'ai_chat.overlay.open_contact': 'Посмотреть контакт',
  'ai_chat.overlay.open_deal': 'Посмотреть сделку',
  'ai_chat.action_plan.view_contact': 'Посмотреть контакт',
  'ai_chat.action_plan.view_deal': 'Посмотреть сделку',
  'ai_chat.action_plan.title': 'Запрошенные действия',
  'ai_chat.action_plan.approve': 'Подтвердить действие',
  'ai_chat.action_plan.reject': 'Отклонить',
  'ai_chat.action_plan.undo': 'Отменить результат',
  'ai_chat.action_plan.empty_value': '—',
  'ai_chat.action_plan.blocked_dependency': 'Станет доступно после предыдущего действия.',
  'ai_chat.action_plan.stale_details': 'Данные изменились с момента составления плана',
  'ai_chat.action_plan.error.duplicate_email':
    'Контакт с таким email уже существует — укажите другой адрес',
  'ai_chat.action_plan.error.duplicate_phone':
    'Контакт с таким телефоном уже существует — укажите другой номер',
  'ai_chat.action_plan.error.duplicate': 'Такая запись уже существует',
  'ai_chat.action_plan.error.validation':
    'Данные не прошли проверку: проверьте телефон (международный формат) и обязательные поля',
  'ai_chat.action_plan.error.handler':
    'Не удалось выполнить действие — измените данные или попробуйте ещё раз',
  'ai_chat.action_plan.error.dependency':
    'Шаг не выполнен, потому что предыдущее действие не прошло',
  'ai_chat.action_plan.error.stale':
    'Запись изменилась после подготовки плана — попросите ассистента обновить его',
  'ai_chat.action_plan.decide_failed':
    'Не удалось применить решение по пункту плана. Попробуйте ещё раз.',
  'ai_chat.action_plan.undo_failed': 'Не удалось отменить действие. Попробуйте ещё раз.',
  'ai_chat.action_plan.action.create_company': 'Создать компанию',
  'ai_chat.action_plan.action.create_contact': 'Создать контакт',
  'ai_chat.action_plan.action.create_deal': 'Создать сделку',
  'ai_chat.action_plan.action.create_task': 'Создать задачу',
  'ai_chat.action_plan.action.create_calendar_event': 'Создать событие календаря',
  'ai_chat.action_plan.action.create_contact_interaction': 'Записать взаимодействие с контактом',
  'ai_chat.action_plan.action.unspecified': 'Действие в CRM',
  'ai_chat.action_plan.entity.company': 'Компания',
  'ai_chat.action_plan.entity.contact': 'Контакт',
  'ai_chat.action_plan.entity.deal': 'Сделка',
  'ai_chat.action_plan.entity.task': 'Задача',
  'ai_chat.action_plan.entity.note': 'Заметка',
  'ai_chat.action_plan.entity.calendar_event': 'Встреча',
  'ai_chat.action_plan.entity.contact_interaction': 'Взаимодействие',
  'ai_chat.action_plan.status.blocked': 'Заблокировано',
  'ai_chat.action_plan.status.pending': 'Ожидает подтверждения',
  'ai_chat.action_plan.status.approved': 'Подтверждено',
  'ai_chat.action_plan.status.rejected': 'Отклонено',
  'ai_chat.action_plan.status.succeeded': 'Выполнено',
  'ai_chat.action_plan.status.failed': 'Ошибка',
  'ai_chat.action_plan.status.cancelled': 'Отменено',
  'ai_chat.action_plan.status.undo_pending': 'Отменяется',
  'ai_chat.action_plan.status.undone': 'Отменено',
  'ai_chat.action_plan.status.stale': 'Устарело',
  'ai_chat.action_plan.field.name': 'Название',
  'ai_chat.action_plan.field.first_name': 'Имя',
  'ai_chat.action_plan.field.last_name': 'Фамилия',
  'ai_chat.action_plan.field.phone': 'Телефон',
  'ai_chat.action_plan.field.email': 'Email',
  'ai_chat.action_plan.field.title': 'Заголовок',
  'ai_chat.action_plan.field.amount': 'Сумма',
  'ai_chat.action_plan.field.stage': 'Стадия',
  'ai_chat.action_plan.field.company': 'Компания',
  'ai_chat.action_plan.field.contact': 'Контакт',
  'ai_chat.action_plan.field.deal': 'Сделка',
  'ai_chat.action_plan.field.due_at': 'Срок',
  'ai_chat.action_plan.field.description': 'Описание',
  'ai_chat.action_plan.field.priority': 'Приоритет',
  'ai_chat.action_plan.field.starts_at': 'Начало',
  'ai_chat.action_plan.field.ends_at': 'Окончание',
  'ai_chat.action_plan.field.timezone': 'Часовой пояс',
  'ai_chat.action_plan.field.location': 'Место',
  'ai_chat.action_plan.field.type': 'Тип',
  'ai_chat.action_plan.field.subject': 'Тема',
  'ai_chat.action_plan.field.body': 'Содержание',
  'ai_chat.action_plan.field.channel': 'Канал',
  'ai_chat.action_plan.field.occurred_at': 'Когда',
  'ai_chat.right_panel.activities': 'Активности',
  'ai_chat.right_panel.no_activities': 'Активностей пока нет',
  'ai_chat.right_panel.empty_activities': 'Активностей пока нет',
  'ai_chat.right_panel.checkpoints': 'Контрольные точки',
  'ai_chat.right_panel.artifacts': 'Артефакты',
  'ai_chat.right_panel.no_artifacts': 'Артефакты пока не созданы',
  'ai_chat.right_panel.details': 'Детали диалога',
  'ai_chat.right_panel.toggle_panel': 'Панель деталей',
  'ai_chat.right_panel.user_prompt': 'Запрос пользователя',
  'ai_chat.right_panel.tool_call': 'Вызов инструмента',
  'ai_chat.right_panel.agent_response': 'Ответ агента',
  'ai_chat.right_panel.approval_required': 'Требуется подтверждение',
  'ai_chat.right_panel.turn_title': 'Шаг диалога',
  'ai_chat.right_panel.tools_executed': {
    one: 'инструмент выполнен',
    few: 'инструмента выполнено',
    many: 'инструментов выполнено',
    other: 'инструментов выполнено',
  },
  'ai_chat.right_panel.business_scenarios': 'Рекомендуемые сценарии',
  'ai_chat.right_panel.active_context': 'Активный контекст',
  'ai_chat.right_panel.scenario_my_day': '☀️ Мой день',
  'ai_chat.right_panel.scenario_my_day_desc': 'Встречи, задачи, горячие лиды и сделки с риском',
  'ai_chat.right_panel.scenario_hot_leads': '🔥 Горячие лиды на сегодня',
  'ai_chat.right_panel.scenario_hot_leads_desc':
    'Найти сделки без активностей и предложить follow-up',
  'ai_chat.right_panel.scenario_deal_risks': '⚠️ Аудит рисков воронки',
  'ai_chat.right_panel.scenario_deal_risks_desc':
    'Проверить зависшие этапы и риски потери клиентов',
  'ai_chat.right_panel.scenario_follow_up': '✉️ Черновики Follow-up',
  'ai_chat.right_panel.scenario_follow_up_desc':
    'Сформировать персональные письма без автоотправки',
  'ai_chat.right_panel.scenario_daily_plan': '📋 План задач на день',
  'ai_chat.right_panel.scenario_daily_plan_desc': 'Собрать и приоритизировать задачи менеджера',
  'ai_chat.right_panel.scenario_extract_tasks': '✨ Извлечь задачи из заметки',
  'ai_chat.right_panel.scenario_extract_tasks_desc':
    'Сформировать задачи и интерактивный план из заметки',
  'ai_chat.right_panel.context_overdue_tasks': {
    one: 'Разобрать просроченную задачу — {count}',
    few: 'Разобрать просроченные задачи — {count}',
    many: 'Разобрать просроченные задачи — {count}',
    other: 'Разобрать просроченные задачи — {count}',
  },
  'ai_chat.right_panel.context_overdue_tasks_desc':
    'Показать задачи и предложить порядок выполнения',
  'ai_chat.right_panel.context_risk_deals': {
    one: 'Проверить сделку с риском — {count}',
    few: 'Проверить сделки с риском — {count}',
    many: 'Проверить сделки с риском — {count}',
    other: 'Проверить сделки с риском — {count}',
  },
  'ai_chat.right_panel.context_risk_deals_desc': 'Предложить безопасные следующие шаги по сделкам',
  'ai_chat.right_panel.context_hot_leads': {
    one: 'Подготовить follow-up для горячего лида — {count}',
    few: 'Подготовить follow-up для горячих лидов — {count}',
    many: 'Подготовить follow-up для горячих лидов — {count}',
    other: 'Подготовить follow-up для горячих лидов — {count}',
  },
  'ai_chat.right_panel.context_hot_leads_desc': 'Сформировать письма без автоматической отправки',
  'ai_chat.overlay.deal_title': 'Просмотр сделки',
  'ai_chat.overlay.contact_title': 'Просмотр контакта',
  'ai_chat.overlay.contact_details': 'Детали контакта',
  'ai_chat.overlay.empty_details': 'Детали не выбраны',
  'ai_chat.overlay.open_full_page': 'Открыть карточку',
  'ai_chat.overlay.load_failed': 'Не удалось загрузить данные',
  'ai_chat.overlay.stage': 'Стадия',
  'ai_chat.overlay.amount': 'Сумма',
  'ai_chat.overlay.company': 'Компания',
  'ai_chat.overlay.contact': 'Контактное лицо',
  'ai_chat.overlay.next_step': 'Следующий шаг',
  'ai_chat.overlay.close': 'Закрыть',
  'ai_chat.overlay.probability': 'Вероятность',
  'ai_chat.overlay.created_at': 'Создано',
  'ai_chat.overlay.expected_close': 'Плановое закрытие',
  'ai_chat.overlay.manager': 'Ответственный',
  'ai_chat.overlay.source': 'Источник',
  'ai_chat.overlay.quick_actions': 'Действия с AI',
  'ai_chat.overlay.action_audit_risk': 'Оценить риск сделки',
  'ai_chat.overlay.action_draft_email': 'Подготовить follow-up',
  'ai_chat.overlay.action_create_tasks': 'Сформировать задачи',
  'ai_chat.overlay.action_email': 'Письмо',
  'ai_chat.overlay.action_note': 'Заметка',
  'ai_chat.overlay.action_task': 'Задача',
  'ai_chat.overlay.action_call': 'Звонок',
  'ai_chat.overlay.general_info': 'Общая информация',
  'ai_chat.overlay.additional': 'Дополнительно',
  'ai_chat.overlay.created_label': 'Создано:',
  'ai_chat.overlay.open_full_card': 'Открыть полную карточку',
  'ai_chat.overlay.open_contact_profile': 'Открыть профиль контакта',
  'ai_chat.overlay.contacts': 'Контакты',
  'ai_chat.overlay.phone': 'Телефон',
  'ai_chat.overlay.email': 'Email',
  'ai_chat.tool_calls.actions_done': '{count} действий выполнено',
  'ai_chat.tool_calls.steps': '{count} шагов агента',
  'ai_chat.tool_calls.errors': 'ошибок: {count}',
  'ai_chat.agent.responding': 'Отвечает:',
  'ai_chat.agent.chat_assistant': 'Ассистент CRM',
  'ai_chat.agent.deal_specialist': 'Deal-специалист',
  'ai_chat.agent.tasks_specialist': 'Tasks/Calendar-специалист',
  'ai_chat.agent.views_builder': 'Специалист по представлениям',
  'ai_chat.actions.pin_note_prompt': 'Прикрепи выбранный ответ заметкой к выбранной сделке.',
  'ai_chat.actions.create_tasks_prompt': 'Сформируй задачи в CRM на основе выбранного ответа.',
  'ai_chat.actions.dashboard_prompt': 'Создай виджет на дашборде на основе выбранного ответа.',
  'ai_chat.overlay.recent_notes': 'Заметки и активности',
  'ai_chat.overlay.no_notes': 'Заметок пока нет',
  'ai_chat.widget.collapse': 'Свернуть',
  'ai_chat.widget.expand': 'Подробнее',
  'ai_chat.widget.tool_executed': 'Выполнен инструмент',
  'ai_chat.suggestions.hot_leads': '🔥 Горячие лиды',
  'ai_chat.suggestions.risk_audit': '⚠️ Аудит рисков',
  'ai_chat.suggestions.follow_up': '✉️ Follow-up письмо',
  'ai_chat.suggestions.daily_tasks': '📋 Задачи на день',
  'ai_chat.suggestions.extract_tasks': '✨ Извлечь задачи',
  'ai_chat.welcome.title': 'Чем помочь вашему бизнесу сегодня?',
  'ai_chat.welcome.try_asking': 'Попробуйте спросить',
  'ai_chat.welcome.subtitle':
    'Интеллектуальный ассистент GovardOS готов анализировать воронку, писать письма и контролировать риски',
  'ai_chat.welcome.pipeline_audit_title': 'Экспресс-аудит воронки',
  'ai_chat.welcome.pipeline_audit_desc':
    'Найти зависшие этапы, оценить вероятность и риски потери клиентов',
  'ai_chat.welcome.hot_leads_title': 'Горячие лиды на сегодня',
  'ai_chat.welcome.hot_leads_desc':
    'Клиенты без активностей, готовые к закрытию и повторному звонку',
  'ai_chat.welcome.follow_up_title': 'Генератор Follow-up писем',
  'ai_chat.welcome.follow_up_desc':
    'Персонализированные черновики для отправки без автоматических рассылок',
  'ai_chat.welcome.manager_brief_title': 'Экспресс-сводка РОПа',
  'ai_chat.welcome.manager_brief_desc': 'Сводка продаж, рисков и приоритетов для руководителя',
  'ai_chat.slash.title': 'Быстрые команды',
  'ai_chat.slash.hint_prefix': 'введите',
  'ai_chat.slash.hint_suffix': 'в строке ввода',
  'ai_chat.slash.lead': 'Найти горячих лидов на сегодня',
  'ai_chat.slash.risk': 'Провести аудит рисков воронки',
  'ai_chat.slash.email': 'Подготовить черновик follow-up',
  'ai_chat.slash.task': 'Сформировать задачи на сегодня',
  'ai_chat.slash.brief': 'Сформировать экспресс-сводку РОПа',
  'ai_chat.right_panel.active_deal_default': 'Сделка в работе',
  'ai_chat.right_panel.active_contact_default': 'Контакт',
  'ai_chat.right_panel.active_risk_deal_default': 'Сделка в фокусе',
  'ai_chat.prompt.hot_leads': 'Найди горячих лидов на сегодня и предложи план действий',
  'ai_chat.prompt.my_day': 'Собери мой день',
  'ai_chat.prompt.my_day_meetings':
    'Подготовь меня к сегодняшним встречам из открытого обзора «Мой день»: составь короткий read-only план подготовки по каждой встрече (время, связанная сделка и контакт, если указаны) и не придумывай отсутствующие данные; ничего не создавай и не изменяй в CRM',
  'ai_chat.meetings_prep.title': 'Подготовка ко встречам сегодня ({count}):',
  'ai_chat.meetings_prep.no_meetings': 'Сегодня встреч нет. Данные CRM не изменялись.',
  'ai_chat.meetings_prep.load_error':
    'Не удалось получить встречи из сводки дня. Данные CRM не изменялись.',
  'ai_chat.meetings_prep.meeting_line': '{index}. «{title}» — {interval}.',
  'ai_chat.meetings_prep.linked': 'Связь: {links}.',
  'ai_chat.meetings_prep.linked_none': 'связанная сделка или контакт не указаны',
  'ai_chat.meetings_prep.linked_deal': 'сделка «{title}»',
  'ai_chat.meetings_prep.linked_contact': 'контакт {name}',
  'ai_chat.meetings_prep.goals_title': 'Цели разговора:',
  'ai_chat.meetings_prep.goal1': 'уточнить текущую ситуацию и ожидания клиента',
  'ai_chat.meetings_prep.goal2': 'обсудить следующие шаги и сроки',
  'ai_chat.meetings_prep.goal3': 'зафиксировать договорённости и записать итог в CRM после встречи',
  'ai_chat.meetings_prep.no_crm_changes': 'Данные CRM не изменялись.',
  'ai_chat.meetings_prep.interval_unavailable': 'время не указано',
  'ai_chat.prompt.my_day_overdue_tasks':
    'Разбери просроченные задачи из моего обзора и предложи порядок выполнения',
  'ai_chat.prompt.my_day_risk_deals':
    'Проверь сделки с риском из моего обзора и предложи безопасные следующие шаги',
  'ai_chat.prompt.my_day_hot_leads':
    'Подготовь follow-up план по горячим лидам из моего обзора без отправки писем',
  'ai_chat.prompt.deal_risks': 'Проанализируй риски по текущим сделкам в воронке',
  'ai_chat.prompt.pipeline_audit': 'Проанализируй риски и зависшие сделки в текущей воронке',
  'ai_chat.prompt.follow_up':
    'Подготовь персонализированные follow-up письма клиентам без отправки',
  'ai_chat.prompt.daily_plan': 'Собери план задач на сегодня и приоритизируй действия менеджера',
  'ai_chat.prompt.extract_tasks': 'Извлеки задачи из этой заметки и сформируй план действий',
  'ai_chat.prompt.executive_brief':
    'Сформируй экспресс-сводку руководителя по текущим сделкам и конверсии',
  'ai_chat.actions.pin_note': 'Прикрепить заметкой к сделке',
  'ai_chat.actions.create_tasks': 'Сформировать задачи',
  'ai_chat.actions.dashboard': 'На дашборд',
  'ai_chat.actions.copy': 'Скопировать ответ',
  'ai_chat.actions.copied': 'Скопировано в буфер',
  'ai_chat.actions.remember': 'Запомнить',
  'ai_chat.actions.remembered': 'Сохранено',
  'ai_chat.actions.regenerate': 'Перегенерировать',
  'ai_chat.actions.edit': 'Редактировать',
  'ai_chat.actions.save': 'Сохранить',
  'ai_chat.actions.cancel': 'Отмена',
  'ai_chat.show_deal_cockpit': 'Показать Deal Cockpit',
  'ai_chat.all_tasks': 'Все задачи',
  'ai_chat.task_details': 'Детали задачи',
  'ai_chat.execution_stream': 'Задача #{id} · Поток выполнения AI',
  'ai_chat.feedback_placeholder':
    'Оставьте обратную связь для агента — ваши комментарии повлияют на следующий запуск...',
  'ai_chat.send_feedback': 'Отправить обратную связь',
  'ai_chat.task_board.open_scenario': 'Открыть сценарий',
  'ai_chat.task_board.loading': 'Загрузка задач...',
  'ai_chat.task_board.in_progress': 'В работе',
  'ai_chat.task_board.pending_review': 'Ожидает проверки',
  'ai_chat.task_board.history': 'История задач / Бэклог',
  'ai_chat.task_board.no_archived_tasks': 'Архивных задач нет',
  'ai_chat.task_board.brief': 'Сводка',
  'ai_chat.task_board.default_brief': 'Сводка и заметки о выполнении агентом',
  'ai_chat.task_board.delete_title': 'Удалить задачу?',
  'ai_chat.task_board.delete': 'Удалить задачу',
  'ai_chat.task_board.yes': 'Да',
  'ai_chat.task_board.no': 'Нет',
  'ai_chat.task_board.screenshot_data': 'демо-данные',
  'ai_chat.task_input.fill_demo': 'Заполнить демо-запрос для скриншота',
  'ai_chat.task_input.file': 'Файл',
  'ai_chat.task_input.placeholder':
    'Введите задачу или инструкцию... Используйте @ для упоминания контактов или сделок',
  'ai_chat.task_input.attach_context_file': 'Прикрепить файл с контекстом CRM',
  'ai_chat.task_input.attach_file': 'Прикрепить файл',
  'ai_chat.task_input.web_search': 'Поиск в интернете',
  'ai_chat.task_input.toggle_web_search': 'Переключить поиск в интернете',
  'ai_chat.task_input.agent_tools': 'Инструменты агента',
  'ai_chat.task_input.toggle_agent_tools': 'Переключить инструменты агента',
  'ai_chat.task_input.tool.deal_risk': 'Риск сделки',
  'ai_chat.task_input.tool.follow_up': 'Черновик follow-up',
  'ai_chat.task_input.web_search_enabled': 'Web search включён',
  'ai_chat.task_input.prompt.deal_risk': 'Проверь риск сделки и предложи следующий шаг',
  'ai_chat.task_input.prompt.follow_up': 'Подготовь follow-up письмо без отправки',
  'ai_chat.task_input.prompt.risk_analysis': 'Анализ рисков по текущим сделкам',
  'ai_chat.task_input.prompt.hot_leads': 'Покажи горячие лиды за последнюю неделю',
  'ai_chat.task_input.prompt.action_plan': 'Составь план действий для новых клиентов',
  'ai_chat.task_input.suggestion.risk_analysis': 'Анализ рисков сделок',
  'ai_chat.task_input.suggestion.hot_leads': 'Горячие лиды',
  'ai_chat.task_input.suggestion.action_plan': 'План действий CRM',
  'ai_chat.artifact.copied': 'Скопировано',
  'ai_chat.artifact.copy': 'Копировать',
  'ai_chat.artifact.export': 'Экспорт',
  'ai_chat.artifact.preview': 'Предпросмотр',
  'ai_chat.artifact.source': 'Исходный код',
  'ai_chat.artifact.type_label': 'Артефакт {type}',
  'ai_chat.artifact.close_canvas': 'Закрыть холст',
  'ai_chat.artifact.html_preview': 'Предпросмотр HTML',
  'ai_chat.artifact.type_doc': 'Документ Markdown',
  'ai_chat.artifact.type_html': 'HTML Виджет',
  'ai_chat.artifact.type_mermaid': 'Диаграмма процессов',
  'ai_chat.artifact.type_todo': 'Чек-лист задач',
  'ai_chat.artifact.lines': 'строк',
  'ai_chat.artifact.download': 'Скачать файл',
  'ai_chat.artifact.open_side_canvas': 'Открыть в боковом холсте',
  'ai_chat.artifact.open_in_canvas_mode': 'Развернуть на полный холст',
  'ai_chat.artifact.expand': 'Развернуть',
  'ai_chat.artifact.collapse': 'Свернуть',
  'ai_chat.artifact.no_tasks': 'В артефакте не найдено задач.',
  'ai_chat.artifact.extraction_failed':
    'Не удалось извлечь проверенные предложения задач из артефакта. Задачи не созданы.',
  'ai_chat.artifact.truncated': '[обрезано: {kept} из {total} символов]',
  'ai_chat.artifact.attach_note': 'Сохранить как заметку',
  'ai_chat.artifact.create_crm_tasks': 'Сформировать задачи в CRM',
  'ai_chat.artifact.action_note_prefix': 'Сохрани этот артефакт в виде заметки к сделке',
  'ai_chat.artifact.action_tasks_prefix': 'Сформируй задачи в CRM на основе артефакта',
  'ai_chat.common.open_canvas': 'Открыть в холсте',
  'ai_chat.todo.default_title': 'План выполнения задач',
  'ai_chat.todo.progress': 'Прогресс выполнения',
  'ai_chat.todo.completed_count': '{completed} из {total} ({percent}%)',
  'ai_chat.mermaid.default_title': 'Диаграмма процесса CRM',
  'ai_chat.mermaid.render_error': 'Не удалось отрисовать Mermaid-диаграмму',
  'ai_chat.mermaid.code': 'Код',
  'ai_chat.mermaid.syntax_error': 'Ошибка синтаксиса Mermaid',
  'ai_chat.demo_cockpit.state.pinned': 'В панели',
  'ai_chat.demo_cockpit.title': 'Пульт сделки',
  'ai_chat.demo_cockpit.short_mode': 'Краткий режим',
  'ai_chat.demo_cockpit.state.floating': 'Плавающий',
  'ai_chat.demo_cockpit.actions.expand': 'Развернуть Deal Cockpit',
  'ai_chat.demo_cockpit.actions.collapse': 'Свернуть Deal Cockpit',
  'ai_chat.demo_cockpit.actions.full': 'Открыть Deal Cockpit полностью',
  'ai_chat.demo_cockpit.actions.unpin_hint': 'Открепить виджет и сделать плавающим',
  'ai_chat.demo_cockpit.actions.pin_hint': 'Закрепить виджет в панели',
  'ai_chat.demo_cockpit.actions.unpin': 'Открепить виджет',
  'ai_chat.demo_cockpit.actions.pin': 'Закрепить виджет',
  'ai_chat.demo_cockpit.actions.hide': 'Скрыть виджет',
  'ai_chat.demo_cockpit.sections.health': 'Состояние сделки',
  'ai_chat.demo_cockpit.sections.next_step': 'Следующий шаг',
  'ai_chat.demo_cockpit.sections.next_action': 'Следующее действие',
  'ai_chat.demo_cockpit.sections.activity_signal': 'Сигнал активности',
  'ai_chat.demo_cockpit.sections.best_next_step': 'Лучший следующий шаг',
  'ai_chat.demo_cockpit.sections.tasks': 'Задачи',
  'ai_chat.demo_cockpit.metrics.amount': 'Сумма',
  'ai_chat.demo_cockpit.metrics.tasks': 'Задачи',
  'ai_chat.demo_cockpit.metrics.open_tasks': '{count} открыто',
  'ai_chat.demo_cockpit.metrics.overdue': 'Просрочено',
  'ai_chat.demo_cockpit.activity.next': 'Следующая активность',
  'ai_chat.demo_cockpit.activity.last': 'Последняя активность',
  'ai_chat.demo_cockpit.priority.low': 'Низкий',
  'ai_chat.demo_cockpit.priority.medium': 'Средний',
  'ai_chat.demo_cockpit.priority.high': 'Высокий',
  'ai_chat.demo_cockpit.disclaimer':
    'Локальная демо-подменка для скриншотов. Данные CRM не изменяются.',
  'ai_chat.task_brief.checklist.request': 'Понять запрос менеджера',
  'ai_chat.task_brief.checklist.context': 'Проверить CRM-контекст',
  'ai_chat.task_brief.checklist.artifact': 'Собрать полезный артефакт',
  'ai_chat.task_brief.checklist.approval': 'Оставить изменения за approval',
  'ai_chat.task_brief.default_artifact_title': 'Карта агентного процесса',
  'ai_chat.task_brief.default_artifact_content':
    'graph TD\nA[Запрос]-->B[CRM tools]\nB-->C[Артефакт]\nC-->D[Approval]',
  'ai_chat.task_brief.default_summary':
    'Агент готовит CRM-результат: анализирует запрос, собирает контекст и показывает безопасный следующий шаг.',
  'ai_chat.task_brief.task_number': 'Задача №{id}',
  'ai_chat.task_brief.in_progress': 'В работе',
  'ai_chat.task_brief.stop': 'Остановить задачу',
  'ai_chat.task_brief.requirements': 'Требования и контекст',
  'ai_chat.task_brief.instructions': 'Инструкции',
  'ai_chat.task_brief.add_subtask': 'Добавить подзадачу',
  'ai_chat.task_brief.artifacts': 'Артефакты',
  'ai_chat.task_brief.activities': 'Активность',
  'ai_chat.task_brief.created_by_user': 'Задача создана пользователем',
  'ai_chat.task_brief.just_now': 'Только что',
  'ai_chat.task_brief.agent_started': 'Агент запустил выполнение',
  'ai_chat.task_brief.seconds_ago': '{count} сек. назад',
  'ai_chat.typing': 'AI думает...',
  'ai_chat.auto_approve.label': 'Автоподтверждение',
  'ai_chat.auto_approve.tooltip':
    'Автоматически подтверждать безопасные действия агента (заметки, связи). Деструктивные действия всегда требуют подтверждения.',
  'ai_chat.auto_approve.update_failed': 'Не удалось изменить настройку автоподтверждения',
  'ai_chat.tool_debug.label': 'Отладка инструментов',
  'ai_chat.tool_debug.hint':
    'Для рабочей команды: показывать технические вызовы инструментов и их аргументы. Обычным пользователям это не нужно.',
  'ai_chat.composer.hint_enter': 'Enter — отправить · Shift+Enter — новая строка',
  'ai_chat.composer.slash_hint': '/ — команды',
  'ai_chat.composer.attach_file': 'Прикрепить файл',
  'ai_chat.composer.drop_file_here': 'Перетащите файл сюда',
  'ai_chat.context_chips.attach': 'Прикрепить сущность',
  'ai_chat.context_chips.search': 'Поиск...',
  'ai_chat.context_chips.empty': 'Ничего не найдено',
  'ai_chat.context_chips.remove': 'Убрать',
  'ai_chat.context_chips.max_reached': 'Максимум 8 сущностей',
  'ai_chat.context_chips.back': 'Назад',
  'ai_chat.context_chips.deal': 'Сделка',
  'ai_chat.context_chips.contact': 'Контакт',
  'ai_chat.context_chips.company': 'Компания',
  'ai_chat.context_chips.task': 'Задача',
  'ai_chat.context_chips.note': 'Заметка',
  'ai_chat.context_chips.user': 'Пользователь',
  'ai_chat.mention.placeholder': 'Упомянуть сущность',
  'ai_chat.mention.empty': 'Ничего не найдено',
  'ai_chat.model_selector.label': 'Модель и шлюз',
  'ai_chat.model_selector.choose_available': 'Выберите рабочую модель',
  'ai_chat.model_selector.unavailable_hint':
    'Этот провайдер сейчас недоступен. Выберите OpenRouter или OpenCode, чтобы продолжить диалог.',
  'ai_chat.model_selector.provider': 'Провайдер',
  'ai_chat.model_selector.model': 'Модель',
  'ai_chat.model_selector.neuraldeep': 'NeuralDeep · РФ',
  'ai_chat.model_selector.openrouter': 'OpenRouter',
  'ai_chat.model_selector.badge.deepseek/deepseek-v4.1-flash': 'Дёшево',
  'ai_chat.model_selector.badge.google/gemini-3.5-flash-lite': 'Быстро',
  'ai_chat.model_selector.badge.openai/gpt-5.6-terra': 'Баланс',
  'ai_chat.model_selector.badge.~deepseek/deepseek-v4-flash-latest': 'Дёшево',
  'ai_chat.model_selector.badge.minimax/minimax-m3': 'Дёшево',
  'ai_chat.model_selector.badge.openai/gpt-5.4-mini': 'Качество',
  'ai_chat.model_selector.opencode': 'OpenCode Zen · Space Bunny',
  'ai_chat.model_selector.govard': 'Govard · DeepSeek v4.1 Flash',
  'ai_chat.error.title': 'Ошибка ответа',
  'ai_chat.error.retry': 'Повторить',
  'ai_chat.error.cancelled_recoverable':
    'Ответ остановлен. Исход не подтверждён — повтор безопасно проверит состояние.',
  'ai_chat.error.unconfirmed_outcome':
    'Результат запроса не подтверждён: связь оборвалась, и изменения в CRM могли уже начаться. Повтор проверит состояние и возобновит исходный запрос.',
  'ai_chat.error.indeterminate_result':
    'Повтор вернул ту же ошибку сервера, а результат хода остаётся неопределённым: система могла успеть сохранить изменение. Проверьте CRM, прежде чем отправлять запрос заново.',
  'ai_chat.error.cancelled_outcome':
    'Запрос отменён. Результат не подтверждён: изменения могли уже начаться — проверьте CRM, прежде чем отправлять запрос заново.',
  'ai_chat.error.deadline_exceeded':
    'Не успел ответить за отведённое время. Попробуйте упростить запрос или разбить его на части.',
  'ai_chat.error.approval_decide_failed':
    'Не удалось применить решение по подтверждению. Попробуйте ещё раз.',
  'ai_chat.error.request_failed': 'Не удалось выполнить запрос чата',
  'ai_chat.error.turn_failed': 'Не удалось завершить ответ чата',
  'ai_chat.error.not_ready': 'Ассистент ещё не готов — попробуйте секунду спустя',
  'ai_chat.error.busy': 'Ассистент ещё отвечает — дождитесь окончания хода',
  'ai_chat.client_action.applied': 'Открываю по запросу ассистента',
  'ai_chat.client_action.unsupported':
    'Ассистент предложил переход, который пока не поддерживается',
  'ai_chat.cockpit.title': 'AI-ассистент',
  'ai_chat.cockpit.context_none': 'Текущий раздел',
  'ai_chat.cockpit.context_value': '{type}: {value}',
  'ai_chat.cockpit.close': 'Закрыть ассистента',
  'ai_chat.cockpit.actions_group_label': 'Быстрые действия',
  'ai_chat.cockpit.local_action_applied': 'Применяю выбранное действие',
  'ai_chat.cockpit.view.kanban': 'Канбан',
  'ai_chat.cockpit.view.list': 'Список',
  'ai_chat.cockpit.view.cards': 'Карточки',
  'ai_chat.cockpit.filter.deals': 'Со сделками',
  'ai_chat.cockpit.filter.email': 'С email',
  'ai_chat.cockpit.navigate.deals': 'К сделкам',
  'ai_chat.cockpit.navigate.contacts': 'К контактам',
  'ai_chat.reasoning.thinking': 'Думает...',
  'ai_chat.reasoning.thinking_elapsed': 'Думает... {seconds}с',
  'ai_chat.markdown.mermaid_loading': 'Диаграмма Mermaid отрисовывается…',
  'ai_chat.markdown.table_scroll': 'Таблица ответа (горизонтальная прокрутка)',
  'ai_chat.error.copy_failed': 'Не удалось скопировать текст',
  'ai_chat.error.remember_failed': 'Не удалось сохранить в память',
  'ai_chat.error.upload_failed': 'Не удалось загрузить файл',
  'ai_chat.error.upload_needs_context':
    'Вложения доступны только в чате конкретной сделки или контакта',
  'ai_chat.file_input.conversation_required':
    'Сначала отправьте сообщение — файл можно будет прикрепить к следующему',
  'ai_chat.file_input.attachment.chip': 'Файл: {fileName} · {format}',
  'ai_chat.file_input.pending.label': 'К следующему сообщению: {fileName}',
  'ai_chat.file_input.pending.remove': 'Убрать файл',
  'ai_chat.file_input.preview.title': 'Предпросмотр файла',
  'ai_chat.file_input.preview.rows': {
    one: '{rows} строка',
    few: '{rows} строки',
    many: '{rows} строк',
    other: '{rows} строк',
  },
  'ai_chat.file_input.preview.columns': 'Колонки',
  'ai_chat.file_input.preview.mapping': 'Распознанные поля',
  'ai_chat.file_input.preview.mapping_empty': 'Поля не распознаны',
  'ai_chat.file_input.preview.sample': 'Пример данных',
  'ai_chat.file_input.error.legacy_office':
    'Старый формат Office (.doc/.ppt/.xls) не поддерживается — пересохраните файл в современном формате',
  'ai_chat.file_input.error.image_not_supported':
    'Изображения не поддерживаются как вход ассистента — вставьте текст или прикрепите документ',
  'ai_chat.file_input.error.empty_content': 'Файл пуст или не содержит извлекаемого текста',
  'ai_chat.file_input.error.unsupported_content_type':
    'Формат файла не поддерживается — используйте TXT, MD, CSV, TSV, JSON, PDF, DOCX, PPTX или XLSX',
  'ai_chat.voice_input.start': 'Голосовой ввод',
  'ai_chat.voice_input.stop': 'Остановить запись',
  'ai_chat.voice_input.listening': 'Слушаю вас...',
  'ai_chat.voice_input.unsupported': 'Голосовой ввод не поддерживается в вашем браузере',
  'ai_chat.session_sidebar.pinned_chats': 'Закреплённые диалоги',
  'ai_chat.session_sidebar.pin_chat': 'Закрепить диалог',
  'ai_chat.session_sidebar.unpin_chat': 'Открепить диалог',
  'command_menu.close': 'Закрыть',
  'command_menu.search_placeholder': 'Поиск по сделкам, контактам, задачам и командам...',
  'command_menu.no_results': 'Ничего не найдено',
  'command_menu.navigate': 'Навигация',
  'command_menu.select': 'Выбрать',
  'command_menu.goto_deals': 'Воронка продаж и канбан',
  'command_menu.goto_contacts': 'База клиентов и компаний',
  'command_menu.goto_tasks': 'Задачи и дела',
  'command_menu.goto_meetings': 'Встречи и календарь',
  'command_menu.goto_chat': 'AI-ассистент GovardOS',
  'command_menu.goto_templates': 'Шаблоны писем и документов',
  'command_menu.goto_dashboard': 'Сводка и метрики',
  'command_menu.goto_settings': 'Настройки CRM и профиля',
  'command_menu.create_deal': 'Создать сделку',
  'command_menu.create_deal_desc': 'Добавить новую сделку в воронку',
  'command_menu.create_contact': 'Создать контакт',
  'command_menu.create_contact_desc': 'Добавить клиента в базу',
  'command_menu.switch_language': 'Сменить язык интерфейса',
  'command_menu.hot_leads_desc': 'Найти лиды, требующие внимания',
  'command_menu.risk_audit_desc': 'Аудит зависших сделок',
  'command_menu.follow_up_desc': 'Сгенерировать черновики писем',
  'command_menu.create_task': 'Создать задачу',
  'command_menu.create_task_desc': 'Добавить новую задачу в список дел',
  'command_menu.goto_projects': 'Проекты и командная работа',
  'command_menu.goto_companies': 'Каталог компаний и связей',
  'command_menu.search_results': 'Результаты поиска',
  'command_menu.commands': 'Команды',
  'command_menu.searching': 'Поиск…',
  'command_menu.entity_deal': 'Сделка',
  'command_menu.entity_contact': 'Контакт',
  'command_menu.entity_company': 'Компания',
  'command_menu.entity_task': 'Задача',
  'command_menu.entity_project': 'Проект',
  'deal_health.title': 'Индекс здоровья сделки',
  'deal_health.status_good': 'Отличное',
  'deal_health.status_warning': 'Внимание',
  'deal_health.status_critical': 'Высокий риск',
  'deal_health.desc_good': 'Активность в норме, высокий шанс закрытия сделки.',
  'deal_health.desc_warning': 'Требуется follow-up, контакт не отвечал более 3 дней.',
  'deal_health.desc_critical': 'Зависшая сделка, риск потери клиента.',
  'shortcuts.title': 'Горячие клавиши',
  'shortcuts.subtitle': 'Быстрое управление CRM без мыши',
  'shortcuts.group_global': 'Глобальные',
  'shortcuts.group_navigation': 'Быстрый переход',
  'shortcuts.group_actions': 'Действия',
  'shortcuts.command_menu': 'Командное меню',
  'shortcuts.ai_copilot': 'AI-чат',
  'shortcuts.cheatsheet': 'Шпаргалка хоткеев',
  'shortcuts.goto_deals': 'Перейти в Сделки',
  'shortcuts.goto_contacts': 'Перейти в Контакты',
  'shortcuts.goto_tasks': 'Перейти в Задачи',
  'shortcuts.goto_analytics': 'Перейти к аналитике на дашборде',
  'shortcuts.create_deal': 'Создать сделку',
  'shortcuts.quick_note': 'Быстрая заметка',
  'revenue_goal.title': 'Цель по выручке на месяц',
  'revenue_goal.forecast_title': 'AI Прогноз выполнения плана',
  'revenue_goal.forecast_desc':
    'Прогноз рассчитан на основе текущих сделок в переговорах и конверсии: {amount} ₽',
  'revenue_goal.forecast_badge': 'AI Прогноз',
  'revenue_goal.win_rate': 'Винрейт',
  'smart_tags.hot': 'Горячая',
  'smart_tags.vip': 'VIP',
  'smart_tags.high_value': 'Крупный чек',
  'smart_tags.stalled': 'Зависла',
  'smart_tags.fast_track': 'Быстрый цикл',
  'smart_followup.title': 'Пульс внимания AI',
  'smart_followup.widget_title': 'AI Follow-up Лента',
  'smart_followup.pending_badge': 'требуют связи',
  'smart_followup.days_silent': 'дней без ответа',
  'smart_followup.open_card': 'Открыть карточку сделки',
  'smart_followup.action_btn': 'Follow-up',
  'smart_followup.defaults.stale_1.title': 'Поставка оборудования для сети салонов',
  'smart_followup.defaults.stale_1.contact_name': 'Елена Смирнова',
  'smart_followup.defaults.stale_1.prompt':
    'Напиши вежливый Follow-up Елене Смирновой по сделке на 450 000 ₽ с предложением созвониться на этой неделе.',
  'smart_followup.defaults.stale_2.title': 'Годовой контракт на обслуживание',
  'smart_followup.defaults.stale_2.contact_name': 'Дмитрий Иванов',
  'smart_followup.defaults.stale_2.prompt':
    'Подготовь короткое напоминание Дмитрию Иванову о согласовании коммерческого предложения по годовому обслуживанию.',
  'smart_followup.defaults.stale_3.title': 'Внедрение CRM для филиала',
  'smart_followup.defaults.stale_3.contact_name': 'Анна Кузнецова',
  'smart_followup.defaults.stale_3.prompt':
    'Сгенерируй follow-up Анне Кузнецовой с акцентом на скидку 10% при закрытии сделки до конца месяца.',

  // Projects (roadmap F3-4) — list page.
  'features.features.projects.pages.projectspage.проекты': 'Проекты',
  'features.features.projects.pages.projectspage.подзаголовок':
    'Портфельные работы команды: задачи, заметки и встречи проекта собираются здесь.',
  'features.features.projects.pages.projectspage.новый_проект': 'Новый проект',
  'features.features.projects.pages.projectspage.поиск': 'Поиск проектов',
  'features.features.projects.pages.projectspage.фильтр_по_статусу': 'Статус',
  'features.features.projects.pages.projectspage.не_удалось_загрузить_проекты':
    'Не удалось загрузить проекты',
  'features.features.projects.pages.projectspage.проектов_нет':
    'Проектов нет. Создайте первый кнопкой «Новый проект».',
  'features.features.projects.pages.projectspage.название': 'Название',
  'features.features.projects.pages.projectspage.статус': 'Статус',
  'features.features.projects.pages.projectspage.владелец': 'Владелец',
  'features.features.projects.pages.projectspage.срок': 'Срок',
  'features.features.projects.pages.projectspage.задачи': 'Задачи',
  'features.features.projects.pages.projectspage.всего_проектов': 'Всего проектов',
  'features.features.projects.pages.projectspage.в_работе': 'В работе',
  'features.features.projects.pages.projectspage.завершено': 'Завершено',
  // Projects — form modal.
  'features.features.projects.components.projectformmodal.сохранить': 'Сохранить',
  'features.features.projects.components.projectformmodal.создать_проект': 'Создать проект',
  'features.features.projects.components.projectformmodal.редактировать_проект':
    'Редактировать проект',
  'features.features.projects.components.projectformmodal.новый_проект': 'Новый проект',
  'features.features.projects.components.projectformmodal.название': 'Название',
  'features.features.projects.components.projectformmodal.название_обязательно':
    'Введите название проекта',
  'features.features.projects.components.projectformmodal.статус': 'Статус',
  'features.features.projects.components.projectformmodal.владелец': 'Владелец',
  'features.features.projects.components.projectformmodal.участники': 'Участники',
  'features.features.projects.components.projectformmodal.описание': 'Описание',
  'features.features.projects.components.projectformmodal.начало': 'Начало',
  'features.features.projects.components.projectformmodal.срок': 'Срок',
  // Projects — card page.
  'features.features.projects.pages.projectcardpage.не_удалось_загрузить_проект':
    'Не удалось загрузить проект',
  'features.features.projects.pages.projectcardpage.к_проектам': 'К проектам',
  'features.features.projects.pages.projectcardpage.редактировать': 'Редактировать',
  'features.features.projects.pages.projectcardpage.удалить_проект': 'Удалить проект?',
  'features.features.projects.pages.projectcardpage.задачи_встречи_и_заметки_останутся_но_отвяжутся_от_проекта':
    'Задачи, встречи и заметки останутся, но будут отвязаны от проекта.',
  'features.features.projects.pages.projectcardpage.владелец': 'Владелец',
  'features.features.projects.pages.projectcardpage.начало': 'Начало',
  'features.features.projects.pages.projectcardpage.срок': 'Срок',
  'features.features.projects.pages.projectcardpage.участники': 'Участники',
  'features.features.projects.pages.projectcardpage.задачи': 'Задачи',
  'features.features.projects.pages.projectcardpage.встречи': 'Встречи',
  'features.features.projects.pages.projectcardpage.детали': 'Детали',
  'features.features.projects.pages.projectcardpage.описание': 'Описание',
  'features.features.projects.pages.projectcardpage.описания_нет': 'Описания нет.',
  'features.features.projects.pages.projectcardpage.выберите_участников': 'Выберите участников',
  'features.features.projects.pages.projectcardpage.сохранить': 'Сохранить',
  'features.features.projects.pages.projectcardpage.участников_нет':
    'Участников пока нет — добавьте первого.',
  'features.features.projects.pages.projectcardpage.статус': 'Статус',
  'features.features.projects.pages.projectcardpage.заметки': 'Заметки',
  // Projects — card tabs.
  'features.features.projects.components.projecttaskstab.задачи_проекта': 'Задачи проекта: {p0}',
  'features.features.projects.components.projecttaskstab.новая_задача': 'Новая задача',
  'features.features.projects.components.projecttaskstab.задач_нет':
    'Задач пока нет — создайте первую.',
  'features.features.projects.components.projectnotestab.заметки_проекта': 'Заметки проекта: {p0}',
  'features.features.projects.components.projectnotestab.новая_заметка': 'Новая заметка',
  'features.features.projects.components.projectnotestab.заметок_нет':
    'Заметок пока нет — создайте первую.',
  'features.features.projects.components.projectnotestab.создать': 'Создать',
  'features.features.projects.components.projectnotestab.текст': 'Текст',
  'features.features.projects.components.projectmeetingstab.встречи_проекта':
    'Встречи проекта: {p0}',
  'features.features.projects.components.projectmeetingstab.новая_встреча': 'Новая встреча',
  'features.features.projects.components.projectmeetingstab.встреч_нет':
    'Встреч пока нет — назначьте первую.',
  'features.features.projects.components.projectmeetingstab.запланирована': 'Запланирована',
  'features.features.projects.components.projectmeetingstab.завершена': 'Завершена',
  'features.features.projects.components.projectmeetingstab.отменена': 'Отменена',
  'imports.title': 'Импорт / Экспорт Excel',
  'imports.error_title': 'Не удалось выполнить импорт',
  'imports.entity': 'Сущность:',
  'imports.upload_hint': 'Перетащите xlsx сюда или нажмите для выбора',
  'imports.back': 'Назад',
  'imports.column_mapping': 'Сопоставление колонок',
  'imports.skip_column': '— пропустить —',
  'imports.result': 'Результат импорта',
  'imports.export': 'Экспорт',
  'imports.subtitle':
    'Загрузите xlsx (до 10MB), сопоставьте колонки и запустите импорт. Экспорт — до 1000 строк.',
  'imports.step_upload': 'Загрузка',
  'imports.step_preview': 'Превью',
  'imports.step_mapping': 'Маппинг',
  'imports.step_result': 'Результат',
  'imports.upload_and_preview': 'Загрузить и показать превью',
  'imports.next_to_mapping': 'Далее к маппингу',
  'imports.mapping_hint':
    'Выберите, какое поле сущности соответствует каждой колонке Excel. Пусто — колонка пропускается.',
  'imports.save_mapping': 'Сохранить маппинг',
  'imports.run_import': 'Запустить импорт',
  'imports.created': 'Создано:',
  'imports.skipped': 'Пропущено (дубли):',
  'imports.errors': 'Ошибок:',
  'imports.col_row': 'Строка',
  'imports.col_error': 'Ошибка',
  'imports.new_import': 'Новый импорт',
  'imports.export_contacts': 'Экспорт контактов',
  'imports.export_companies': 'Экспорт компаний',
  'imports.export_deals': 'Экспорт сделок',
  'imports.entity.contacts': 'Контакты',
  'imports.entity.companies': 'Компании',
  'imports.entity.deals': 'Сделки',
  'imports.field.firstName': 'Имя',
  'imports.field.lastName': 'Фамилия',
  'imports.field.email': 'Email',
  'imports.field.phone': 'Телефон',
  'imports.field.company': 'Компания',
  'imports.field.role': 'Должность',
  'imports.field.tags_comma': 'Теги (через запятую)',
  'imports.field.notes': 'Заметки',
  'imports.field.name': 'Название',
  'imports.field.domain': 'Домен',
  'imports.field.industry': 'Отрасль',
  'imports.field.website': 'Сайт',
  'imports.field.description': 'Описание',
  'imports.field.tags': 'Теги',
  'imports.field.title': 'Название',
  'imports.field.amount': 'Сумма',
  'imports.field.stage': 'Стадия',
  'imports.field.currency': 'Валюта',
  'snippets.open': 'Открыть',
  'snippets.deal_risk.loss_risk': 'Риск потери:',
  'snippets.entity_feed.row_hint': 'Нажмите на строку для деталей',
  'snippets.email_draft.subject_prefix': 'Тема',
  'chat.meeting_fallback': 'Встреча',
  'chat.task_fallback': 'Задача',
  // deal_risk: deterministic engine signals (machine code + params) and
  // recommendations, localized in the snippets with the engine text as fallback.
  'chat.deal_risk.days_unit': {
    one: 'день',
    few: 'дня',
    many: 'дней',
    other: 'дней',
  },
  'chat.deal_risk.signal.missing_next_activity': 'Следующее действие по сделке не запланировано.',
  'chat.deal_risk.signal.overdue_next_activity': {
    one: 'Следующее действие просрочено на {days} день.',
    few: 'Следующее действие просрочено на {days} дня.',
    many: 'Следующее действие просрочено на {days} дней.',
    other: 'Следующее действие просрочено на {days} дней.',
  },
  'chat.deal_risk.signal.stale_activity': {
    zero: 'По сделке ещё не зафиксирована активность.',
    one: 'Нет новой активности уже {days} день.',
    few: 'Нет новой активности уже {days} дня.',
    many: 'Нет новой активности уже {days} дней.',
    other: 'Нет новой активности уже {days} дней.',
  },
  'chat.deal_risk.signal.stage_age_over_norm':
    'Сделка на стадии «{stage}» дольше нормы: {days} {daysWord} при норме {norm} {normWord}.',
  'chat.deal_risk.signal.qualification_gaps':
    'Чек-лист закрытия сделки: {gaps} из {total} пунктов не подтверждены.',
  'chat.deal_risk.signal.overdue_task': 'Просрочена задача: {title}.',
  'chat.deal_risk.recommendation.follow_current_plan.title': 'Продолжать по текущему плану',
  'chat.deal_risk.recommendation.follow_current_plan.description':
    'Сейчас у сделки нет явных сигналов риска. Следующий шаг уже запланирован.',
  'chat.deal_risk.recommendation.prepare_followup_email.title': 'Подготовить follow-up письмо',
  'chat.deal_risk.recommendation.prepare_followup_email.description':
    'Коротко уточнить статус клиента, подтвердить интерес и предложить удобный следующий шаг. Письмо не будет отправлено без отдельного подтверждения.',
  'chat.deal_risk.recommendation.contact_client_no_email.title': 'Связаться с клиентом',
  'chat.deal_risk.recommendation.contact_client_no_email.description':
    'У контакта нет email для follow-up. Уточните удобный канал связи и зафиксируйте следующий шаг.',
  'chat.deal_risk.recommendation.closed_no_followup.title': 'Сделка уже закрыта',
  'chat.deal_risk.recommendation.closed_no_followup.description':
    'Для закрытой сделки follow-up по риску потери не требуется.',
  'artifacts.diagram_title': 'Диаграмма процесса',
  'artifacts.html_widget_title': 'Интерактивный HTML виджет',
  'artifacts.markdown_doc': 'Документ Markdown',
  'artifacts.action_plan': 'План действий',
  'artifacts.project_brief': 'Бриф проекта',
  'artifacts.meeting_summary': 'Сводка встречи',
  'artifacts.analytics_report': 'Аналитический отчёт',
  'artifacts.document_fallback': 'Документ',
  'notes.tpl_summary': '📋 **Резюме разговора:**\n- Обсудили: \n- Договорились: ',
  'notes.tpl_decision': '🎯 **Принятое решение:** ',
  'notes.tpl_task': '⚡ **Задача:** ',
  'notes.ai_extract_tasks_prompt': 'Из этой заметки сделай задачи:\n\n{body}',
  'copilot.hot_leads': 'Горячие лиды',
  'copilot.parse_error': 'Не удалось разобрать результат инструмента.',
  'copilot.no_leads': 'Лидов не найдено',
  'copilot.flag_off': 'AI-чат (PoC) выключен. Включите флаг',
  'copilot.flag_off_suffix': 'и перезапустите фронтенд.',
  'notes.templates': 'Шаблоны:',
  'settings.ai.system_prompt': 'Системный промпт',
  'settings.ai.system_prompt_append_placeholder':
    'Например: Всегда отвечай на русском, будь кратким, используй дружелюбный тон...',
  'settings.ai.system_prompt_override_placeholder':
    'Полная замена системного промпта — оставим пустым в 99% случаев',
  'settings.ai.model_and_tools': 'Модель и инструменты',
  'settings.ai.model': 'Модель',
  'settings.ai.allowed_tools': 'Разрешённые инструменты (enabledTools)',
  'settings.ai.allowed_tools_placeholder':
    'search_deals, create_task, mcp_notion_search ... (через запятую, пусто = все)',
  'settings.ai.skills': 'Скиллы',
  'settings.ai.saved': 'Сохранено — агент подхватит на следующем ходе',
  'settings.ai.delete_skill': 'Удалить скилл?',
  'settings.ai.skill_name_placeholder': 'Название скилла (например: beauty-architect)',
  'settings.ai.skill_description_placeholder': 'Описание (опционально)',
  'settings.ai.skill_instructions_placeholder': 'Инструкции — что делает скилл, как отвечает',
  'settings.ai.skill_triggers_placeholder':
    'Триггеры через запятую (например: бьюти, салон, запись)',
  'settings.ai.skill_tool_allowlist_placeholder':
    'toolAllowlist через запятую (например: search_deals, create_task)',
  'settings.ai.delete_mcp': 'Удалить MCP сервер?',
  'settings.ai.mcp_name_placeholder': 'Имя сервера (например: notion, figma, custom-api)',
  'settings.ai.mcp_headers_placeholder': 'headersRef — имя env переменной',
  'settings.ai.system_prompt_description':
    'Добавляется после ядра CRM_SYSTEM_PROMPT. Не может переопределить правила безопасности и approval-дисциплину. Override — полная замена (осторожно).',
  'settings.ai.append_label': 'Append (рекомендуется)',
  'settings.ai.override_label': 'Override (эксперт)',
  'settings.ai.allowed_tools_description':
    'Ограничивает реестр тулов до allowlist. MCP-инструменты — с префиксом mcp_.',
  'settings.ai.skills_description':
    'Скилл — именованный пакет инструкций. Активируется фразой «используй скилл X» или триггером. Если задан toolAllowlist — в этом ходе агент видит только эти тулзы.',
  'settings.ai.skills_empty': 'Скиллов пока нет — добавьте первый для демо «свой агент за 30 сек»',
  'settings.ai.triggers_prefix': 'триггеры:',
  'settings.ai.add_skill': 'Добавить скилл',
  'settings.ai.mcp_message': 'MCP — Model Context Protocol: внешние инструменты по http/sse',
  'settings.ai.mcp_description':
    'Имя → url/tools/list → discovery. Вызов mcp_{server}_{tool} идёт через approval (destructive). Секрет — через env + headersRef (имя переменной), не в JSON.',
  'settings.ai.mcp_empty': 'MCP-серверов пока нет',
  'settings.ai.add_mcp': 'Добавить MCP сервер',
  'settings.ai.save': 'Сохранить',

  // ─── Админ-панель платформы (P0: дашборд + пользователи) ──────────────────────
  'admin.dashboard.title': 'Админ-панель',
  'admin.dashboard.subtitle': 'Обзор платформы: аккаунты, активность, воркеры и очередь писем',
  'admin.dashboard.reload': 'Обновить',
  'admin.dashboard.period_label': 'Период LLM-затрат',
  'admin.dashboard.period_days': 'Последние {days} дней',
  'admin.dashboard.kpi_users': 'Пользователи',
  'admin.dashboard.kpi_users_24h': '+{count} за 24 часа',
  'admin.dashboard.kpi_workspaces': 'Воркспейсы',
  'admin.dashboard.kpi_deals': 'Сделки',
  'admin.dashboard.kpi_messages_24h': 'Сообщения (24ч)',
  'admin.dashboard.kpi_tokens_24h': '{count} токенов',
  'admin.dashboard.llm_spend_title': 'LLM-затраты',
  'admin.dashboard.llm_spend_period': 'за {days} дней · {messages} сообщений · {tokens} токенов',
  'admin.dashboard.workers_title': 'Воркеры',
  'admin.dashboard.load_error': 'Не удалось загрузить обзор платформы',

  'admin.workers.scenario_runner': 'Сценарный движок',
  'admin.workers.telegram_inbound': 'Telegram: входящие',
  'admin.workers.telegram_delivery': 'Telegram: доставка',
  'admin.workers.mail_outbox': 'Почтовая очередь',
  'admin.workers.external_calendar_sync': 'Синхронизация календарей',
  'admin.workers.status_healthy': 'работает',
  'admin.workers.status_degraded': 'деградация',
  'admin.workers.status_stopped': 'остановлен',
  'admin.workers.status_failed': 'упал',
  'admin.workers.status_starting': 'запускается',
  'admin.workers.ticks': 'тики',
  'admin.workers.completed': 'завершено',
  'admin.workers.errors': 'ошибки',
  'admin.workers.last_tick': 'последний тик',

  'admin.outbox.title': 'Почтовая очередь',
  'admin.outbox.empty': 'Очередь писем пуста',
  'admin.outbox.status_pending': 'в очереди',
  'admin.outbox.status_sending': 'отправляется',
  'admin.outbox.status_sent': 'отправлено',
  'admin.outbox.status_delivered': 'доставлено',
  'admin.outbox.status_failed': 'ошибка',
  'admin.outbox.status_bounced': 'возврат',
  'admin.outbox.status_spam_complaint': 'жалобы на спам',

  'admin.users.title': 'Пользователи',
  'admin.users.subtitle': '{visible} из {total} пользователей',
  'admin.users.reload': 'Обновить',
  'admin.users.search_label': 'Поиск пользователей по email или имени',
  'admin.users.search_placeholder': 'Поиск по email или имени…',
  'admin.users.status_filter_label': 'Фильтр по статусу',
  'admin.users.filter_all': 'Все',
  'admin.users.filter_verified': 'Подтверждённые',
  'admin.users.filter_unverified': 'Неподтверждённые',
  'admin.users.filter_blocked': 'Заблокированные',
  'admin.users.filter_admins': 'Админы платформы',
  'admin.users.col_email': 'EMAIL',
  'admin.users.col_name': 'ИМЯ',
  'admin.users.col_status': 'СТАТУС',
  'admin.users.col_verified': 'EMAIL ПОДТВЕРЖДЕН',
  'admin.users.col_blocked': 'ЗАБЛОКИРОВАН',
  'admin.users.col_platform_role': 'РОЛЬ',
  'admin.users.col_workspaces': 'ВОРКСПЕЙСЫ',
  'admin.users.col_created': 'СОЗДАН',
  'admin.users.col_last_activity': 'ПОСЛ. АКТИВНОСТЬ',
  'admin.users.col_actions': 'ДЕЙСТВИЯ',
  'admin.users.status_verified': 'подтверждён',
  'admin.users.status_unverified': 'не подтверждён',
  'admin.users.status_blocked': 'заблокирован',
  'admin.users.status_active': 'активен',
  'admin.users.role_admin': 'админ',
  'admin.users.role_user': 'пользователь',
  'admin.users.empty': 'Пользователей пока нет',
  'admin.users.empty_search': 'По этому запросу ничего не найдено',
  'admin.users.load_error': 'Не удалось загрузить пользователей',
  'admin.users.action_verify': 'Подтвердить email',
  'admin.users.confirm_verify': 'Отметить {email} как подтверждённый?',
  'admin.users.action_block': 'Заблокировать',
  'admin.users.confirm_block':
    'Заблокировать {email}? Активные сессии будут отозваны, вход в систему будет запрещён.',
  'admin.users.block_reason_label': 'Причина блокировки (необязательно)',
  'admin.users.block_reason_placeholder': 'Причина для аудита…',
  'admin.users.action_unblock': 'Разблокировать',
  'admin.users.confirm_unblock': 'Разблокировать пользователя и разрешить вход снова?',
  'admin.users.action_send_reset': 'Отправить сброс пароля',
  'admin.users.confirm_send_reset': 'Письмо для сброса пароля уйдёт на {email}.',
  'admin.users.action_promote': 'Выдать админа',
  'admin.users.confirm_promote': 'Выдать этому пользователю права админа платформы?',
  'admin.users.action_demote': 'Снять админа',
  'admin.users.confirm_demote': 'Отозвать у этого пользователя права админа платформы?',
  'admin.users.detail_title': 'Детали пользователя',
  'admin.users.detail_empty': 'Выберите пользователя, чтобы увидеть детали',
  'admin.users.detail_memberships': 'Членства в воркспейсах',
  'admin.users.detail_no_memberships': 'Нет членств в воркспейсах',
  'admin.users.detail_sessions': 'Активные сессии',
  'admin.users.detail_no_sessions': 'Нет активных сессий',
  'admin.users.session_device': 'Устройство',
  'admin.users.session_unknown_device': 'Неизвестное устройство',
  'admin.users.session_ip': 'IP',
  'admin.users.session_last_used': 'Использована',
  'admin.users.session_expires': 'Истекает',

  // ─── Админ-панель платформы (P1: воркспейсы) ─────────────────────────────────
  'admin.workspaces.title': 'Воркспейсы',
  'admin.workspaces.subtitle': '{visible} из {total} воркспейсов',
  'admin.workspaces.reload': 'Обновить',
  'admin.workspaces.search_label': 'Поиск воркспейсов по названию или slug',
  'admin.workspaces.search_placeholder': 'Поиск по названию или slug…',
  'admin.workspaces.col_name': 'НАЗВАНИЕ',
  'admin.workspaces.col_owner': 'ВЛАДЕЛЕЦ',
  'admin.workspaces.col_members': 'УЧАСТНИКИ',
  'admin.workspaces.col_deals': 'СДЕЛКИ',
  'admin.workspaces.col_spend': 'LLM-ЗАТРАТЫ',
  'admin.workspaces.col_kind': 'ТИП',
  'admin.workspaces.col_status': 'СТАТУС',
  'admin.workspaces.col_created': 'СОЗДАН',
  'admin.workspaces.col_member_user': 'УЧАСТНИК',
  'admin.workspaces.col_member_role': 'РОЛЬ',
  'admin.workspaces.col_member_status': 'СТАТУС',
  'admin.workspaces.col_member_joined': 'ВСТУПИЛ',
  'admin.workspaces.kind_business': 'бизнес',
  'admin.workspaces.kind_personal': 'личный',
  'admin.workspaces.status_active': 'активен',
  'admin.workspaces.status_blocked': 'заблокирован',
  'admin.workspaces.empty': 'Воркспейсов пока нет',
  'admin.workspaces.empty_search': 'По этому запросу ничего не найдено',
  'admin.workspaces.load_error': 'Не удалось загрузить воркспейсы',
  'admin.workspaces.detail_empty': 'Выберите воркспейс, чтобы увидеть детали',
  'admin.workspaces.detail_plan': 'План',
  'admin.workspaces.detail_timezone': 'Часовой пояс',
  'admin.workspaces.detail_created': 'Создан',
  'admin.workspaces.detail_members': 'Участники',
  'admin.workspaces.detail_no_members': 'Нет участников',
  'admin.workspaces.detail_spend': 'LLM-затраты',
  'admin.workspaces.counter_deals': 'Сделки',
  'admin.workspaces.counter_contacts': 'Контакты',
  'admin.workspaces.counter_tasks': 'Задачи',
  'admin.workspaces.counter_messages': 'Сообщения',
  'admin.workspaces.counter_active_members': 'Активные',
  'admin.workspaces.action_block': 'Заблокировать',
  'admin.workspaces.confirm_block':
    'Заблокировать «{name}»? Участники потеряют доступ, фоновые задачи будут остановлены. Данные сохранятся.',
  'admin.workspaces.block_reason_label': 'Причина блокировки (необязательно)',
  'admin.workspaces.block_reason_placeholder': 'Причина для аудита…',
  'admin.workspaces.action_unblock': 'Разблокировать',
  'admin.workspaces.confirm_unblock':
    'Разблокировать воркспейс? Участники снова получат доступ, воркеры продолжат работу.',
  'admin.workspaces.detail_plan_limits': '{tokens} токенов/мес · {storage}',

  // ─── Админ-панель платформы (P0: тарифы) ─────────────────────────────────────
  'admin.plans.title': 'Тарифы',
  'admin.plans.subtitle': 'Всего тарифов: {total}',
  'admin.plans.reload': 'Обновить',
  'admin.plans.create': 'Добавить тариф',
  'admin.plans.col_plan': 'ТАРИФ',
  'admin.plans.col_price': 'ЦЕНА',
  'admin.plans.col_cost': 'СЕБЕСТОИМОСТЬ',
  'admin.plans.col_tokens': 'ТОКЕНЫ/МЕС',
  'admin.plans.col_storage': 'ХРАНИЛИЩЕ',
  'admin.plans.col_period': 'ПЕРИОД',
  'admin.plans.col_order': 'ПОРЯДОК',
  'admin.plans.col_status': 'СТАТУС',
  'admin.plans.col_actions': 'ДЕЙСТВИЯ',
  'admin.plans.tokens_tooltip': 'Лимит токенов LLM в месяц',
  'admin.plans.period_monthly': 'ежемесячно',
  'admin.plans.status_active': 'активен',
  'admin.plans.status_inactive': 'отключён',
  'admin.plans.empty': 'Тарифов пока нет',
  'admin.plans.load_error': 'Не удалось загрузить тарифы',
  'admin.plans.action_edit': 'Редактировать тариф «{name}»',
  'admin.plans.action_edit_short': 'Изменить',
  'admin.plans.action_deactivate': 'Отключить',
  'admin.plans.action_deactivate_short': 'Отключить',
  'admin.plans.confirm_deactivate':
    'Отключить тариф «{name}»? Действующие воркспейсы сохранят его, строку можно включить снова.',
  'admin.plans.action_activate': 'Включить',
  'admin.plans.deactivated': 'Тариф отключён',
  'admin.plans.activated': 'Тариф включён',
  'admin.plans.saved': 'Тариф сохранён',
  'admin.plans.created': 'Тариф создан',
  'admin.plans.create_title': 'Новый тариф',
  'admin.plans.edit_title': 'Редактирование тарифа',
  'admin.plans.save': 'Сохранить',
  'admin.plans.field_code': 'Код',
  'admin.plans.code_hint': 'Строчные латинские буквы, цифры и дефис; не меняется после создания',
  'admin.plans.code_locked_hint': 'Код неизменяем — на него ссылаются воркспейсы',
  'admin.plans.code_required': 'Введите код тарифа',
  'admin.plans.code_pattern': 'Только строчные латинские буквы, цифры и дефис',
  'admin.plans.field_name': 'Название',
  'admin.plans.name_placeholder': 'Pro',
  'admin.plans.name_required': 'Введите название',
  'admin.plans.field_price': 'Цена, $/мес',
  'admin.plans.field_cost': 'Себестоимость, $/мес',
  'admin.plans.field_tokens': 'Лимит токенов в месяц',
  'admin.plans.field_storage': 'Хранилище',
  'admin.plans.storage_unit': 'ГБ',
  'admin.plans.field_order': 'Порядок сортировки',
  'admin.plans.field_required': 'Заполните поле',
  'admin.plans.error_code_exists': 'Тариф с таким кодом уже существует',
  'admin.plans.error_save_failed': 'Не удалось сохранить тариф',

  // ─── Админ-панель платформы (P1: LLM-мониторинг) ─────────────────────────────
  'admin.llm.title': 'LLM-затраты',
  'admin.llm.subtitle': 'Период: {from} — {to}',
  'admin.llm.reload': 'Обновить',
  'admin.llm.period_label': 'Период LLM-затрат',
  'admin.llm.period_days': 'Последние {days} дней',
  'admin.llm.period_custom': 'Произвольный',
  'admin.llm.range_label': 'Диапазон дат',
  'admin.llm.kpi_spend': 'Затраты за период',
  'admin.llm.kpi_tokens': 'Токены',
  'admin.llm.kpi_messages': 'Сообщения',
  'admin.llm.tab_by_workspace': 'По воркспейсам',
  'admin.llm.tab_by_profile': 'По профилям',
  'admin.llm.tab_top_conversations': 'Топ разговоров',
  'admin.llm.col_workspace': 'ВОРКСПЕЙС',
  'admin.llm.col_profile': 'ПРОФИЛЬ',
  'admin.llm.col_conversations': 'РАЗГОВОРЫ',
  'admin.llm.col_messages': 'СООБЩЕНИЯ',
  'admin.llm.col_tokens': 'ТОКЕНЫ',
  'admin.llm.col_cost': 'ЗАТРАТЫ',
  'admin.llm.col_conversation': 'РАЗГОВОР',
  'admin.llm.col_user': 'ПОЛЬЗОВАТЕЛЬ',
  'admin.llm.col_last_message': 'ПОСЛ. СООБЩЕНИЕ',
  'admin.llm.unassigned': 'без воркспейса',
  'admin.llm.unassigned_hint': 'Сообщения, записанные до привязки к воркспейсам',
  'admin.llm.untitled': 'Без названия',
  'admin.llm.empty': 'За выбранный период данных нет',
  'admin.llm.load_error': 'Не удалось загрузить LLM-агрегации',
  'admin.llm.profile.neuraldeep': 'neuraldeep',
  'admin.llm.profile.openrouter': 'openrouter',
  'admin.llm.profile.govard': 'govard',
  'admin.llm.profile.opencode': 'opencode',

  // ─── Админ-панель платформы (P2: почта и аудит) ──────────────────────────────
  'admin.common.period_label': 'Период',
  'admin.common.period_all': 'Всё время',
  'admin.common.period_24h': '24 часа',
  'admin.common.period_7d': '7 дней',
  'admin.common.period_30d': '30 дней',

  'admin.mail.title': 'Почтовая очередь',
  'admin.mail.subtitle': '{visible} из {total} писем',
  'admin.mail.reload': 'Обновить',
  'admin.mail.load_error': 'Не удалось загрузить очередь писем',
  'admin.mail.search_label': 'Поиск писем по email или теме',
  'admin.mail.search_placeholder': 'Поиск по email или теме…',
  'admin.mail.status_filter_label': 'Фильтр по статусу',
  'admin.mail.kind_filter_label': 'Фильтр по типу',
  'admin.mail.filter_all': 'Все',
  'admin.mail.empty': 'Писем пока нет',
  'admin.mail.empty_search': 'По этому запросу ничего не найдено',
  'admin.mail.col_subject': 'ТЕМА',
  'admin.mail.col_to': 'ПОЛУЧАТЕЛЬ',
  'admin.mail.col_kind': 'ТИП',
  'admin.mail.col_status': 'СТАТУС',
  'admin.mail.col_attempts': 'ПОПЫТКИ',
  'admin.mail.col_available_at': 'ДОСТУПНО С',
  'admin.mail.col_last_error': 'ПОСЛ. ОШИБКА',
  'admin.mail.col_sent_at': 'ОТПРАВЛЕНО',
  'admin.mail.col_actions': 'ДЕЙСТВИЯ',
  'admin.mail.kind.meeting_invited': 'Приглашение на встречу',
  'admin.mail.kind.meeting_updated': 'Обновление встречи',
  'admin.mail.kind.meeting_cancelled': 'Отмена встречи',
  'admin.mail.kind.workspace_invited': 'Приглашение в воркспейс',
  'admin.mail.kind.password_reset': 'Сброс пароля',
  'admin.mail.kind.email_verification': 'Подтверждение email',
  'admin.mail.kind.agent_email': 'Письмо агента',
  'admin.mail.detail_title': 'Детали письма',
  'admin.mail.detail_empty': 'Выберите письмо, чтобы увидеть детали',
  'admin.mail.detail_to': 'Получатель',
  'admin.mail.detail_workspace': 'Воркспейс',
  'admin.mail.detail_kind': 'Тип',
  'admin.mail.detail_status': 'Статус',
  'admin.mail.detail_attempts': 'Попытки',
  'admin.mail.detail_available_at': 'Доступно с',
  'admin.mail.detail_last_error': 'Последняя ошибка',
  'admin.mail.detail_sent_at': 'Отправлено',
  'admin.mail.detail_delivered_at': 'Доставлено',
  'admin.mail.detail_provider_id': 'ID у провайдера',
  'admin.mail.detail_dedupe_key': 'Ключ дедупликации',
  'admin.mail.detail_created_at': 'Создано',
  'admin.mail.detail_updated_at': 'Обновлено',
  'admin.mail.retry': 'Повторить',
  'admin.mail.retry_confirm': 'Поставить письмо в очередь на повторную отправку?',
  'admin.mail.retry_queued': 'Письмо снова в очереди',
  'admin.mail.retry_invalid_status':
    'Повторная отправка доступна только для писем с ошибкой доставки',

  'admin.audit.title': 'Журнал аудита',
  'admin.audit.subtitle': '{visible} из {total} записей',
  'admin.audit.reload': 'Обновить',
  'admin.audit.load_error': 'Не удалось загрузить журнал аудита',
  'admin.audit.action_filter_label': 'Фильтр по действию',
  'admin.audit.filter_all': 'Все',
  'admin.audit.empty': 'Записей пока нет',
  'admin.audit.empty_search': 'По этому запросу ничего не найдено',
  'admin.audit.col_time': 'ВРЕМЯ',
  'admin.audit.col_actor': 'ИНИЦИАТОР',
  'admin.audit.col_action': 'ДЕЙСТВИЕ',
  'admin.audit.col_target': 'ОБЪЕКТ',
  'admin.audit.col_metadata': 'МЕТАДАННЫЕ',
  'admin.audit.action.user_verify': 'Подтверждение email',
  'admin.audit.action.user_block': 'Блокировка пользователя',
  'admin.audit.action.user_unblock': 'Разблокировка пользователя',
  'admin.audit.action.user_send_reset': 'Отправка сброса пароля',
  'admin.audit.action.user_platform_role': 'Изменение роли платформы',
  'admin.audit.action.workspace_block': 'Блокировка воркспейса',
  'admin.audit.action.workspace_unblock': 'Разблокировка воркспейса',
  'admin.audit.action.mail_retry': 'Повторная отправка письма',
  'admin.audit.action.plan_config_create': 'Создание тарифа',
  'admin.audit.action.plan_config_update': 'Изменение тарифа',
  'admin.audit.action.plan_config_deactivate': 'Отключение тарифа',

  'admin.errors.action_failed': 'Действие не выполнено. Попробуйте ещё раз.',
  'admin.errors.last_admin_demote': 'Нельзя понизить последнего админа платформы.',
  'admin.errors.not_platform_admin': 'Требуются права админа платформы.',
};
